import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  compareTo3ankvs086tmwq as compareTo,
  coerceIn10f36k81le1mm as coerceIn,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  toString1pkumu07cwy4m as toString,
  StringBuildermazzzhj6kkai as StringBuilder,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  Enum3alwj03lh1n41 as Enum,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  constructCallableReference23y65rf941mch as constructCallableReference,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  protoOf180f3jzyo7rfj as protoOf,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  lazy2hsh8ze7j6ikd as lazy,
  contentEquals5p44wfjhu6ta as contentEquals,
  contentHashCodem24x0wy7gjt7 as contentHashCode,
  contentToString28hodxfcotn0 as contentToString,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  until1jbpn0z3f8lbg as until,
  createThis2j2avj17cvnv2 as createThis,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  hashCodeq5arwsb9dgti as hashCode,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  binarySearchyyczvdessj07 as binarySearch,
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
  getOrNull1go7ef9ldk0df as getOrNull,
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfvhqybd2zx248 as listOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  listOf1jh22dvmctj1r as listOf_0,
  last3s1sh0kl8j0vf as last_0,
  joinToString1cxrrlmo0chqs as joinToString,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  plus310ted5e4i90h as plus,
  distinct10qe1scfdvu5k as distinct,
  toIntArray2d4xwvtjb01mq as toIntArray,
  sortedArray2m4d4tn4pbwoi as sortedArray,
  toList383f556t1dixk as toList,
  Paire9pteg33gng7 as Pair,
  step18s9qzr5xwxat as step,
  get_sign1dnxi33u9vk0c as get_sign,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  numberToDouble210hrknaofnhf as numberToDouble,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trimEnd17pt8cbotbalj as trimEnd,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  toString30pk9tzaqopn as toString_0,
  Comparable198qfk8pnblz0 as Comparable,
  KProperty02ce7r476m8633 as KProperty0,
  enumEntries20mr21zbe3az4 as enumEntries,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  LazyThreadSafetyMode_PUBLICATION_getInstance20ynwq7b0awd8 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  IntArrayList3liuagbdnwmna as IntArrayList,
  _BSearchResult___init__impl__em6zamjg3fd7w2ehe9 as _BSearchResult___init__impl__em6zam,
  _BSearchResult___get_found__impl__om04iz3bhk3bxb307hs as _BSearchResult___get_found__impl__om04iz,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  PointArrayList281mrsgyr6ua1 as PointArrayList,
  getCyclic28wvgqye98jqx as getCyclic,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  sort23bpsawysis6n as sort,
  pointArrayListOf7rbgdbqf3x4b as pointArrayListOf,
  pointArrayListOf2s9je3njyg83l as pointArrayListOf_0,
  pointArrayListOf36sb9r6prgwk4 as pointArrayListOf_1,
  getCyclic18d9063nmuul as getCyclic_0,
  binarySearch1lxbagta5e4q4 as binarySearch_0,
  _BSearchResult___get_index__impl__b5kraz22sor0j4icoq6 as _BSearchResult___get_index__impl__b5kraz,
  _BSearchResult___get_nearIndex__impl__s8nq4314o583ijf6vjx as _BSearchResult___get_nearIndex__impl__s8nq43,
  swap3upf401qn4fc8 as swap,
  rotateRight96vk8nw2c6nx as rotateRight,
  SortOps3rp25tm4jbjru as SortOps,
  genericSort3vhmyxbppxo3h as genericSort,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  get_size3oaoh8cpamcqc as get_size,
  Pool1zbsw0zhvh8ca as Pool,
  PointIntArrayList1s7gare9hr1oh as PointIntArrayList,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstance1mhteccb9s8gp as Companion_getInstance,
  Companion_getInstance1a9vx2vzoy0c2 as Companion_getInstance_0,
  _Angle___init__impl__g23q1m2b2a3p1lcfecp as _Angle___init__impl__g23q1m,
  adjustFromUp1ak85cceintt4 as adjustFromUp,
  Angle__minus_impl_xeau7k1xg6mt6atsc3s as Angle__minus_impl_xeau7k,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__plus_impl_26v37k2azilpxrtd5b2 as Angle__plus_impl_26v37k,
  _Angle___get_absoluteValue__impl__4qoakv1xrpqzvux2rki as _Angle___get_absoluteValue__impl__4qoakv,
  Angle__umod_impl_4wilf73sd8kyo0hgy9w as Angle__umod_impl_4wilf7,
  Angle__compareTo_impl_a0hfds27mzezsqxd8iz as Angle__compareTo_impl_a0hfds,
  _Angle___get_ratio__impl__ap3on4xjct7npipfzx as _Angle___get_ratio__impl__ap3on4,
  interpolatewhd2sgxffql5 as interpolate,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__cosine_impl_bgvzun30j3tzbj9negy as Angle__cosine_impl_bgvzun,
  Angle__sine_impl_3l11xv107tog2g378xw as Angle__sine_impl_3l11xv,
  interpolateAngleDenormalized1hkwzk523mo1c as interpolateAngleDenormalized,
  Companion_getInstance45f4wj6tp63r as Companion_getInstance_1,
  transformY3ktoxhxwkzwk1 as transformY,
  transformX33nszy4vzqsfy as transformX,
  Companion_getInstancepzu5ca8urjqj as Companion_getInstance_2,
  Line2D2pf35pcx71ncp as Line2D,
  Angle2itorpob18n08 as Angle,
  outerCircle30hn5vvbpz9gu as outerCircle,
  Angle__times_impl_v3s9y23mibtgzdmjehg as Angle__times_impl_v3s9y2,
  _Angle___get_normalized__impl__9s30ys29omek7j37ko1 as _Angle___get_normalized__impl__9s30ys,
  _Angle___get_radians__impl__n00yt5vm4zpqngpunw as _Angle___get_radians__impl__n00yt5,
  Angle__times_impl_v3s9y23l6wmhpsc1jdf as Angle__times_impl_v3s9y2_0,
  Angle__div_impl_ut2btd3g8dzjqxtz8vj as Angle__div_impl_ut2btd,
  _Angle___get_cosine__impl__vprvmu2q6djrsmzk9ju as _Angle___get_cosine__impl__vprvmu,
  _Angle___get_sine__impl__15nmyi49dr4tf51lji as _Angle___get_sine__impl__15nmyi,
  _Angle___get_tangent__impl__vushdy26wugwjs1otqt as _Angle___get_tangent__impl__vushdy,
  Size2Dum5ayuyhhau7 as Size2D,
  Rectangle3q03woyn9k8x1 as Rectangle,
  Companion_getInstance3cokvjrertd3u as Companion_getInstance_3,
  BoundsBuilder__plus_impl_cz7f7xgidk87zsybva as BoundsBuilder__plus_impl_cz7f7x,
  Companion_getInstance11dw08y48m2m0 as Companion_getInstance_4,
  _BoundsBuilder___get_bounds__impl__s1l1gxzjc7xpskx0n0 as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Vector2I2k5512l4eeahb as Vector2I,
  toIntu0rc68akxu7a as toInt,
  Angle__unaryPlus_impl_eyi5pl35tfk7sxjoioj as Angle__unaryPlus_impl_eyi5pl,
  Angle__unaryMinus_impl_7901fr16exly0rraiwq as Angle__unaryMinus_impl_7901fr,
  BoundsBuilder162uwsje56mvu as BoundsBuilder,
  BoundsBuilder__plus_impl_cz7f7x16kulpov94zla as BoundsBuilder__plus_impl_cz7f7x_0,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance1ath7o4bn4ut as Companion_getInstance_5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstancevp821koktwyg as Companion_getInstance_6,
  _Ratio___get_absoluteValue__impl__92ozif26vimnm8eslr7 as _Ratio___get_absoluteValue__impl__92ozif,
  Ratio__times_impl_ucdh7y3ofskh6zksge6 as Ratio__times_impl_ucdh7y,
  toRatioClampedeq87m2alw3kr as toRatioClamped,
  toRatioa3v13oich5q as toRatio,
  toRatio1hooqit5gulhr as toRatio_0,
  Ratio136tf4z2t0p2d as Ratio,
  clamp1qclpmpfxm7xb as clamp,
  convertRange139vj18oahy2c as convertRange,
  Ratio__minus_impl_s1uwyg230wh21dxh91x as Ratio__minus_impl_s1uwyg,
  Ratio__toDouble_impl_o7epzewvz4wcchi2m as Ratio__toDouble_impl_o7epze,
  Ratio__times_impl_ucdh7y950x9mhigsbq as Ratio__times_impl_ucdh7y_0,
  _Ratio___get_value__impl__57cli62yq1wlg55nngd as _Ratio___get_value__impl__57cli6,
  normalizeZero2ksfd6bzt4qwz as normalizeZero,
  _Ratio___init__impl__9mwvn21qwyi4zg9z4fu as _Ratio___init__impl__9mwvn2,
  isAlmostEquals18m8qk24p7w0q as isAlmostEquals,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals_0,
  isAlmostEquals$default1fay4lgiuix8d as isAlmostEquals$default,
  Ratio__toString_impl_mfgt3e3j0h64ug0009v as Ratio__toString_impl_mfgt3e,
  Ratio__hashCode_impl_quhc2vwuaml6l5qpjf as Ratio__hashCode_impl_quhc2v,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  isAlmostZero7baqs51et9hm as isAlmostZero,
  Ratio__compareTo_impl_z2ienc31uw6ixghmhkm as Ratio__compareTo_impl_z2ienc,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  convertRange1a6ancvyn151r as convertRange_0,
  interpolate2g7wzskc23f1q as interpolate_0,
  interpolate35pbs3ac913y4 as interpolate_1,
  _Ratio___init__impl__9mwvn23v7lk04jh8pl2 as _Ratio___init__impl__9mwvn2_0,
  umod164hvijxhfi8p as umod,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  insert2fz5125p2hdyd as insert_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  clamp31lhm66c28ic8 as clamp_0,
  Companion_getInstance2q13golofn64 as Companion_getInstance_7,
  invoke3idfsdzzpzmqq as invoke,
  invoke1y68e7g1lbvl5 as invoke_0,
  Easing3266vfl8a4o75 as Easing,
  toRatiolga1a9coidva as toRatio_1,
  clampdicp8njiht45 as clamp_1,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  hasExtra1969mplo13qgb as hasExtra,
  Property1m5vulkepgwzd as Property,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class IntSegmentSet {
  constructor() {
    this.fab_1 = IntArrayList.za1(16);
    this.gab_1 = IntArrayList.za1(16);
  }
  s2() {
    return this.fab_1.s2();
  }
  n1() {
    return this.s2() === 0;
  }
  o9j() {
    return this.s2() > 0;
  }
  sh() {
    // Inline function 'kotlin.apply' call
    this.fab_1.a5();
    this.gab_1.a5();
    return this;
  }
  hab() {
    return this.o9j() ? this.fab_1.j9u(0) : 0;
  }
  iab() {
    return this.o9j() ? this.gab_1.j9u(this.gab_1.s2() - 1 | 0) : 0;
  }
  jab(x) {
    var tmp2 = this.s2();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = tmp2 - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        var min = this.fab_1.j9u(mid);
        var max = this.gab_1.j9u(mid);
        var mval = x < min ? 1 : x > max ? -1 : 0;
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$0 = mid;
          break $l$block;
        }
      }
      tmp$ret$0 = (-low | 0) - 1 | 0;
    }
    return _BSearchResult___init__impl__em6zam(tmp$ret$0);
  }
  kab(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchLeft' call
    var tmp2 = this.s2();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = tmp2 - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        var mval = compareTo(this.fab_1.j9u(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      var tmp4 = low;
      // Inline function 'kotlin.math.min' call
      var b = high;
      var tmp$ret$4 = Math.min(tmp4, b);
      tmp$ret$1 = coerceIn(tmp$ret$4, 0, tmp2 - 1 | 0);
    }
    var tmp$ret$0 = tmp$ret$1;
    return coerceIn(tmp$ret$0, 0, this.s2() - 1 | 0);
  }
  lab(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchRight' call
    var tmp2 = this.s2();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = tmp2 - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        var mval = compareTo(this.gab_1.j9u(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      var tmp4 = low;
      // Inline function 'kotlin.math.max' call
      var b = high;
      var tmp$ret$4 = Math.max(tmp4, b);
      tmp$ret$1 = coerceIn(tmp$ret$4, 0, tmp2 - 1 | 0);
    }
    var tmp$ret$0 = tmp$ret$1;
    return coerceIn(tmp$ret$0, 0, this.s2() - 1 | 0);
  }
  dab(min, max) {
    // Inline function 'kotlin.apply' call
    $l$block_0: {
      // Inline function 'kotlin.check' call
      if (!(min <= max)) {
        throw IllegalStateException.o('Check failed.');
      }
      if (this.n1()) {
        insertAt(this, this.s2(), min, max);
      } else if (min === this.iab()) {
        this.gab_1.s7x(this.gab_1.s2() - 1 | 0, max);
      } else if (max === this.hab()) {
        this.fab_1.s7x(0, min);
      } else {
        var removeStart = -1;
        var removeCount = -1;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (this.n1()) {
            break $l$block;
          }
          var nmin = this.kab(min);
          var nmax = this.lab(max);
          var inductionVariable = nmin;
          if (inductionVariable <= nmax)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0 = n;
              var tmp2 = this.fab_1.j9u(n);
              var x2 = this.gab_1.j9u(n);
              if (this.mab(tmp2, x2, min, max)) {
                if (removeStart === -1)
                  removeStart = tmp0;
                var tmp = removeStart;
                var tmp0_0 = this.fab_1.j9u(removeStart);
                // Inline function 'kotlin.math.min' call
                // Inline function 'kotlin.math.min' call
                var b = Math.min(tmp2, min);
                var tmp$ret$6 = Math.min(tmp0_0, b);
                this.fab_1.s7x(tmp, tmp$ret$6);
                var tmp_0 = removeStart;
                var tmp0_1 = this.gab_1.j9u(removeStart);
                // Inline function 'kotlin.math.max' call
                // Inline function 'kotlin.math.max' call
                var b_0 = Math.max(x2, max);
                var tmp$ret$8 = Math.max(tmp0_1, b_0);
                this.gab_1.s7x(tmp_0, tmp$ret$8);
                removeCount = removeCount + 1 | 0;
              }
            }
             while (!(n === nmax));
        }
        if (removeCount !== 0)
          if (removeCount > 0) {
            removeAt(this, removeStart + 1 | 0, removeCount);
          } else if (max < this.hab()) {
            insertAt(this, 0, min, max);
          } else if (min > this.iab()) {
            insertAt(this, this.s2(), min, max);
          } else {
            var inductionVariable_0 = coerceAtLeast(this.kab(min), 1);
            var last = this.lab(max);
            if (inductionVariable_0 <= last)
              do {
                var m = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var prevMax = this.gab_1.j9u(m - 1 | 0);
                var currMin = this.fab_1.j9u(m);
                if (min > prevMax && max < currMin) {
                  insertAt(this, m, min, max);
                  break $l$block_0;
                }
              }
               while (!(m === last));
            // Inline function 'kotlin.error' call
            var message = 'Unexpected';
            throw IllegalStateException.o(toString(message));
          }
      }
    }
    return this;
  }
  as(v) {
    return _BSearchResult___get_found__impl__om04iz(this.jab(v));
  }
  nab(a, b) {
    // Inline function 'kotlin.apply' call
    var aSmaller = a.s2() < b.s2();
    var av = aSmaller ? a : b;
    var bv = aSmaller ? b : a;
    // Inline function 'kotlin.also' call
    this.sh();
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = av.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2 = av.fab_1.j9u(n);
        // Inline function 'korlibs.math.segment.IntSegmentSet.intersection' call
        var max = av.gab_1.j9u(n);
        var count = 0;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (bv.n1()) {
            break $l$block;
          }
          var nmin = bv.kab(tmp2);
          var nmax = bv.lab(max);
          var inductionVariable_0 = nmin;
          if (inductionVariable_0 <= nmax)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp2_0 = bv.fab_1.j9u(n_0);
              var x2 = bv.gab_1.j9u(n_0);
              if (bv.mab(tmp2_0, x2, tmp2, max)) {
                // Inline function 'kotlin.math.max' call
                var tmp0 = Math.max(tmp2_0, tmp2);
                // Inline function 'kotlin.math.min' call
                var max_0 = Math.min(x2, max);
                this.dab(tmp0, max_0);
                count = count + 1 | 0;
              }
            }
             while (!(n_0 === nmax));
        }
      }
       while (inductionVariable < last);
    return this;
  }
  mab(x1, x2, y1, y2) {
    return x2 >= y1 && y2 >= x1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('[');
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2 = this.fab_1.j9u(n);
        var max = this.gab_1.j9u(n);
        var first = n === 0;
        if (!first) {
          this_0.m1(', ');
        }
        this_0.m1('' + tmp2 + '-' + max);
      }
       while (inductionVariable < last);
    this_0.m1(']');
    return this_0.toString();
  }
}
class StrokePointsMode extends Enum {}
class StrokePointsBuilder {
  constructor(width, mode, generateDebug) {
    mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
    generateDebug = generateDebug === VOID ? false : generateDebug;
    this.yab_1 = width;
    this.zab_1 = mode;
    this.aac_1 = generateDebug;
    this.bac_1 = 20;
    var tmp = this;
    var tmp_0;
    switch (this.zab_1.w1_1) {
      case 0:
        tmp_0 = 6;
        break;
      case 1:
        tmp_0 = 2;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.cac_1 = new DoubleVectorArrayList(tmp_0);
    this.dac_1 = new PointArrayList();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.eac_1 = ArrayList.p2();
  }
  gac() {
    return this.cac_1;
  }
  toString() {
    return 'StrokePointsBuilder(' + this.yab_1 + ', ' + this.cac_1.toString() + ')';
  }
  hac(pos, normal, width, maxWidth) {
    switch (this.zab_1.w1_1) {
      case 0:
        // Inline function 'kotlin.math.absoluteValue' call

        var tmp$ret$0 = Math.abs(maxWidth);
        this.cac_1.oa3(pos.r9g_1, pos.s9g_1, normal.r9g_1, normal.s9g_1, width, tmp$ret$0);
        break;
      case 1:
        this.cac_1.ma3(pos.r9g_1 + normal.r9g_1 * width, pos.s9g_1 + normal.s9g_1 * width);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  iac(pos, normal, width, maxWidth, $super) {
    maxWidth = maxWidth === VOID ? width : maxWidth;
    var tmp;
    if ($super === VOID) {
      this.hac(pos, normal, width, maxWidth);
      tmp = Unit_instance;
    } else {
      tmp = $super.hac.call(this, pos, normal, width, maxWidth);
    }
    return tmp;
  }
  jac(center, pos, sign) {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var dist = Vector2D.t9g(pos.r9g_1 - center.r9g_1, pos.s9g_1 - center.s9g_1);
    var tmp;
    if (sign < 0.0) {
      // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
      tmp = Vector2D.t9g(-dist.r9g_1, -dist.s9g_1);
    } else {
      tmp = dist;
    }
    var normal = tmp;
    this.iac(center, normal.j9t(), dist.a() * sign);
  }
  kac(center, pos, sign, $super) {
    sign = sign === VOID ? 1.0 : sign;
    var tmp;
    if ($super === VOID) {
      this.jac(center, pos, sign);
      tmp = Unit_instance;
    } else {
      tmp = $super.jac.call(this, center, pos, sign);
    }
    return tmp;
  }
  lac(pos, normal, width) {
    this.iac(pos, normal, width);
    this.iac(pos, normal, -width);
  }
  mac(curr, next, kind, miterLimitRatio) {
    var commonPoint = curr.nac(Companion_getInstance_6().z9f_1);
    var currTangent = curr.oac(Companion_getInstance_6().z9f_1);
    var currNormal = curr.pac(Companion_getInstance_6().z9f_1);
    var nextTangent = next.oac(Companion_getInstance_6().w9f_1);
    var nextNormal = next.pac(Companion_getInstance_6().w9f_1);
    var tmp = Companion_instance_20;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = this.yab_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g(currNormal.r9g_1 * scale, currNormal.s9g_1 * scale);
    var tmp$ret$1 = Vector2D.t9g(commonPoint.r9g_1 + that.r9g_1, commonPoint.s9g_1 + that.s9g_1);
    var currLine0 = tmp.qac(tmp$ret$1, currTangent);
    var tmp_0 = Companion_instance_20;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_0 = -this.yab_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that_0 = Vector2D.t9g(currNormal.r9g_1 * scale_0, currNormal.s9g_1 * scale_0);
    var tmp$ret$3 = Vector2D.t9g(commonPoint.r9g_1 + that_0.r9g_1, commonPoint.s9g_1 + that_0.s9g_1);
    var currLine1 = tmp_0.qac(tmp$ret$3, currTangent);
    var tmp_1 = Companion_instance_20;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_1 = this.yab_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that_1 = Vector2D.t9g(nextNormal.r9g_1 * scale_1, nextNormal.s9g_1 * scale_1);
    var tmp$ret$5 = Vector2D.t9g(commonPoint.r9g_1 + that_1.r9g_1, commonPoint.s9g_1 + that_1.s9g_1);
    var nextLine0 = tmp_1.qac(tmp$ret$5, nextTangent);
    var tmp_2 = Companion_instance_20;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_2 = -this.yab_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that_2 = Vector2D.t9g(nextNormal.r9g_1 * scale_2, nextNormal.s9g_1 * scale_2);
    var tmp$ret$7 = Vector2D.t9g(commonPoint.r9g_1 + that_2.r9g_1, commonPoint.s9g_1 + that_2.s9g_1);
    var nextLine1 = tmp_2.qac(tmp$ret$7, nextTangent);
    var intersection0 = lineIntersectionPoint(Companion_instance_20, currLine0, nextLine0);
    var intersection1 = lineIntersectionPoint(Companion_instance_20, currLine1, nextLine1);
    if (intersection0 == null || intersection1 == null) {
      this.lac(commonPoint, currNormal, this.yab_1);
      return Unit_instance;
    }
    var direction = Companion_getInstance().c9t(currTangent, nextTangent);
    var miterLength = Companion_getInstance().z9s(intersection0, intersection1);
    var miterLimit = miterLimitRatio * this.yab_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    Companion_getInstance_0();
    var up = Companion_getInstance().k9h_1;
    var tmp2 = nextTangent.r9g_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    // Inline function 'kotlin.math.atan2' call
    var x = nextTangent.s9g_1;
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    var radians = Math.atan2(tmp2, x);
    var tmp$ret$11 = _Angle___init__impl__g23q1m(radians);
    var tmp_3 = adjustFromUp(tmp$ret$11, up);
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    Companion_getInstance_0();
    var up_0 = Companion_getInstance().k9h_1;
    var tmp2_0 = currTangent.r9g_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    // Inline function 'kotlin.math.atan2' call
    var x_0 = currTangent.s9g_1;
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    var radians_0 = Math.atan2(tmp2_0, x_0);
    var tmp$ret$15 = _Angle___init__impl__g23q1m(radians_0);
    var tmp$ret$12 = adjustFromUp(tmp$ret$15, up_0);
    var angle = Angle__minus_impl_xeau7k(tmp_3, tmp$ret$12);
    if (!kind.equals(LineJoin_MITER_getInstance()) || miterLength > miterLimit) {
      var p1 = direction <= 0.0 ? projectedPoint(currLine0, commonPoint) : projectedPoint(nextLine1, commonPoint);
      var p2 = direction <= 0.0 ? projectedPoint(nextLine0, commonPoint) : projectedPoint(currLine1, commonPoint);
      var p3 = direction <= 0.0 ? lineIntersectionPoint(Companion_instance_20, currLine1, nextLine1) : lineIntersectionPoint(Companion_instance_20, currLine0, nextLine0);
      var p4Line = direction < 0.0 ? nextLine1 : nextLine0;
      var p4 = projectedPoint(p4Line, commonPoint);
      if (p3 == null) {
        p3 = p4;
      }
      var angleB = _Angle___get_absoluteValue__impl__4qoakv(Angle__plus_impl_26v37k(angle, get_degrees(180)));
      var angle2 = _Angle___get_absoluteValue__impl__4qoakv(Angle__umod_impl_4wilf7(angle, get_degrees(180)));
      var angle3 = Angle__compareTo_impl_a0hfds(angle2, get_degrees(90)) >= 0 ? Angle__minus_impl_xeau7k(get_degrees(180), angle2) : angle2;
      var ratio = toRatioClamped(Ratio__times_impl_ucdh7y(_Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle3)), 4.0));
      var p5 = interpolate(toRatio(ratio), p4, ensureNotNull(p3));
      if (this.aac_1) {
        this.eac_1.d2(nextLine1.tac(1000.0).g9m());
        this.eac_1.d2(currLine1.tac(1000.0).g9m());
        this.eac_1.d2(nextLine0.tac(1000.0).g9m());
        this.eac_1.d2(currLine0.tac(1000.0).g9m());
        this.eac_1.d2(Companion_instance_20.qac(commonPoint, currTangent).tac(1000.0).g9m());
        this.eac_1.d2(Companion_instance_20.qac(commonPoint, nextTangent).tac(1000.0).g9m());
        this.dac_1.uaa(p3);
        this.dac_1.uaa(p4);
        this.dac_1.uaa(p5);
      }
      var p6 = p5;
      if (direction < 0.0) {
        this.kac(commonPoint, p1);
        this.jac(commonPoint, p6, -1.0);
        this.kac(commonPoint, p2);
        this.jac(commonPoint, p6, -1.0);
      } else {
        this.kac(commonPoint, p6);
        this.jac(commonPoint, p2, -1.0);
        this.kac(commonPoint, p6);
        this.jac(commonPoint, p1, -1.0);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var d0 = Vector2D.t9g(intersection0.r9g_1 - commonPoint.r9g_1, intersection0.s9g_1 - commonPoint.s9g_1);
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var d1 = Vector2D.t9g(commonPoint.r9g_1 - intersection1.r9g_1, commonPoint.s9g_1 - intersection1.s9g_1);
    var tmp_4 = d0.j9t();
    var tmp_5 = d0.a();
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = d0.a();
    var tmp$ret$18 = Math.abs(this_0);
    this.hac(commonPoint, tmp_4, tmp_5, tmp$ret$18);
    var tmp_6 = d1.j9t();
    var tmp_7 = -d1.a();
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = d1.a();
    var tmp$ret$19 = Math.abs(this_1);
    this.hac(commonPoint, tmp_6, tmp_7, tmp$ret$19);
  }
  uac(curr, ratio, kind) {
    switch (kind.w1_1) {
      case 1:
      case 2:
        // Inline function 'kotlin.let' call

        var it = curr.pac(ratio).l9t();
        var tmp;
        if (equals(ratio, Companion_getInstance_6().z9f_1)) {
          // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
          tmp = Vector2D.t9g(-it.r9g_1, -it.s9g_1);
        } else {
          tmp = it;
        }

        var derivate = tmp;
        switch (kind.w1_1) {
          case 1:
            var tmp0 = curr.nac(ratio);
            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale = this.yab_1;
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            var that = Vector2D.t9g(derivate.r9g_1 * scale, derivate.s9g_1 * scale);
            var tmp$ret$4 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
            this.lac(tmp$ret$4, curr.pac(ratio), this.yab_1);
            break;
          case 2:
            var mid = curr.nac(ratio);
            var normal = curr.pac(ratio);
            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale_0 = this.yab_1;
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            var that_0 = Vector2D.t9g(normal.r9g_1 * scale_0, normal.s9g_1 * scale_0);
            var p0 = Vector2D.t9g(mid.r9g_1 + that_0.r9g_1, mid.s9g_1 + that_0.s9g_1);
            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale_1 = -this.yab_1;
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            var that_1 = Vector2D.t9g(normal.r9g_1 * scale_1, normal.s9g_1 * scale_1);
            var p3 = Vector2D.t9g(mid.r9g_1 + that_1.r9g_1, mid.s9g_1 + that_1.s9g_1);
            var a = equals(ratio, Companion_getInstance_6().w9f_1) ? p0 : p3;
            var b = equals(ratio, Companion_getInstance_6().w9f_1) ? p3 : p0;
            this.vac(a, b, ratio, mid);
            break;
          default:
            // Inline function 'kotlin.error' call

            var message = "Can't happen";
            throw IllegalStateException.o(toString(message));
        }

        break;
      case 0:
        this.lac(curr.nac(ratio), curr.pac(ratio), this.yab_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  wac(p0, p3, ratio, mid, nsteps) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var up = Companion_getInstance().k9h_1;
    var tmp2 = mid.r9g_1;
    var tmp4 = mid.s9g_1;
    var tmp6 = p0.r9g_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var y1 = p0.s9g_1;
    var angleStart = Angle_between(tmp2, tmp4, tmp6, y1, up);
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var up_0 = Companion_getInstance().k9h_1;
    var tmp2_0 = mid.r9g_1;
    var tmp4_0 = mid.s9g_1;
    var tmp6_0 = p3.r9g_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var y1_0 = p3.s9g_1;
    var angleEnd = Angle_between(tmp2_0, tmp4_0, tmp6_0, y1_0, up_0);
    if (equals(ratio, Companion_getInstance_6().z9f_1)) {
      // Inline function 'korlibs.math.geom.Companion.polar' call
      // Inline function 'korlibs.math.geom.Companion.polar' call
      var up_1 = Companion_getInstance().k9h_1;
      var tmp$ret$7 = Vector2D.t9g(0.0 + Angle__cosine_impl_bgvzun(angleEnd, up_1) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angleEnd, up_1) * 1.0);
      this.lac(mid, tmp$ret$7, this.yab_1);
    }
    var addAngle = Companion_getInstance().c9t(p0, p3) <= 0.0 ? Companion_getInstance_0().x9g_1 : Companion_getInstance_0().z9g_1;
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = nsteps - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio_0 = n / NSd;
        var it = toRatio_0(ratio_0);
        var angle = interpolateAngleDenormalized(it, angleStart, angleEnd);
        var tmp0 = Companion_getInstance();
        // Inline function 'korlibs.math.geom.Companion.polar' call
        var angle_0 = Angle__plus_impl_26v37k(angle, addAngle);
        // Inline function 'korlibs.math.geom.Companion.polar' call
        var up_2 = tmp0.k9h_1;
        var dir = Vector2D.t9g(0.0 + Angle__cosine_impl_bgvzun(angle_0, up_2) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angle_0, up_2) * 1.0);
        this.hac(mid, dir, 0.0, this.yab_1);
        this.hac(mid, dir, this.yab_1, this.yab_1);
      }
       while (!(n === end));
    if (equals(ratio, Companion_getInstance_6().w9f_1)) {
      // Inline function 'korlibs.math.geom.Companion.polar' call
      // Inline function 'korlibs.math.geom.Companion.polar' call
      var up_3 = Companion_getInstance().k9h_1;
      var tmp$ret$13 = Vector2D.t9g(0.0 + Angle__cosine_impl_bgvzun(angleStart, up_3) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angleStart, up_3) * 1.0);
      this.lac(mid, tmp$ret$13, this.yab_1);
    }
  }
  vac(p0, p3, ratio, mid, nsteps, $super) {
    var tmp;
    if (mid === VOID) {
      // Inline function 'korlibs.math.geom.Companion.middle' call
      Companion_getInstance();
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      // Inline function 'korlibs.math.geom.Vector2D.times' call
      var this_0 = Vector2D.t9g(p0.r9g_1 + p3.r9g_1, p0.s9g_1 + p3.s9g_1);
      tmp = Vector2D.t9g(this_0.r9g_1 * 0.5, this_0.s9g_1 * 0.5);
    } else {
      tmp = mid;
    }
    mid = tmp;
    nsteps = nsteps === VOID ? this.bac_1 : nsteps;
    var tmp_0;
    if ($super === VOID) {
      this.wac(p0, p3, ratio, mid, nsteps);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.wac.call(this, p0, p3, new Ratio(ratio), mid, nsteps);
    }
    return tmp_0;
  }
  xac(curr, nsteps) {
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = nsteps - 1 | 0;
    var NSd = NS;
    var start = false ? 0 : 1;
    var end = false ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        var it = toRatio_0(ratio);
        this.lac(curr.nac(it), curr.pac(it), this.yab_1);
      }
       while (!(n === end));
  }
  yac(curr, nsteps, $super) {
    nsteps = nsteps === VOID ? numberToInt(clamp(curr.a() / 10.0, 10.0, 100.0)) : nsteps;
    var tmp;
    if ($super === VOID) {
      this.xac(curr, nsteps);
      tmp = Unit_instance;
    } else {
      tmp = $super.xac.call(this, curr, nsteps);
    }
    return tmp;
  }
  fac(curves, join, startCap, endCap, miterLimit, forceClosed) {
    var closed = forceClosed == null ? curves.bad_1 : forceClosed;
    var curves_0 = curves.aad_1;
    var inductionVariable = 0;
    var last = curves_0.s2() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = getCyclic(curves_0, n + 0 | 0);
        var next = getCyclic(curves_0, n + 1 | 0);
        if (n === 0) {
          if (closed) {
            this.mac(getCyclic(curves_0, n - 1 | 0), curr, join, miterLimit);
          } else {
            this.uac(curr, Companion_getInstance_6().w9f_1, startCap);
          }
        }
        if (!(curr.rad() === 1)) {
          this.yac(curr);
        }
        if (n < (curves_0.s2() - 1 | 0)) {
          this.mac(curr, next, join, miterLimit);
        } else {
          if (closed) {
            this.mac(curr, next, join, miterLimit);
          } else {
            this.uac(curr, Companion_getInstance_6().z9f_1, endCap);
          }
        }
      }
       while (inductionVariable <= last);
  }
}
class ProjectedPoint {
  constructor(p, t, dSq) {
    p = p === VOID ? Vector2D.y9j() : p;
    t = t === VOID ? Companion_getInstance_6().w9f_1 : t;
    dSq = dSq === VOID ? 0.0 : dSq;
    this.hae_1 = p;
    this.iae_1 = t;
    this.jae_1 = dSq;
  }
  lae(other, epsilon) {
    return this.hae_1.m9t(other.hae_1, epsilon) && isAlmostEquals(this.iae_1, other.iae_1, toRatio_0(epsilon)) && isAlmostEquals_0(this.jae_1, other.jae_1, epsilon);
  }
  l9f(other, epsilon) {
    return this.lae(other instanceof ProjectedPoint ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return 'ProjectedPoint(p=' + this.hae_1.toString() + ', t=' + Ratio__toString_impl_mfgt3e(this.iae_1) + ', dSq=' + this.jae_1 + ')';
  }
  hashCode() {
    var result = this.hae_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.iae_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.jae_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProjectedPoint))
      return false;
    var tmp0_other_with_cast = other instanceof ProjectedPoint ? other : THROW_CCE();
    if (!this.hae_1.equals(tmp0_other_with_cast.hae_1))
      return false;
    if (!equals(this.iae_1, tmp0_other_with_cast.iae_1))
      return false;
    if (!equals(this.jae_1, tmp0_other_with_cast.jae_1))
      return false;
    return true;
  }
}
class Extrema {
  constructor(xt, yt) {
    this.sad_1 = xt;
    this.tad_1 = yt;
    var tmp = this;
    tmp.uad_1 = lazy(Bezier$Extrema$allt$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.vad_1 = lazy(Bezier$Extrema$xt01$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.wad_1 = lazy(Bezier$Extrema$yt01$delegate$lambda(this));
  }
  xad() {
    var tmp0 = this.vad_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('xt01', 1, tmp, Bezier$Extrema$_get_xt01_$ref_uaychq(), null);
    return tmp0.k3();
  }
  yad() {
    var tmp0 = this.wad_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('yt01', 1, tmp, Bezier$Extrema$_get_yt01_$ref_eubpb(), null);
    return tmp0.k3();
  }
  fae(index) {
    return index === 0 ? this.xad() : this.yad();
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Extrema) {
      tmp_0 = contentEquals(this.sad_1, other.sad_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.tad_1, other.tad_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.sad_1) + imul(contentHashCode(this.tad_1), 7) | 0;
  }
  toString() {
    return 'Extrema(x=' + contentToString(this.sad_1) + ', y=' + contentToString(this.tad_1) + ')';
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.zad_1 = new Float64Array([-0.06405689286260563, 0.06405689286260563, -0.1911188674736163, 0.1911188674736163, -0.3150426796961634, 0.3150426796961634, -0.4337935076260451, 0.4337935076260451, -0.5454214713888396, 0.5454214713888396, -0.6480936519369755, 0.6480936519369755, -0.7401241915785544, 0.7401241915785544, -0.820001985973903, 0.820001985973903, -0.8864155270044011, 0.8864155270044011, -0.9382745520027328, 0.9382745520027328, -0.9747285559713095, 0.9747285559713095, -0.9951872199970213, 0.9951872199970213]);
    var tmp_0 = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp_0.aae_1 = new Float64Array([0.12793819534675216, 0.12793819534675216, 0.1258374563468283, 0.1258374563468283, 0.12167047292780339, 0.12167047292780339, 0.1155056680537256, 0.1155056680537256, 0.10744427011596563, 0.10744427011596563, 0.09761865210411388, 0.09761865210411388, 0.08619016153195327, 0.08619016153195327, 0.0733464814110803, 0.0733464814110803, 0.05929858491543678, 0.05929858491543678, 0.04427743881741981, 0.04427743881741981, 0.028531388628933663, 0.028531388628933663, 0.0123412297999872, 0.0123412297999872]);
    this.bae_1 = 6.283185307179586;
    this.cae_1 = Line2D.z9j(0, 0, 1, 0);
    this.dae_1 = new Float64Array(0);
  }
  mae(p0, p1, p2, p3, t) {
    var out;
    var tmp2 = p0.r9g_1;
    var tmp4 = p0.s9g_1;
    var tmp6 = p1.r9g_1;
    var tmp8 = p1.s9g_1;
    var tmp10 = p2.r9g_1;
    var tmp12 = p2.s9g_1;
    // Inline function 'korlibs.math.geom.bezier.Companion.cubicCalc' call
    var cx = 3.0 * (tmp6 - tmp2);
    var bx = 3.0 * (tmp10 - tmp6) - cx;
    var ax = p3.r9g_1 - tmp2 - cx - bx;
    var cy = 3.0 * (tmp8 - tmp4);
    var by = 3.0 * (tmp12 - tmp8) - cy;
    var ay = p3.s9g_1 - tmp4 - cy - by;
    var tSquared = Ratio__times_impl_ucdh7y_0(t, t);
    var tCubed = Ratio__times_impl_ucdh7y_0(tSquared, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp = ax * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_0 = tmp + bx * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp0 = tmp_0 + cx * _Ratio___get_value__impl__57cli6(t) + tmp2;
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_1 = ay * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_2 = tmp_1 + by * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var y = tmp_2 + cy * _Ratio___get_value__impl__57cli6(t) + tmp4;
    out = Vector2D.t9g(tmp0, y);
    return out;
  }
  nae(p, c, a, t) {
    var out;
    var tmp2 = p.r9g_1;
    var tmp4 = p.s9g_1;
    var tmp6 = c.r9g_1;
    var tmp8 = c.s9g_1;
    var tmp10 = a.r9g_1;
    // Inline function 'korlibs.math.geom.bezier.Companion.quadCalc' call
    var y1 = a.s9g_1;
    var t1 = 1 - Ratio__toDouble_impl_o7epze(t);
    var a_0 = t1 * t1;
    var c_0 = Ratio__times_impl_ucdh7y_0(t, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var b = 2 * t1 * _Ratio___get_value__impl__57cli6(t);
    var tmp0 = a_0 * tmp2 + b * tmp6 + Ratio__times_impl_ucdh7y(c_0, tmp10);
    var y = a_0 * tmp4 + b * tmp8 + Ratio__times_impl_ucdh7y(c_0, y1);
    out = Vector2D.t9g(tmp0, y);
    return out;
  }
  oae(a, b) {
    return a + (b - a) * (2.0 / 3.0);
  }
  pae(a, b) {
    return b + (a - b) * (2.0 / 3.0);
  }
}
class Bezier {
  constructor(points, dummy) {
    return new.target.xae(points, dummy);
  }
  static xae(points, dummy) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.gad_1 = points;
    if ($this.gad_1.s2() > 4) {
      // Inline function 'kotlin.error' call
      var message = 'Only supports quad and cubic beziers';
      throw IllegalStateException.o(toString(message));
    }
    var tmp = $this;
    tmp.had_1 = lazy(Bezier$aligned$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.iad_1 = lazy(Bezier$dpoints$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.jad_1 = lazy(Bezier$direction$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.kad_1 = lazy(Bezier$extrema$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.lad_1 = lazy(Bezier$outerCircle$delegate$lambda($this));
    var tmp_4 = $this;
    tmp_4.mad_1 = lazy(Bezier$boundingBox$delegate$lambda($this));
    var tmp_5 = $this;
    tmp_5.nad_1 = lazy(Bezier$length$delegate$lambda($this));
    var tmp_6 = $this;
    tmp_6.oad_1 = lazy(Bezier$lut$delegate$lambda($this));
    var tmp_7 = $this;
    tmp_7.pad_1 = lazy(Bezier$isLinear$delegate$lambda($this));
    var tmp_8 = $this;
    tmp_8.qad_1 = lazy(Bezier$isSimple$delegate$lambda($this));
    return $this;
  }
  static yae() {
    Companion_getInstance_8();
    return this.zae(Vector2D.d9m(0.0, 0.0), Vector2D.d9m(0.0, 0.0));
  }
  static zae(p0, p1) {
    Companion_getInstance_8();
    return this.xae(pointArrayListOf(p0, p1), Unit_instance);
  }
  static aaf(p0, p1, p2) {
    Companion_getInstance_8();
    return this.xae(pointArrayListOf_0(p0, p1, p2), Unit_instance);
  }
  static baf(p0, p1, p2, p3) {
    Companion_getInstance_8();
    return this.xae(pointArrayListOf_1(p0, p1, p2, p3), Unit_instance);
  }
  static caf(points) {
    Companion_getInstance_8();
    return this.xae(points.saa(), Unit_instance);
  }
  daf(other, epsilon) {
    if (!(this.gad_1.s2() === other.gad_1.s2()))
      return false;
    var tmp0 = until(0, this.gad_1.s2());
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var inductionVariable = tmp0.n3_1;
      var last = tmp0.o3_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = element;
          if (!this.gad_1.u2(it).m9t(other.gad_1.u2(it), epsilon)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
         while (!(element === last));
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  l9f(other, epsilon) {
    return this.daf(other instanceof Bezier ? other : THROW_CCE(), epsilon);
  }
  gae(t) {
    return this.eaf(t);
  }
  faf() {
    return this.sae();
  }
  gaf(m) {
    return _getBoundingBox(this, m);
  }
  nac(t) {
    return this.eaf(t);
  }
  equals(other) {
    var tmp;
    if (other instanceof Bezier) {
      tmp = equals(this.gad_1, other.gad_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.gad_1);
  }
  toString() {
    return 'Bezier(' + toString(this.gad_1) + ')';
  }
  rae() {
    return 2;
  }
  rad() {
    return this.gad_1.s2() - 1 | 0;
  }
  qae() {
    var tmp0 = this.iad_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('dpoints', 1, tmp, Bezier$_get_dpoints_$ref_ff14gc(), null);
    return tmp0.k3();
  }
  eae() {
    var tmp0 = this.kad_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('extrema', 1, tmp, Bezier$_get_extrema_$ref_gf7khf(), null);
    return tmp0.k3();
  }
  tae() {
    var tmp0 = this.lad_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('outerCircle', 1, tmp, Bezier$_get_outerCircle_$ref_c58qwg(), null);
    return tmp0.k3();
  }
  sae() {
    var tmp0 = this.mad_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('boundingBox', 1, tmp, Bezier$_get_boundingBox_$ref_1y88b0(), null);
    return tmp0.k3();
  }
  a() {
    var tmp0 = this.nad_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('length', 1, tmp, Bezier$_get_length_$ref_bphkk9(), null);
    return tmp0.k3();
  }
  wae() {
    var tmp0 = this.oad_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('lut', 1, tmp, Bezier$_get_lut_$ref_n1ixow(), null);
    return tmp0.k3();
  }
  haf(length) {
    return this.wae().paf(length).jaf_1;
  }
  qaf(steps, out) {
    out.a5();
    Companion_getInstance_6();
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    var NS = (steps + 1 | 0) - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        var t = toRatio_0(ratio);
        out.raf(t, this.eaf(t));
      }
       while (!(n === end));
    return out;
  }
  vae(steps, out, $super) {
    steps = steps === VOID ? 100 : steps;
    out = out === VOID ? CurveLUT.saf(this, steps + 1 | 0) : out;
    return $super === VOID ? this.qaf(steps, out) : $super.qaf.call(this, steps, out);
  }
  taf(point, out) {
    out.kae_1 = this;
    if (this.gad_1.s2() === 2) {
      var p0 = this.gad_1.u2(0);
      var p1 = this.gad_1.u2(1);
      return findNearestLine(this, point.r9g_1, point.s9g_1, p0.r9g_1, p0.s9g_1, p1.r9g_1, p1.s9g_1, out);
    }
    var LUT = this.wae();
    var l = LUT.uaf();
    var closest = LUT.vaf(point);
    var mpos = closest.xaf_1;
    var t1 = (mpos - 1 | 0) / l;
    var t2 = (mpos + 1 | 0) / l;
    var step = 0.1 / l;
    var mdistSq = closest.waf_1;
    var t = t1;
    var ft = t;
    mdistSq = mdistSq + 1;
    while (t < t2 + step) {
      var p = this.eaf(toRatio_0(t));
      var d = Companion_getInstance().w9i(point, p);
      if (d < mdistSq) {
        mdistSq = d;
        ft = t;
        out.hae_1 = p;
      }
      t = t + step;
    }
    out.hae_1 = this.eaf(toRatio_0(ft));
    out.iae_1 = ft < 0 ? Companion_getInstance_6().w9f_1 : ft > 1 ? Companion_getInstance_6().z9f_1 : toRatio_0(ft);
    out.jae_1 = mdistSq;
    return out;
  }
  yaf() {
    if (this.gad_1.s2() < 4)
      return Companion_getInstance_8().dae_1;
    var p = _get_aligned__7fjidv(this);
    var p1 = p.u2(1);
    var p2 = p.u2(2);
    var p3 = p.u2(3);
    var a = p2.r9g_1 * p1.s9g_1;
    var b = p3.r9g_1 * p1.s9g_1;
    var c = p1.r9g_1 * p2.s9g_1;
    var d = p3.r9g_1 * p2.s9g_1;
    var v1 = 18.0 * (-3.0 * a + 2.0 * b + 3.0 * c - d);
    var v2 = 18.0 * (3.0 * a - b - 3.0 * c);
    var v3 = 18.0 * (c - a);
    if (isAlmostZero(v1)) {
      if (!isAlmostZero(v2)) {
        var t = -v3 / v2;
        if (0.0 <= t ? t <= 1.0 : false) {
          // Inline function 'kotlin.doubleArrayOf' call
          return new Float64Array([t]);
        }
      }
      return Companion_getInstance_8().dae_1;
    }
    var d2 = 2.0 * v1;
    if (isAlmostEquals_0(d2, 0.0))
      return Companion_getInstance_8().dae_1;
    var trm = v2 * v2 - 4.0 * v1 * v3;
    if (trm < 0)
      return Companion_getInstance_8().dae_1;
    // Inline function 'kotlin.math.sqrt' call
    var sq = Math.sqrt(trm);
    var out0 = (sq - v2) / d2;
    var out1 = -(v2 + sq) / d2;
    var out = DoubleArrayList.ga3(2);
    if (0.0 <= out0 ? out0 <= 1.0 : false) {
      out.la3(out0);
    }
    if (0.0 <= out1 ? out1 <= 1.0 : false) {
      out.la3(out1);
    }
    return out.k9u();
  }
  eaf(t) {
    return compute(Companion_getInstance_8(), t, this.gad_1);
  }
  zaf(t, normalize) {
    var out = compute(Companion_getInstance_8(), t, this.qae().u2(0));
    if ((equals(t, Companion_getInstance_6().w9f_1) || equals(t, Companion_getInstance_6().z9f_1)) && isAlmostZero(out.h9t())) {
      var inductionVariable = 0;
      if (inductionVariable < 10)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.math.pow' call
          var n_0 = -(10 - n | 0) | 0;
          var newT = Math.pow(10.0, n_0);
          var nt = equals(t, Companion_getInstance_6().z9f_1) ? 1.0 - newT : newT;
          out = compute(Companion_getInstance_8(), _Ratio___init__impl__9mwvn2(nt), this.qae().u2(0));
        }
         while (isAlmostZero(out.h9t()) && inductionVariable < 10);
    }
    if (normalize)
      out = out.j9t();
    return out;
  }
  uae(t, normalize, $super) {
    normalize = normalize === VOID ? false : normalize;
    return $super === VOID ? this.zaf(t, normalize) : $super.zaf.call(this, new Ratio(t), normalize);
  }
  aag(t, normalize) {
    return this.zaf(t, normalize).l9t();
  }
  pac(t) {
    return this.aag(t, true);
  }
  oac(t) {
    return this.zaf(t, true);
  }
  bag(t, out) {
    if (this.rad() < 2)
      return null;
    var p = this.gad_1;
    out.xaa(p, 0);
    out.xaa(p, 1);
    out.xaa(p, 2);
    if (this.rad() === 3) {
      out.xaa(p, 3);
    }
    while (p.s2() > 1) {
      var next = new PointArrayList();
      var inductionVariable = 0;
      var last = p.s2() - 1 | 0;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var p_0 = interpolate(toRatio(t), p.u2(i), p.u2(i + 1 | 0));
          out.uaa(p_0);
          next.uaa(p_0);
        }
         while (inductionVariable < last);
      p = next;
    }
    return out;
  }
  cag(t, out, $super) {
    out = out === VOID ? new PointArrayList() : out;
    return $super === VOID ? this.bag(t, out) : $super.bag.call(this, new Ratio(t), out);
  }
  dag(t0, t1) {
    return SubBezier.kag(this.iag(t0).jag(map(Companion_getInstance_8(), t1, t0, Companion_getInstance_6().z9f_1, Companion_getInstance_6().w9f_1, Companion_getInstance_6().z9f_1)).eag_1, t0, t1, this);
  }
  jag(t) {
    return SubBezier.lag(this).jag(t);
  }
  iag(t) {
    return SubBezier.lag(this).iag(t);
  }
  mag() {
    return Line2D.w9j(this.gad_1.u2(0), this.gad_1.u2(this.rad()));
  }
}
class CurveInfo {
  constructor(index, curve, startLength, endLength, bounds) {
    this.nag_1 = index;
    this.oag_1 = curve;
    this.pag_1 = startLength;
    this.qag_1 = endLength;
    this.rag_1 = bounds;
  }
  l9u(length) {
    var containsLower = this.pag_1;
    return length <= this.qag_1 ? containsLower <= length : false;
  }
  a() {
    return this.qag_1 - this.pag_1;
  }
  toString() {
    return 'CurveInfo(index=' + this.nag_1 + ', curve=' + this.oag_1.toString() + ', startLength=' + this.pag_1 + ', endLength=' + this.qag_1 + ', bounds=' + this.rag_1.toString() + ')';
  }
  hashCode() {
    var result = this.nag_1;
    result = imul(result, 31) + this.oag_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.pag_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.qag_1) | 0;
    result = imul(result, 31) + this.rag_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveInfo))
      return false;
    var tmp0_other_with_cast = other instanceof CurveInfo ? other : THROW_CCE();
    if (!(this.nag_1 === tmp0_other_with_cast.nag_1))
      return false;
    if (!this.oag_1.equals(tmp0_other_with_cast.oag_1))
      return false;
    if (!equals(this.pag_1, tmp0_other_with_cast.pag_1))
      return false;
    if (!equals(this.qag_1, tmp0_other_with_cast.qag_1))
      return false;
    if (!this.rag_1.equals(tmp0_other_with_cast.rag_1))
      return false;
    return true;
  }
}
class Curves {
  constructor(beziers, closed) {
    this.zac_1 = new Mixin();
    this.aad_1 = beziers;
    this.bad_1 = closed;
    this.cad_1 = false;
    var tmp = this;
    tmp.dad_1 = lazy(Curves$contiguous$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.ead_1 = lazy(Curves$infos$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.fad_1 = lazy(Curves$length$delegate$lambda(this));
  }
  o9u(_set____db54di) {
    this.zac_1.o9u(_set____db54di);
  }
  p9u() {
    return this.zac_1.p9u();
  }
  sag() {
    var tmp0 = this.ead_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('infos', 1, tmp, Curves$_get_infos_$ref_92y8xn(), null);
    return tmp0.k3();
  }
  a() {
    var tmp0 = this.fad_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('length', 1, tmp, Curves$_get_length_$ref_2flho(), null);
    return tmp0.k3();
  }
  tag(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.pag_1 / this.a());
  }
  uag(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.qag_1 / this.a());
  }
  vag(t) {
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var tmp = this.sag();
    var index = binarySearch(tmp, VOID, VOID, Curves$findInfo$lambda(pos));
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance_6().w9f_1) < 0)
      return first(this.sag());
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance_6().z9f_1) > 0)
      return last(this.sag());
    var tmp0_elvis_lhs = getOrNull(this.sag(), index);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException.o(toString('OUTSIDE'));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  nac(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.vag(t);
    var posInCurve = pos - info.pag_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    return info.oag_1.nac(toRatio(ratioInCurve));
  }
  pac(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.vag(t);
    var posInCurve = pos - info.pag_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    return info.oag_1.pac(ratioInCurve);
  }
  oac(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.vag(t);
    var posInCurve = pos - info.pag_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    return info.oag_1.oac(ratioInCurve);
  }
  haf(length) {
    if (length <= 0.0)
      return Companion_getInstance_6().w9f_1;
    if (length >= this.a())
      return Companion_getInstance_6().z9f_1;
    var tmp = this.sag();
    var curveIndex = binarySearch(tmp, VOID, VOID, Curves$ratioFromLength$lambda(length));
    var index = curveIndex < 0 ? (-curveIndex | 0) + 1 | 0 : curveIndex;
    if (curveIndex < 0) {
      return Companion_getInstance_6().a9g_1;
    }
    var info = this.sag().u2(index);
    var lengthInCurve = length - info.pag_1;
    var ratioInCurve = info.oag_1.haf(lengthInCurve);
    return convertRange(ratioInCurve, Companion_getInstance_6().w9f_1, Companion_getInstance_6().z9f_1, this.tag(info), this.uag(info));
  }
  wag(len0, len1) {
    return this.dag(this.haf(len0), this.haf(len1));
  }
  dag(t0, t1) {
    if (Ratio__compareTo_impl_z2ienc(t0, t1) > 0)
      return this.dag(t1, t0);
    // Inline function 'kotlin.check' call
    if (!(Ratio__compareTo_impl_z2ienc(t0, t1) <= 0)) {
      throw IllegalStateException.o('Check failed.');
    }
    if (equals(t0, t1))
      return new Curves(emptyList(), false);
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t0, this.a());
    var info = this.vag(t0);
    var posInCurve = pos - info.pag_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos_0 = Ratio__times_impl_ucdh7y(t1, this.a());
    var info_0 = this.vag(t1);
    var posInCurve_0 = pos_0 - info_0.pag_1;
    var ratioInCurve_0 = _Ratio___init__impl__9mwvn2(posInCurve_0 / info_0.a());
    var tmp;
    if (info.nag_1 === info_0.nag_1) {
      tmp = listOf(info.oag_1.dag(ratioInCurve, ratioInCurve_0).eag_1);
    } else {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList.p2();
      if (!equals(ratioInCurve, Companion_getInstance_6().z9f_1)) {
        this_0.d2(info.oag_1.iag(ratioInCurve).eag_1);
      }
      var inductionVariable = info.nag_1 + 1 | 0;
      var last = info_0.nag_1;
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.d2(this.sag().u2(index).oag_1);
        }
         while (inductionVariable < last);
      if (!equals(ratioInCurve_0, Companion_getInstance_6().w9f_1)) {
        this_0.d2(info_0.oag_1.jag(ratioInCurve_0).eag_1);
      }
      tmp = this_0.g9();
    }
    var tmp$ret$1 = tmp;
    return new Curves(tmp$ret$1, false);
  }
  toString() {
    return 'Curves(beziers=' + toString(this.aad_1) + ', closed=' + this.bad_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.aad_1);
    result = imul(result, 31) + getBooleanHashCode(this.bad_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Curves))
      return false;
    var tmp0_other_with_cast = other instanceof Curves ? other : THROW_CCE();
    if (!equals(this.aad_1, tmp0_other_with_cast.aad_1))
      return false;
    if (!(this.bad_1 === tmp0_other_with_cast.bad_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_0 = new Int32Array([0, 3, 5]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$1 = new Int32Array([0, 4, 7, 9]);
    tmp.xag_1 = listOf_0([null, null, tmp_0, tmp$ret$1]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_2 = new Int32Array([5, 4, 2]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$3 = new Int32Array([9, 8, 6, 3]);
    tmp_1.yag_1 = listOf_0([null, null, tmp_2, tmp$ret$3]);
  }
}
class SubBezier {
  constructor(curve, t1, t2, parent) {
    return new.target.kag(curve, t1, t2, parent);
  }
  static kag(curve, t1, t2, parent) {
    Companion_getInstance_9();
    var $this = createThis(this);
    $this.eag_1 = curve;
    $this.fag_1 = t1;
    $this.gag_1 = t2;
    $this.hag_1 = parent;
    return $this;
  }
  static lag(curve) {
    Companion_getInstance_9();
    return this.kag(curve, Companion_getInstance_6().w9f_1, Companion_getInstance_6().z9f_1, null);
  }
  nac(t) {
    return this.eag_1.nac(convertRange(t, this.fag_1, this.gag_1, Companion_getInstance_6().w9f_1, Companion_getInstance_6().z9f_1));
  }
  jag(t) {
    return _splitLeft(this, t);
  }
  iag(t) {
    return _splitRight(this, t);
  }
  toString() {
    return 'SubBezier[' + get_niceStr(Ratio__toDouble_impl_o7epze(this.fag_1)) + '..' + get_niceStr(Ratio__toDouble_impl_o7epze(this.gag_1)) + '](' + this.eag_1.toString() + ')';
  }
}
class ClosestResult {
  constructor(mdistSq, mpos) {
    this.waf_1 = mdistSq;
    this.xaf_1 = mpos;
  }
}
class Estimation {
  constructor(point, ratio, length) {
    point = point === VOID ? Vector2D.y9j() : point;
    ratio = ratio === VOID ? Companion_getInstance_6().w9f_1 : ratio;
    length = length === VOID ? 0.0 : length;
    this.iaf_1 = point;
    this.jaf_1 = ratio;
    this.kaf_1 = length;
  }
  toString() {
    return 'Estimation(point=' + this.iaf_1.n9t() + ', ratio=' + get_niceStr_0(this.jaf_1) + ', length=' + get_niceStr(this.kaf_1) + ')';
  }
  hashCode() {
    var result = this.iaf_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.jaf_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.kaf_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Estimation))
      return false;
    var tmp0_other_with_cast = other instanceof Estimation ? other : THROW_CCE();
    if (!this.iaf_1.equals(tmp0_other_with_cast.iaf_1))
      return false;
    if (!equals(this.jaf_1, tmp0_other_with_cast.jaf_1))
      return false;
    if (!equals(this.kaf_1, tmp0_other_with_cast.kaf_1))
      return false;
    return true;
  }
}
class CurveLUT {
  constructor(curve, points, ts, _estimatedLengths) {
    return new.target.bah(curve, points, ts, _estimatedLengths);
  }
  static bah(curve, points, ts, _estimatedLengths) {
    var $this = createThis(this);
    $this.laf_1 = curve;
    $this.maf_1 = points;
    $this.naf_1 = ts;
    $this.oaf_1 = _estimatedLengths;
    return $this;
  }
  static saf(curve, capacity) {
    return this.bah(curve, new PointArrayList(capacity), DoubleArrayList.ga3(capacity), DoubleArrayList.ga3(capacity));
  }
  aah() {
    if (this.oaf_1.n1()) {
      this.oaf_1.la3(0.0);
    }
    while (this.oaf_1.s2() < this.s2()) {
      var pos = this.oaf_1.s2();
      var prev = last_0(this.oaf_1);
      this.oaf_1.la3(prev + Companion_getInstance().z9s(this.maf_1.u2(pos - 1 | 0), this.maf_1.u2(pos)));
    }
    return this.oaf_1;
  }
  uaf() {
    return this.maf_1.s2() - 1 | 0;
  }
  s2() {
    return this.maf_1.s2();
  }
  a5() {
    this.maf_1.sh();
    this.naf_1.a5();
    this.oaf_1.a5();
  }
  raf(t, p) {
    this.maf_1.uaa(p);
    this.naf_1.la3(Ratio__toDouble_impl_o7epze(t));
  }
  vaf(point) {
    var mdistSq = Infinity;
    var mpos = 0;
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = Companion_getInstance().w9i(this.maf_1.u2(n), point);
        if (d < mdistSq) {
          mdistSq = d;
          mpos = n;
        }
      }
       while (inductionVariable < last);
    return new ClosestResult(mdistSq, mpos);
  }
  zag(_this__u8e3s4, index, ratio) {
    var ratio0 = toRatio_0(this.naf_1.u2(index));
    var length0 = this.aah().u2(index);
    var point0 = this.maf_1.u2(index);
    if (ratio === 0.0) {
      _this__u8e3s4.jaf_1 = ratio0;
      _this__u8e3s4.kaf_1 = length0;
      _this__u8e3s4.iaf_1 = point0;
    } else {
      var ratio1 = toRatio_0(this.naf_1.u2(index + 1 | 0));
      var length1 = this.aah().u2(index + 1 | 0);
      var point1 = this.maf_1.u2(index + 1 | 0);
      _this__u8e3s4.jaf_1 = interpolate_0(toRatio_0(ratio), ratio0, ratio1);
      _this__u8e3s4.kaf_1 = interpolate_1(toRatio_0(ratio), length0, length1);
      _this__u8e3s4.iaf_1 = interpolate(toRatio_0(ratio), point0, point1);
    }
    return _this__u8e3s4;
  }
  cah(length, out) {
    return estimateAt(this, this.aah(), length, out);
  }
  paf(length, out, $super) {
    out = out === VOID ? new Estimation() : out;
    return $super === VOID ? this.cah(length, out) : $super.cah.call(this, length, out);
  }
  toString() {
    var tmp = toString(this.laf_1);
    var tmp_0 = until(0, this.s2());
    return 'CurveLUT[' + tmp + '](' + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, CurveLUT$toString$lambda(this)) + ')';
  }
  hashCode() {
    var result = hashCode(this.laf_1);
    result = imul(result, 31) + this.maf_1.hashCode() | 0;
    result = imul(result, 31) + this.naf_1.hashCode() | 0;
    result = imul(result, 31) + this.oaf_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveLUT))
      return false;
    var tmp0_other_with_cast = other instanceof CurveLUT ? other : THROW_CCE();
    if (!equals(this.laf_1, tmp0_other_with_cast.laf_1))
      return false;
    if (!this.maf_1.equals(tmp0_other_with_cast.maf_1))
      return false;
    if (!this.naf_1.equals(tmp0_other_with_cast.naf_1))
      return false;
    if (!this.oaf_1.equals(tmp0_other_with_cast.oaf_1))
      return false;
    return true;
  }
}
class Arc {
  constructor() {
    this.dah_1 = 0.5522847498307933;
    this.eah_1 = 6.283185307179586;
  }
  fah(out, a, c, r) {
    if (out.n1()) {
      out.gah(a);
    }
    var b = out.hah();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var AB = Vector2D.t9g(b.r9g_1 - a.r9g_1, b.s9g_1 - a.s9g_1);
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var AC = Vector2D.t9g(c.r9g_1 - a.r9g_1, c.s9g_1 - a.s9g_1);
    var angle = Angle__times_impl_v3s9y2(Companion_getInstance().w9s(AB, AC), 0.5);
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__minus_impl_xeau7k(Companion_getInstance_0().y9g_1, angle);
    var up = Companion_getInstance().k9h_1;
    var tmp = r * Angle__sine_impl_3l11xv(angle_0, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance().k9h_1;
    var x = tmp / Angle__sine_impl_3l11xv(angle, up_0);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_0 = AB.k9t();
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g(this_0.r9g_1 * x, this_0.s9g_1 * x);
    var A = Vector2D.t9g(a.r9g_1 + that.r9g_1, a.s9g_1 + that.s9g_1);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = AC.k9t();
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that_0 = Vector2D.t9g(this_1.r9g_1 * x, this_1.s9g_1 * x);
    var B = Vector2D.t9g(a.r9g_1 + that_0.r9g_1, a.s9g_1 + that_0.s9g_1);
    out.iah(A);
    out.jah(a, B);
  }
  kah(out, center, r, start, end, counterclockwise) {
    var x = center.jm();
    var y = center.km();
    var startAngle = _Angle___get_normalized__impl__9s30ys(start);
    var endAngle1 = _Angle___get_normalized__impl__9s30ys(end);
    var endAngle = Angle__compareTo_impl_a0hfds(endAngle1, startAngle) < 0 ? Angle__plus_impl_26v37k(endAngle1, Companion_getInstance_0().b9h_1) : endAngle1;
    var tmp0 = Companion_getInstance_0().b9h_1;
    // Inline function 'korlibs.math.geom.abs' call
    var angle = Angle__minus_impl_xeau7k(endAngle, startAngle);
    // Inline function 'korlibs.math.geom.min' call
    var b = _Angle___get_absoluteValue__impl__4qoakv(angle);
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var tmp0_0 = _Angle___get_radians__impl__n00yt5(tmp0);
    // Inline function 'korlibs.math.geom.Angle.internal' call
    // Inline function 'kotlin.math.min' call
    var b_0 = _Angle___get_radians__impl__n00yt5(b);
    var tmp$ret$4 = Math.min(tmp0_0, b_0);
    var remainingAngle = _Angle___init__impl__g23q1m(tmp$ret$4);
    if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_0().w9g_1) < 0 && !equals(start, end))
      remainingAngle = Companion_getInstance_0().b9h_1;
    var sgn1 = Angle__compareTo_impl_a0hfds(startAngle, endAngle) < 0 ? 1 : -1;
    var sgn = counterclockwise ? -sgn1 | 0 : sgn1;
    if (counterclockwise) {
      remainingAngle = Angle__minus_impl_xeau7k(Companion_getInstance_0().b9h_1, remainingAngle);
      if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_0().w9g_1) < 0 && !equals(start, end))
        remainingAngle = Companion_getInstance_0().b9h_1;
    }
    var a1 = startAngle;
    var index = 0;
    while (Angle__compareTo_impl_a0hfds(remainingAngle, Companion_getInstance_0().w9g_1) > 0) {
      var tmp = a1;
      var tmp0_1 = remainingAngle;
      // Inline function 'korlibs.math.geom.min' call
      var b_1 = Companion_getInstance_0().y9g_1;
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var tmp0_2 = _Angle___get_radians__impl__n00yt5(tmp0_1);
      // Inline function 'korlibs.math.geom.Angle.internal' call
      // Inline function 'kotlin.math.min' call
      var b_2 = _Angle___get_radians__impl__n00yt5(b_1);
      var tmp$ret$8 = Math.min(tmp0_2, b_2);
      var tmp$ret$5 = _Angle___init__impl__g23q1m(tmp$ret$8);
      var a2 = Angle__plus_impl_26v37k(tmp, Angle__times_impl_v3s9y2_0(tmp$ret$5, sgn));
      var a = Angle__div_impl_ut2btd(Angle__minus_impl_xeau7k(a2, a1), 2.0);
      var x4 = r * _Angle___get_cosine__impl__vprvmu(a);
      var y4 = r * _Angle___get_sine__impl__15nmyi(a);
      var x1 = x4;
      var y1 = -y4;
      var f = 0.5522847498307933 * _Angle___get_tangent__impl__vushdy(a);
      var x2 = x1 + f * y4;
      var y2 = y1 + f * x4;
      var x3 = x2;
      var y3 = -y2;
      var ar = Angle__plus_impl_26v37k(a, a1);
      var cos_ar = _Angle___get_cosine__impl__vprvmu(ar);
      var sin_ar = _Angle___get_sine__impl__15nmyi(ar);
      if (index === 0) {
        out.gah(Vector2D.t9g(x + r * _Angle___get_cosine__impl__vprvmu(a1), y + r * _Angle___get_sine__impl__15nmyi(a1)));
      }
      out.lah(Vector2D.t9g(x + x2 * cos_ar - y2 * sin_ar, y + x2 * sin_ar + y2 * cos_ar), Vector2D.t9g(x + x3 * cos_ar - y3 * sin_ar, y + x3 * sin_ar + y3 * cos_ar), Vector2D.t9g(x + r * _Angle___get_cosine__impl__vprvmu(a2), y + r * _Angle___get_sine__impl__15nmyi(a2)));
      index = index + 1 | 0;
      var tmp_0 = remainingAngle;
      // Inline function 'korlibs.math.geom.abs' call
      var angle_0 = Angle__minus_impl_xeau7k(a2, a1);
      var tmp$ret$9 = _Angle___get_absoluteValue__impl__4qoakv(angle_0);
      remainingAngle = Angle__minus_impl_xeau7k(tmp_0, tmp$ret$9);
      a1 = a2;
    }
    if (equals(startAngle, endAngle) && !(index === 0)) {
      out.f7();
    }
  }
}
class Companion_1 {
  yah(width, height, algo) {
    return new BinPacker(Size2D.y9p(width, height), algo);
  }
  zah(width, height, algo) {
    return Companion_instance_1.yah(width, height, algo);
  }
  aai(width, height, algo, $super) {
    algo = algo === VOID ? MaxRects.cai(width, height) : algo;
    return $super === VOID ? this.zah(width, height, algo) : $super.zah.call(this, width, height, algo);
  }
}
class ImageDoNotFitException extends Error {
  constructor(width, height, packer) {
    var tmp = "Size '" + width + 'x' + height + "' doesn't fit in '" + packer.w9z() + 'x' + packer.x9z() + "'";
    super(tmp);
    setPropertiesToThrowableInstance(this, tmp);
    captureStack(this, this.jai_1);
    this.gai_1 = width;
    this.hai_1 = height;
    this.iai_1 = packer;
  }
}
class BinPacker {
  constructor(size, algo) {
    algo = algo === VOID ? MaxRects.kai(size) : algo;
    this.dai_1 = size;
    this.eai_1 = algo;
    this.fai_1 = FastArrayList.f9v();
  }
  w9z() {
    return this.dai_1.j9i_1;
  }
  x9z() {
    return this.dai_1.k9i_1;
  }
  taa(width, height) {
    var tmp0_elvis_lhs = this.lai(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw new ImageDoNotFitException(width, height, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  lai(width, height) {
    var tmp0_elvis_lhs = this.eai_1.mai(Size2D.y9p(width, height));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rect = tmp;
    // Inline function 'kotlin.collections.plusAssign' call
    this.fai_1.d2(rect);
    return rect;
  }
}
class MaxRects {
  constructor(maxSize) {
    return new.target.kai(maxSize);
  }
  static kai(maxSize) {
    var $this = createThis(this);
    $this.bai_1 = fastArrayListOf([Companion_getInstance_2().m9i(Companion_getInstance().g9h_1, maxSize)]);
    return $this;
  }
  static cai(width, height) {
    return this.kai(Size2D.y9p(width, height));
  }
  mai(size) {
    return this.nai(size);
  }
  nai(size) {
    var width = size.jm();
    var height = size.km();
    if (width <= 0.0 && height <= 0.0)
      return Companion_getInstance_2().r9p(0, 0, 0, 0);
    var newNode = quickFindPositionForNewNodeBestAreaFit(this, width, height);
    if (newNode.r9h_1 === 0.0)
      return null;
    var numRectanglesToProcess = this.bai_1.s2();
    var i = 0;
    while (i < numRectanglesToProcess) {
      if (splitFreeNode(this, this.bai_1.u2(i), newNode)) {
        this.bai_1.g5(i);
        numRectanglesToProcess = numRectanglesToProcess - 1 | 0;
        i = i - 1 | 0;
      }
      i = i + 1 | 0;
    }
    pruneFreeList(this);
    return newNode;
  }
}
class Companion_2 {}
class HitTestDirection extends Enum {}
class Convex {
  xah(curves) {
    var tmp0_elvis_lhs = toNonCurveSimplePointList(curves);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var points = tmp;
    return this.oai(points);
  }
  oai(vertices) {
    var base = 0;
    var n = vertices.s2();
    var TWO_PI = 3.141592653589793 * 2;
    if (n <= 3)
      return true;
    if (vertices.l9j(base) === vertices.l9j(n - 1 | 0) && vertices.m9j(base) === vertices.m9j(n - 1 | 0)) {
      n = n - 1 | 0;
    }
    var old_x = vertices.l9j(n - 2 | 0);
    var old_y = vertices.m9j(n - 2 | 0);
    var new_x = vertices.l9j(n - 1 | 0);
    var new_y = vertices.m9j(n - 1 | 0);
    var tmp0 = new_y - old_y;
    // Inline function 'kotlin.math.atan2' call
    var x = new_x - old_x;
    var new_direction = Math.atan2(tmp0, x);
    var old_direction;
    var angle_sum = Companion_getInstance_0().x9g_1;
    var orientation = 0.0;
    var inductionVariable = 0;
    var last = n;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        old_x = new_x;
        old_y = new_y;
        old_direction = new_direction;
        var _unary__edvuaz = base;
        base = _unary__edvuaz + 1 | 0;
        var p = _unary__edvuaz;
        new_x = vertices.l9j(p);
        new_y = vertices.m9j(p);
        var tmp0_0 = new_y - old_y;
        // Inline function 'kotlin.math.atan2' call
        var x_0 = new_x - old_x;
        new_direction = Math.atan2(tmp0_0, x_0);
        if (old_x === new_x && old_y === new_y) {
          return false;
        }
        var angle = new_direction - old_direction;
        if (angle <= -3.141592653589793)
          angle = angle + TWO_PI;
        else if (angle > 3.141592653589793)
          angle = angle - TWO_PI;
        if (i === 0) {
          if (angle === 0.0) {
            return false;
          }
          orientation = angle > 0 ? 1.0 : -1.0;
        } else if (orientation * angle < 0.0) {
          return false;
        }
        var tmp = angle_sum;
        Companion_getInstance_0();
        // Inline function 'korlibs.math.geom.Companion.fromRadians' call
        var radians = angle;
        var tmp$ret$2 = _Angle___init__impl__g23q1m(radians);
        angle_sum = Angle__plus_impl_26v37k(tmp, tmp$ret$2);
      }
       while (inductionVariable < last);
    return isAlmostEquals(Companion_getInstance_6().z9f_1, _Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle_sum)));
  }
}
class BaseShape2D {
  constructor(base, genVector) {
    this.tai_1 = base;
    this.uai_1 = genVector;
    var tmp = this;
    tmp.vai_1 = lazy(BaseShape2D$cachedPath$delegate$lambda(this));
  }
  toString() {
    return 'Shape2D(' + toString(this.tai_1) + ')';
  }
}
class CircleShape2D extends BaseShape2D {
  constructor(circle) {
    super(circle, CircleShape2D$_init_$lambda_c1uoso);
    this.sai_1 = circle;
  }
  toString() {
    return 'Shape2D(' + this.tai_1.toString() + ')';
  }
  hashCode() {
    return this.sai_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CircleShape2D))
      return false;
    var tmp0_other_with_cast = other instanceof CircleShape2D ? other : THROW_CCE();
    if (!this.sai_1.equals(tmp0_other_with_cast.sai_1))
      return false;
    return true;
  }
}
class AbstractShape2D {}
class SliceCoords {}
function x(index) {
  switch (index) {
    case 0:
      return this.bal();
    case 1:
      return this.dal();
    case 2:
      return this.fal();
    case 3:
      return this.hal();
    default:
      return NaN;
  }
}
function y(index) {
  switch (index) {
    case 0:
      return this.cal();
    case 1:
      return this.eal();
    case 2:
      return this.gal();
    case 3:
      return this.ial();
    default:
      return NaN;
  }
}
class SliceCoordsWithBase {}
function get_frameOffsetX() {
  return this.sak().r9k_1;
}
function get_frameOffsetY() {
  return this.sak().o9k_1;
}
function get_frameWidth() {
  return this.w9z() + this.sak().l9k() | 0;
}
function get_frameHeight() {
  return this.x9z() + this.sak().m9k() | 0;
}
class SliceCoordsWithBaseAndRect {}
function get_left() {
  return this.rak().v9h();
}
function get_top() {
  return this.rak().x9h();
}
function get_right() {
  return this.rak().w9h();
}
function get_bottom() {
  return this.rak().y9h();
}
function get_area() {
  return this.rak().g9r();
}
class RectSlice {
  constructor(base, rect, orientation, padding, name) {
    orientation = orientation === VOID ? Companion_getInstance_14().yai_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_3().n9k_1 : padding;
    name = name === VOID ? null : name;
    this.haj_1 = base;
    this.iaj_1 = rect;
    this.jaj_1 = orientation;
    this.kaj_1 = padding;
    this.laj_1 = name;
    this.maj_1 = this.haj_1.s2().o9s_1;
    this.naj_1 = this.haj_1.s2().p9s_1;
    this.oaj_1 = this.iaj_1.q9q_1;
    this.paj_1 = this.iaj_1.r9q_1;
    this.qaj_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.jaj_1) ? this.iaj_1.q9q_1 : this.iaj_1.r9q_1;
    this.raj_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.jaj_1) ? this.iaj_1.r9q_1 : this.iaj_1.q9q_1;
    this.saj_1 = this.qaj_1 + this.kaj_1.l9k() | 0;
    this.taj_1 = this.raj_1 + this.kaj_1.m9k() | 0;
    this.uaj_1 = this.iaj_1.v9h() / this.maj_1;
    this.vaj_1 = this.iaj_1.w9h() / this.maj_1;
    this.waj_1 = this.iaj_1.x9h() / this.naj_1;
    this.xaj_1 = this.iaj_1.y9h() / this.naj_1;
    this.yaj_1 = new RectCoords(this.uaj_1, this.waj_1, this.vaj_1, this.waj_1, this.vaj_1, this.xaj_1, this.uaj_1, this.xaj_1);
    this.zaj_1 = transformed_1(this.yaj_1, this.jaj_1);
    this.aak_1 = this.zaj_1.iak_1;
    this.bak_1 = this.zaj_1.jak_1;
    this.cak_1 = this.zaj_1.kak_1;
    this.dak_1 = this.zaj_1.lak_1;
    this.eak_1 = this.zaj_1.mak_1;
    this.fak_1 = this.zaj_1.nak_1;
    this.gak_1 = this.zaj_1.oak_1;
    this.hak_1 = this.zaj_1.pak_1;
  }
  qak() {
    return this.haj_1;
  }
  rak() {
    return this.iaj_1;
  }
  sak() {
    return this.kaj_1;
  }
  w9z() {
    return this.qaj_1;
  }
  x9z() {
    return this.raj_1;
  }
  tak() {
    return this.saj_1;
  }
  uak() {
    return this.taj_1;
  }
  vak(left, top, right, bottom, name, clamped, orientation) {
    var tmp = this.iaj_1.h9r(left, top, right, bottom, clamped);
    return new RectSlice(this.haj_1, tmp, orientation, this.kaj_1, name == null ? this.laj_1 : name);
  }
  wak(left, top, right, bottom, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.jaj_1 : orientation;
    return $super === VOID ? this.vak(left, top, right, bottom, name, clamped, orientation) : $super.vak.call(this, left, top, right, bottom, name, clamped, new SliceOrientation(orientation));
  }
  xak(x, y, width, height, name, clamped, orientation) {
    return this.vak(x, y, x + width | 0, y + height | 0, name, clamped, orientation);
  }
  yak(x, y, width, height, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.jaj_1 : orientation;
    return $super === VOID ? this.xak(x, y, width, height, name, clamped, orientation) : $super.xak.call(this, x, y, width, height, name, clamped, new SliceOrientation(orientation));
  }
  zak(rect, name, clamped, orientation) {
    return this.vak(rect.v9h(), rect.x9h(), rect.w9h(), rect.y9h(), name, clamped, orientation);
  }
  aal(rect, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.jaj_1 : orientation;
    return $super === VOID ? this.zak(rect, name, clamped, orientation) : $super.zak.call(this, rect, name, clamped, new SliceOrientation(orientation));
  }
  bal() {
    return this.aak_1;
  }
  cal() {
    return this.bak_1;
  }
  dal() {
    return this.cak_1;
  }
  eal() {
    return this.dak_1;
  }
  fal() {
    return this.eak_1;
  }
  gal() {
    return this.fak_1;
  }
  hal() {
    return this.gak_1;
  }
  ial() {
    return this.hak_1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('RectSlice(');
    this_0.m1(this.laj_1);
    this_0.m1(':');
    this_0.s1(this.iaj_1);
    if (!(this.jaj_1 === Companion_getInstance_14().yai_1)) {
      this_0.m1(':');
      this_0.s1(new SliceOrientation(this.jaj_1));
    }
    if (this.kaj_1.u9k()) {
      this_0.m1(':');
      this_0.s1(this.kaj_1);
    }
    this_0.m1(')');
    return this_0.toString();
  }
  hashCode() {
    var result = hashCode(this.haj_1);
    result = imul(result, 31) + this.iaj_1.hashCode() | 0;
    result = imul(result, 31) + SliceOrientation__hashCode_impl_7mjkdw(this.jaj_1) | 0;
    result = imul(result, 31) + this.kaj_1.hashCode() | 0;
    result = imul(result, 31) + (this.laj_1 == null ? 0 : getStringHashCode(this.laj_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectSlice))
      return false;
    var tmp0_other_with_cast = other instanceof RectSlice ? other : THROW_CCE();
    if (!equals(this.haj_1, tmp0_other_with_cast.haj_1))
      return false;
    if (!this.iaj_1.equals(tmp0_other_with_cast.iaj_1))
      return false;
    if (!(this.jaj_1 === tmp0_other_with_cast.jaj_1))
      return false;
    if (!this.kaj_1.equals(tmp0_other_with_cast.kaj_1))
      return false;
    if (!(this.laj_1 == tmp0_other_with_cast.laj_1))
      return false;
    return true;
  }
}
class Companion_3 {
  nal(base, coords, name, flippedWidthHeight) {
    return new SliceCoordsImpl(base, coords, name, flippedWidthHeight);
  }
  oal(base, coords, name, flippedWidthHeight, $super) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    return $super === VOID ? this.nal(base, coords, name, flippedWidthHeight) : $super.nal.call(this, base, coords, name, flippedWidthHeight);
  }
}
class SliceCoordsImpl {
  constructor(base, coords, name, flippedWidthHeight) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    this.pal_1 = base;
    this.qal_1 = coords;
    this.ral_1 = name;
    this.sal_1 = flippedWidthHeight;
    this.tal_1 = Companion_getInstance_3().n9k_1;
    this.ual_1 = !this.sal_1 ? this.pal_1.s2().o9s_1 : this.pal_1.s2().p9s_1;
    this.val_1 = !this.sal_1 ? this.pal_1.s2().p9s_1 : this.pal_1.s2().o9s_1;
    this.wal_1 = numberToInt(Companion_getInstance().x9s(this.qal_1.bal(), this.qal_1.cal(), this.qal_1.dal(), this.qal_1.eal()) * this.ual_1);
    this.xal_1 = numberToInt(Companion_getInstance().x9s(this.qal_1.bal(), this.qal_1.cal(), this.qal_1.hal(), this.qal_1.ial()) * this.val_1);
    this.yal_1 = this.wal_1 + this.tal_1.l9k() | 0;
    this.zal_1 = this.xal_1 + this.tal_1.m9k() | 0;
  }
  qak() {
    return this.pal_1;
  }
  sak() {
    return this.tal_1;
  }
  w9z() {
    return this.wal_1;
  }
  x9z() {
    return this.xal_1;
  }
  tak() {
    return this.yal_1;
  }
  uak() {
    return this.zal_1;
  }
  bal() {
    return this.qal_1.bal();
  }
  cal() {
    return this.qal_1.cal();
  }
  dal() {
    return this.qal_1.dal();
  }
  eal() {
    return this.qal_1.eal();
  }
  fal() {
    return this.qal_1.fal();
  }
  gal() {
    return this.qal_1.gal();
  }
  hal() {
    return this.qal_1.hal();
  }
  ial() {
    return this.qal_1.ial();
  }
  toString() {
    return 'SliceCoordsImpl(base=' + toString(this.pal_1) + ', coords=' + toString(this.qal_1) + ', name=' + this.ral_1 + ', flippedWidthHeight=' + this.sal_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.pal_1);
    result = imul(result, 31) + hashCode(this.qal_1) | 0;
    result = imul(result, 31) + (this.ral_1 == null ? 0 : getStringHashCode(this.ral_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.sal_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SliceCoordsImpl))
      return false;
    var tmp0_other_with_cast = other instanceof SliceCoordsImpl ? other : THROW_CCE();
    if (!equals(this.pal_1, tmp0_other_with_cast.pal_1))
      return false;
    if (!equals(this.qal_1, tmp0_other_with_cast.qal_1))
      return false;
    if (!(this.ral_1 == tmp0_other_with_cast.ral_1))
      return false;
    if (!(this.sal_1 === tmp0_other_with_cast.sal_1))
      return false;
    return true;
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    this.aam_1 = values();
  }
  u2(index) {
    return this.aam_1[umod(index, 4)];
  }
}
class SliceRotation extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.dam_1 = imul(this.w1_1, 90);
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(8);
    while (tmp_0 < 8) {
      var tmp_2 = tmp_0;
      // Inline function 'kotlin.intArrayOf' call
      // Inline function 'kotlin.also' call
      var this_0 = new Int32Array([0, 1, 2, 3]);
      var orientation = _SliceOrientation___init__impl__ewylib(tmp_2);
      if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
        swap(this_0, 0, 1);
        swap(this_0, 3, 2);
      }
      rotateRight(this_0, _SliceOrientation___get_rotation__impl__m65r0o(orientation).w1_1);
      tmp_1[tmp_2] = this_0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.wai_1 = tmp_1;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = Array(8);
    while (tmp_4 < 8) {
      var tmp_6 = tmp_4;
      var orientation_0 = _SliceOrientation___init__impl__ewylib(tmp_6);
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.apply' call
      var this_1 = StringBuilder.l1();
      this_1.m1(_SliceOrientation___get_flipX__impl__lgb7bx(orientation_0) ? 'MIRROR_HORIZONTAL_ROTATE_' : 'ROTATE_');
      this_1.kh(_SliceOrientation___get_rotation__impl__m65r0o(orientation_0).dam_1);
      tmp_5[tmp_6] = this_1.toString();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.xai_1 = tmp_5;
    var tmp_7 = this;
    var tmp39_rotation = SliceRotation_R0_getInstance();
    tmp_7.yai_1 = _SliceOrientation___init__impl__ewylib_0(tmp39_rotation, false);
    var tmp_8 = this;
    var tmp40_rotation = SliceRotation_R90_getInstance();
    tmp_8.zai_1 = _SliceOrientation___init__impl__ewylib_0(tmp40_rotation, false);
    var tmp_9 = this;
    var tmp41_rotation = SliceRotation_R180_getInstance();
    tmp_9.aaj_1 = _SliceOrientation___init__impl__ewylib_0(tmp41_rotation, false);
    var tmp_10 = this;
    var tmp42_rotation = SliceRotation_R270_getInstance();
    tmp_10.baj_1 = _SliceOrientation___init__impl__ewylib_0(tmp42_rotation, false);
    this.caj_1 = _SliceOrientation___init__impl__ewylib_0(VOID, true);
    var tmp_11 = this;
    var tmp43_rotation = SliceRotation_R90_getInstance();
    tmp_11.daj_1 = _SliceOrientation___init__impl__ewylib_0(tmp43_rotation, true);
    var tmp_12 = this;
    var tmp44_rotation = SliceRotation_R180_getInstance();
    tmp_12.eaj_1 = _SliceOrientation___init__impl__ewylib_0(tmp44_rotation, true);
    var tmp_13 = this;
    var tmp45_rotation = SliceRotation_R270_getInstance();
    tmp_13.faj_1 = _SliceOrientation___init__impl__ewylib_0(tmp45_rotation, true);
    this.gaj_1 = listOf_0([new SliceOrientation(this.yai_1), new SliceOrientation(this.zai_1), new SliceOrientation(this.aaj_1), new SliceOrientation(this.baj_1), new SliceOrientation(this.caj_1), new SliceOrientation(this.daj_1), new SliceOrientation(this.eaj_1), new SliceOrientation(this.faj_1)]);
  }
}
class SliceOrientation {
  constructor(raw) {
    Companion_getInstance_14();
    this.eam_1 = raw;
  }
  toString() {
    return SliceOrientation__toString_impl_tdph6r(this.eam_1);
  }
  hashCode() {
    return SliceOrientation__hashCode_impl_7mjkdw(this.eam_1);
  }
  equals(other) {
    return SliceOrientation__equals_impl_h4gywg(this.eam_1, other);
  }
}
class RectCoords {
  constructor(tlX, tlY, trX, trY, brX, brY, blX, blY) {
    this.iak_1 = tlX;
    this.jak_1 = tlY;
    this.kak_1 = trX;
    this.lak_1 = trY;
    this.mak_1 = brX;
    this.nak_1 = brY;
    this.oak_1 = blX;
    this.pak_1 = blY;
  }
  bal() {
    return this.iak_1;
  }
  cal() {
    return this.jak_1;
  }
  dal() {
    return this.kak_1;
  }
  eal() {
    return this.lak_1;
  }
  fal() {
    return this.mak_1;
  }
  gal() {
    return this.nak_1;
  }
  hal() {
    return this.oak_1;
  }
  ial() {
    return this.pak_1;
  }
  toString() {
    return 'RectCoords(tlX=' + this.iak_1 + ', tlY=' + this.jak_1 + ', trX=' + this.kak_1 + ', trY=' + this.lak_1 + ', brX=' + this.mak_1 + ', brY=' + this.nak_1 + ', blX=' + this.oak_1 + ', blY=' + this.pak_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.iak_1);
    result = imul(result, 31) + getNumberHashCode(this.jak_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.kak_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.lak_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.mak_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.nak_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.oak_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.pak_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCoords))
      return false;
    var tmp0_other_with_cast = other instanceof RectCoords ? other : THROW_CCE();
    if (!equals(this.iak_1, tmp0_other_with_cast.iak_1))
      return false;
    if (!equals(this.jak_1, tmp0_other_with_cast.jak_1))
      return false;
    if (!equals(this.kak_1, tmp0_other_with_cast.kak_1))
      return false;
    if (!equals(this.lak_1, tmp0_other_with_cast.lak_1))
      return false;
    if (!equals(this.mak_1, tmp0_other_with_cast.mak_1))
      return false;
    if (!equals(this.nak_1, tmp0_other_with_cast.nak_1))
      return false;
    if (!equals(this.oak_1, tmp0_other_with_cast.oak_1))
      return false;
    if (!equals(this.pak_1, tmp0_other_with_cast.pak_1))
      return false;
    return true;
  }
}
class Companion_6 {}
class Item {
  constructor(index) {
    this.fam_1 = index;
  }
  toString() {
    return Item__toString_impl_d711m6(this.fam_1);
  }
  hashCode() {
    return Item__hashCode_impl_8k4v6p(this.fam_1);
  }
  equals(other) {
    return Item__equals_impl_qczid(this.fam_1, other);
  }
}
class FTrapezoidsInt {
  constructor(capacity) {
    capacity = capacity === VOID ? 5 : capacity;
    this.gam_1 = false;
    this.ham_1 = IntArrayList.za1(imul(capacity, 7));
  }
  s2() {
    return this.ham_1.s2() / 6 | 0;
  }
  iam(index) {
    return _Item___init__impl__hhk1le(index);
  }
  toString() {
    return 'FTrapezoidsInt[' + this.s2() + ']';
  }
  jam(x, y, assumeSorted) {
    // Inline function 'korlibs.math.geom.trapezoid.FTrapezoidsInt.pointInside' call
    var iterations = 0;
    var iterations2 = 0;
    var found = false;
    if (assumeSorted) {
      var size = this.s2();
      // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
      var tmp2 = size - 1 | 0;
      var tmp$ret$2;
      $l$block: {
        // Inline function 'korlibs.datastructure.genericBinarySearch' call
        var low = 0;
        var high = tmp2 - 1 | 0;
        while (low <= high) {
          var mid = (low + high | 0) / 2 | 0;
          iterations2 = iterations2 + 1 | 0;
          var mval = compareTo(this.lam(_Item___init__impl__hhk1le(mid)), y);
          if (mval < 0)
            low = mid + 1 | 0;
          else if (mval > 0)
            high = mid - 1 | 0;
          else {
            tmp$ret$2 = mid;
            break $l$block;
          }
        }
        tmp$ret$2 = (-low | 0) - 1 | 0;
      }
      var result = _BSearchResult___init__impl__em6zam(tmp$ret$2);
      var index = _BSearchResult___get_nearIndex__impl__s8nq43(result);
      $l$loop: while (0 <= index ? index < size : false) {
        var item = _Item___init__impl__hhk1le(index);
        if (y > this.mam(item))
          break $l$loop;
        iterations = iterations + 1 | 0;
        index = index - 1 | 0;
      }
      index = index + 1 | 0;
      var inductionVariable = index;
      if (inductionVariable < size)
        $l$loop_1: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          iterations = iterations + 1 | 0;
          var item_0 = _Item___init__impl__hhk1le(n);
          var inside = this.kam(item_0, x, y);
          if (inside) {
            found = true;
            break $l$loop_1;
          }
        }
         while (this.lam(item_0) <= y && inductionVariable < size);
    } else {
      var inductionVariable_0 = 0;
      var last = this.s2();
      if (inductionVariable_0 < last)
        $l$loop_2: do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          iterations = iterations + 1 | 0;
          var it = this.iam(n_0);
          if (this.kam(it, x, y)) {
            found = true;
            break $l$loop_2;
          }
        }
         while (inductionVariable_0 < last);
    }
    if (!(null == null)) {
      null.oam_1 = iterations;
      null.pam_1 = iterations2;
      null.qam_1 = this.s2();
      null.nam_1 = found;
    }
    return found;
  }
  ram(x, y, assumeSorted, $super) {
    assumeSorted = assumeSorted === VOID ? this.gam_1 : assumeSorted;
    return $super === VOID ? this.jam(x, y, assumeSorted) : $super.jam.call(this, x, y, assumeSorted);
  }
  sam(_this__u8e3s4) {
    return this.ham_1.u2(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 0 | 0);
  }
  tam(_this__u8e3s4) {
    return this.ham_1.u2(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 1 | 0);
  }
  lam(_this__u8e3s4) {
    return this.ham_1.u2(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 2 | 0);
  }
  uam(_this__u8e3s4) {
    return this.ham_1.u2(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 3 | 0);
  }
  vam(_this__u8e3s4) {
    return this.ham_1.u2(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 4 | 0);
  }
  mam(_this__u8e3s4) {
    return this.ham_1.u2(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 5 | 0);
  }
  kam(_this__u8e3s4, x, y) {
    return Companion_instance_8.wam(this.sam(_this__u8e3s4), this.tam(_this__u8e3s4), this.lam(_this__u8e3s4), this.uam(_this__u8e3s4), this.vam(_this__u8e3s4), this.mam(_this__u8e3s4), x, y);
  }
  xam(x0a, x0b, y0, x1a, x1b, y1) {
    // Inline function 'kotlin.also' call
    var this_0 = new Item(_Item___init__impl__hhk1le(this.s2()));
    this_0.fam_1;
    this.ham_1.ia2(x0a, x0b, y0, x1a, x1b, y1);
    return this_0.fam_1;
  }
}
class Companion_7 {}
class SortOps_0 extends SortOps {
  constructor(gen) {
    super();
    this.zam_1 = gen;
  }
  aan(subject, l, r) {
    var tmp0 = this.zam_1(subject, new Item_0(_Item___init__impl__hhk1le_0(l)));
    // Inline function 'kotlin.compareTo' call
    var other = this.zam_1(subject, new Item_0(_Item___init__impl__hhk1le_0(r)));
    return compareTo(tmp0, other);
  }
  wa3(subject, l, r) {
    return this.aan(subject instanceof FSegmentsInt ? subject : THROW_CCE(), l, r);
  }
  ban(subject, indexL, indexR) {
    return subject.dan(_Item___init__impl__hhk1le_0(indexL), _Item___init__impl__hhk1le_0(indexR));
  }
  ya3(subject, indexL, indexR) {
    return this.ban(subject instanceof FSegmentsInt ? subject : THROW_CCE(), indexL, indexR);
  }
}
class Item_0 {
  constructor(index) {
    this.yam_1 = index;
  }
  toString() {
    return Item__toString_impl_d711m6_0(this.yam_1);
  }
  hashCode() {
    return Item__hashCode_impl_8k4v6p_0(this.yam_1);
  }
  equals(other) {
    return Item__equals_impl_qczid_0(this.yam_1, other);
  }
}
class FSegmentsInt {
  constructor(capacity) {
    capacity = capacity === VOID ? 5 : capacity;
    this.can_1 = IntArrayList.za1(imul(capacity, 4));
  }
  s2() {
    return this.can_1.s2() / 4 | 0;
  }
  g9m() {
    // Inline function 'kotlin.also' call
    var this_0 = new FSegmentsInt(this.s2());
    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = this.ean(n);
        this_0.jan(this.fan(it), this.gan(it), this.han(it), this.ian(it));
      }
       while (inductionVariable < last);
    return this_0;
  }
  kan(gen) {
    // Inline function 'kotlin.also' call
    var this_0 = this.g9m();
    this_0.lan(gen);
    return this_0;
  }
  lan(gen) {
    genericSort(this, 0, this.s2() - 1 | 0, new SortOps_0(gen));
  }
  dan(a, b) {
    var ax0 = this.fan(a);
    var ay0 = this.gan(a);
    var ax1 = this.han(a);
    var ay1 = this.ian(a);
    this.man(a, this.fan(b), this.gan(b), this.han(b), this.ian(b));
    this.man(b, ax0, ay0, ax1, ay1);
  }
  ean(index) {
    return _Item___init__impl__hhk1le_0(index);
  }
  nan(index) {
    return (0 <= index ? index < this.s2() : false) ? this.ean(index) : null;
  }
  oan(_this__u8e3s4, value) {
    this.can_1.s7x(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 0 | 0, value);
  }
  fan(_this__u8e3s4) {
    return this.can_1.u2(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 0 | 0);
  }
  pan(_this__u8e3s4, value) {
    this.can_1.s7x(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 1 | 0, value);
  }
  gan(_this__u8e3s4) {
    return this.can_1.u2(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 1 | 0);
  }
  qan(_this__u8e3s4, value) {
    this.can_1.s7x(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 2 | 0, value);
  }
  han(_this__u8e3s4) {
    return this.can_1.u2(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 2 | 0);
  }
  ran(_this__u8e3s4, value) {
    this.can_1.s7x(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 3 | 0, value);
  }
  ian(_this__u8e3s4) {
    return this.can_1.u2(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 3 | 0);
  }
  man(_this__u8e3s4, x0, y0, x1, y1) {
    this.oan(_this__u8e3s4, x0);
    this.pan(_this__u8e3s4, y0);
    this.qan(_this__u8e3s4, x1);
    this.ran(_this__u8e3s4, y1);
  }
  san(_this__u8e3s4) {
    return this.han(_this__u8e3s4) - this.fan(_this__u8e3s4) | 0;
  }
  tan(_this__u8e3s4) {
    return this.ian(_this__u8e3s4) - this.gan(_this__u8e3s4) | 0;
  }
  uan(_this__u8e3s4) {
    return this.san(_this__u8e3s4) / this.tan(_this__u8e3s4);
  }
  van(_this__u8e3s4) {
    var tmp0 = this.fan(_this__u8e3s4);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = this.han(_this__u8e3s4);
    return Math.min(tmp0, b);
  }
  wan(_this__u8e3s4) {
    var tmp0 = this.gan(_this__u8e3s4);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = this.ian(_this__u8e3s4);
    return Math.min(tmp0, b);
  }
  xan(_this__u8e3s4) {
    var tmp0 = this.gan(_this__u8e3s4);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = this.ian(_this__u8e3s4);
    return Math.max(tmp0, b);
  }
  yan(_this__u8e3s4, y) {
    return this.fan(_this__u8e3s4) + toIntRound((y - this.gan(_this__u8e3s4) | 0) * this.uan(_this__u8e3s4)) | 0;
  }
  zan(_this__u8e3s4, y) {
    var containsLower = this.wan(_this__u8e3s4);
    return y <= this.xan(_this__u8e3s4) ? containsLower <= y : false;
  }
  aao(_this__u8e3s4, other) {
    return Companion_instance_9.bao(this.fan(_this__u8e3s4), this.gan(_this__u8e3s4), this.han(_this__u8e3s4), this.ian(_this__u8e3s4), this.fan(other), this.gan(other), this.han(other), this.ian(other));
  }
  jan(x0, y0, x1, y1) {
    var index = this.s2();
    this.can_1.ha2(x0, y0, x1, y1);
    return _Item___init__impl__hhk1le_0(index);
  }
  cao(v, segments) {
    // Inline function 'kotlin.run' call
    return this.jan(segments.fan(v), segments.gan(v), segments.han(v), segments.ian(v));
  }
}
class SegmentIntToTrapezoidIntList {
  dao(segments, winding, trapezoids) {
    var _destruct__k2r9zo = segmentLookups(this, segments);
    var allY = _destruct__k2r9zo.jm();
    var allSegmentsInY = _destruct__k2r9zo.km();
    var inductionVariable = 0;
    var last = allY.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y0 = allY[n];
        var y1 = allY[n + 1 | 0];
        var segs = allSegmentsInY.u2(n);
        // Inline function 'kotlin.collections.arrayListOf' call
        var chunks = ArrayList.p2();
        switch (winding.w1_1) {
          case 0:
            var progression = step(until(0, segs.s2()), 2);
            var inductionVariable_0 = progression.n3_1;
            var last_0 = progression.o3_1;
            var step_0 = progression.p3_1;
            if (step_0 > 0 && inductionVariable_0 <= last_0 || (step_0 < 0 && last_0 <= inductionVariable_0))
              $l$loop_1: do {
                var m = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + step_0 | 0;
                var tmp0_elvis_lhs = segs.nan(m + 0 | 0);
                var tmp;
                var tmp_0 = tmp0_elvis_lhs;
                if ((tmp_0 == null ? null : new Item_0(tmp_0)) == null) {
                  continue $l$loop_1;
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                var s0 = tmp;
                var tmp1_elvis_lhs = segs.nan(m + 1 | 0);
                var tmp_1;
                var tmp_2 = tmp1_elvis_lhs;
                if ((tmp_2 == null ? null : new Item_0(tmp_2)) == null) {
                  continue $l$loop_1;
                } else {
                  tmp_1 = tmp1_elvis_lhs;
                }
                var s1 = tmp_1;
                var tmp_3;
                // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                // Inline function 'kotlin.run' call
                if (!segs.zan(s0, y1)) {
                  tmp_3 = true;
                } else {
                  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                  // Inline function 'kotlin.run' call
                  tmp_3 = !segs.zan(s1, y1);
                }
                if (tmp_3)
                  continue $l$loop_1;
                // Inline function 'kotlin.collections.plusAssign' call
                var element = new Pair(new Item_0(s0), new Item_0(s1));
                chunks.d2(element);
              }
               while (!(m === last_0));
            break;
          case 1:
            var sign = 0;
            var inductionVariable_1 = 0;
            var last_1 = segs.s2();
            if (inductionVariable_1 < last_1)
              $l$loop_2: do {
                var m_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var seg = segs.ean(m_0);
                if (!(sign === 0) && m_0 > 0) {
                  var s0_0 = segs.ean(m_0 - 1 | 0);
                  var s1_0 = seg;
                  var tmp_4;
                  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                  // Inline function 'kotlin.run' call
                  if (!segs.zan(s0_0, y1)) {
                    tmp_4 = true;
                  } else {
                    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                    // Inline function 'kotlin.run' call
                    tmp_4 = !segs.zan(s1_0, y1);
                  }
                  if (tmp_4)
                    continue $l$loop_2;
                  // Inline function 'kotlin.collections.plusAssign' call
                  var element_0 = new Pair(new Item_0(s0_0), new Item_0(s1_0));
                  chunks.d2(element_0);
                }
                var tmp_5 = sign;
                // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                // Inline function 'kotlin.run' call
                sign = tmp_5 + get_sign(segs.tan(seg)) | 0;
              }
               while (inductionVariable_1 < last_1);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var _iterator__ex2g4s = chunks.p1();
        while (_iterator__ex2g4s.q1()) {
          var _destruct__k2r9zo_0 = _iterator__ex2g4s.r1();
          var s0_1 = _destruct__k2r9zo_0.jm().yam_1;
          var s1_1 = _destruct__k2r9zo_0.km().yam_1;
          // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
          // Inline function 'kotlin.run' call
          var x0a = segs.yan(s0_1, y0);
          var x0b = segs.yan(s1_1, y0);
          var x1a = segs.yan(s0_1, y1);
          var x1b = segs.yan(s1_1, y1);
          var tmp_6;
          if (x1b < x1a) {
            var intersectY = segs.aao(s0_1, s1_1);
            var intersectX = segs.yan(s0_1, intersectY);
            trapezoids.xam(x0a, x0b, y0, intersectX, intersectX, intersectY);
            tmp_6 = trapezoids.xam(intersectX, intersectX, intersectY, x1a, x1b, y1);
          } else {
            tmp_6 = trapezoids.xam(x0a, x0b, y0, x1a, x1b, y1);
          }
        }
      }
       while (inductionVariable < last);
    return trapezoids;
  }
  eao(segments, winding, trapezoids, $super) {
    winding = winding === VOID ? Winding_EVEN_ODD_getInstance() : winding;
    trapezoids = trapezoids === VOID ? new FTrapezoidsInt() : trapezoids;
    return $super === VOID ? this.dao(segments, winding, trapezoids) : $super.dao.call(this, segments, winding, trapezoids);
  }
}
class Companion_8 {
  wam(x0a, x0b, y0, x1a, x1b, y1, x, y) {
    if (y < y0 || y > y1)
      return false;
    if (x < x0a && x < x1a || (x > x0b && x > x1b))
      return false;
    var sign1 = get_sign(det(this, x1a - x | 0, y1 - y | 0, x0a - x | 0, y0 - y | 0));
    var sign2 = get_sign(det(this, x1b - x | 0, y1 - y | 0, x0b - x | 0, y0 - y | 0));
    return !(sign1 === sign2);
  }
}
class Companion_9 {
  bao(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    var outY = -2147483648;
    $l$block: {
      // Inline function 'korlibs.math.geom.trapezoid.Companion.getIntersectXY' call
      var a1 = By - Ay | 0;
      var b1 = Ax - Bx | 0;
      var c1 = imul(a1, Ax) + imul(b1, Ay) | 0;
      var a2 = Dy - Cy | 0;
      var b2 = Cx - Dx | 0;
      var c2 = imul(a2, Cx) + imul(b2, Cy) | 0;
      var determinant = imul(a1, b2) - imul(a2, b1) | 0;
      if (determinant === 0) {
        break $l$block;
      }
      var x = (imul(b2, c1) - imul(b1, c2) | 0) / determinant | 0;
      var y = (imul(a1, c2) - imul(a2, c1) | 0) / determinant | 0;
      outY = y;
    }
    return outY;
  }
}
class Bucket {
  constructor() {
    this.fao_1 = FastArrayList.f9v();
  }
  sh() {
    // Inline function 'kotlin.apply' call
    this.fao_1.a5();
    return this;
  }
}
class Buckets {
  constructor(pool, ySize) {
    this.gao_1 = pool;
    this.hao_1 = ySize;
    this.iao_1 = FastIntMap();
  }
  s2() {
    return get_size(this.iao_1);
  }
  jao(y) {
    return y / this.hao_1 | 0;
  }
  kao(index) {
    var tmp0 = this.iao_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = tmp0.get(index);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var out = this.gao_1.ja8();
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp0.set(index, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  lao(y) {
    var tmp0 = this.iao_1;
    // Inline function 'korlibs.datastructure.get' call
    var key = this.jao(y);
    // Inline function 'kotlin.js.asDynamic' call
    return tmp0.get(key);
  }
  a5() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.iao_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      var it = v.value;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = this_0.get(it);
      var value = ensureNotNull(tmp$ret$4);
      this.gao_1.ka8(value.sh());
    }
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.iao_1.clear();
  }
  mao(edge, threshold) {
    var min = this.jao(edge.xao());
    var max = this.jao(edge.yao());
    if ((max - min | 0) < threshold) {
      var inductionVariable = min;
      if (inductionVariable <= max)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.kao(n).fao_1.d2(edge);
        }
         while (!(n === max));
      return true;
    }
    return false;
  }
  zao(edge, threshold, $super) {
    threshold = threshold === VOID ? 2147483647 : threshold;
    return $super === VOID ? this.mao(edge, threshold) : $super.mao.call(this, edge, threshold);
  }
}
class AllBuckets {
  constructor() {
    var tmp = this;
    var tmp_0 = PolygonScanline$AllBuckets$pool$lambda;
    tmp.aap_1 = Pool.ga8(tmp_0, VOID, PolygonScanline$AllBuckets$pool$lambda_0);
    this.bap_1 = new Buckets(this.aap_1, 80);
    this.cap_1 = new Buckets(this.aap_1, 320);
    this.dap_1 = new Buckets(this.aap_1, 1280);
  }
  eap(edge) {
    if (this.bap_1.mao(edge, 4))
      return Unit_instance;
    if (this.cap_1.mao(edge, 4))
      return Unit_instance;
    this.dap_1.zao(edge);
  }
  a5() {
    this.bap_1.a5();
    this.cap_1.a5();
    this.dap_1.a5();
  }
}
class XWithWind {
  constructor() {
    this.zap_1 = IntArrayList.za1(1024);
    this.aaq_1 = IntArrayList.za1(1024);
  }
  s2() {
    return this.zap_1.s2();
  }
  baq(x, wind) {
    this.zap_1.ga2(x);
    this.aaq_1.ga2(wind);
  }
  a5() {
    this.zap_1.a5();
    this.aaq_1.a5();
  }
  toString() {
    return 'XWithWind(' + this.zap_1.toString() + ', ' + this.aaq_1.toString() + ')';
  }
}
class IntArrayListSort extends SortOps {
  constructor() {
    IntArrayListSort_instance = null;
    super();
    IntArrayListSort_instance = this;
  }
  caq(subject, l, r) {
    return compareTo(subject.zap_1.j9u(l), subject.zap_1.j9u(r));
  }
  wa3(subject, l, r) {
    return this.caq(subject instanceof XWithWind ? subject : THROW_CCE(), l, r);
  }
  daq(subject, indexL, indexR) {
    subject.zap_1.qa2(indexL, indexR);
    subject.aaq_1.qa2(indexL, indexR);
  }
  ya3(subject, indexL, indexR) {
    return this.daq(subject instanceof XWithWind ? subject : THROW_CCE(), indexL, indexR);
  }
}
class RastScale {
  paq() {
    return 20;
  }
  qaq() {
    return 0;
  }
  xap(_this__u8e3s4) {
    return numberToInt(_this__u8e3s4 * this.paq()) + this.qaq() | 0;
  }
}
class PolygonScanline extends RastScale {
  constructor() {
    super();
    this.fap_1 = -1;
    this.gap_1 = Winding_NON_ZERO_getInstance();
    this.hap_1 = Companion_getInstance_4().e9i();
    var tmp = this;
    tmp.iap_1 = Pool.ha8(VOID, PolygonScanline$edgesPool$lambda);
    this.jap_1 = FastArrayList.f9v();
    this.kap_1 = FastArrayList.f9v();
    this.lap_1 = FastArrayList.f9v();
    this.map_1 = new AllBuckets();
    this.nap_1 = true;
    this.oap_1 = new PointArrayList();
    this.pap_1 = 0.0;
    this.qap_1 = 0.0;
    this.rap_1 = 0.0;
    this.sap_1 = 0.0;
    this.tap_1 = false;
    this.uap_1 = new XWithWind();
    this.vap_1 = 0;
    this.wap_1 = new IntSegmentSet();
  }
  faf() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(this.hap_1);
  }
  ra8() {
    this.nap_1 = true;
    this.hap_1 = Companion_getInstance_4().z9h_1;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.jap_1.d9v_1;
    var n = 0;
    while (n < array.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.iap_1.ka8(it);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.kap_1.d9v_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_0 = array_0[_unary__edvuaz_0];
      this.iap_1.ka8(it_0);
    }
    this.jap_1.a5();
    this.kap_1.a5();
    this.lap_1.a5();
    this.oap_1.sh();
    this.map_1.a5();
    this.pap_1 = 0.0;
    this.qap_1 = 0.0;
    this.rap_1 = 0.0;
    this.sap_1 = 0.0;
    this.tap_1 = false;
  }
  faq() {
    return this.jap_1.s2();
  }
  o9j() {
    return this.faq() > 0;
  }
  gaq(x, y) {
    this.rap_1 = x;
    this.sap_1 = y;
    this.pap_1 = x;
    this.qap_1 = y;
    this.tap_1 = true;
  }
  haq(x, y) {
    if (this.tap_1) {
      addPoint(this, this.rap_1, this.sap_1);
    }
    addEdge(this, this.rap_1, this.sap_1, x, y);
    addPoint(this, x, y);
    this.rap_1 = x;
    this.sap_1 = y;
    this.tap_1 = false;
  }
  gah(p) {
    return this.gaq(p.r9g_1, p.s9g_1);
  }
  iah(p) {
    return this.haq(p.r9g_1, p.s9g_1);
  }
  iaq(path) {
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.y9j();
    var l = Vector2D.y9j();
    if (false) {
      this.f7();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.nah_1;
    var n_0 = 0;
    while (n_0 < this_0.s2()) {
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.j9u(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.oah_1.u2(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.t9g(tmp, path.oah_1.u2(_unary__edvuaz_1));
          i = it;
          this.eaq(it, true);
          l = it;
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.oah_1.u2(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.t9g(tmp_0, path.oah_1.u2(_unary__edvuaz_3));
          this.eaq(it_0, false);
          l = it_0;
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.oah_1.u2(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var tmp0 = Vector2D.t9g(tmp_1, path.oah_1.u2(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.oah_1.u2(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.t9g(tmp_2, path.oah_1.u2(_unary__edvuaz_7));
          var sum = Companion_getInstance().z9s(l, tmp0) + Companion_getInstance().z9s(tmp0, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.y9j()};
          var prevPos = {_v: Vector2D.y9j()};
          var emittedCount = {_v: 0};
          var tmp0_0 = Companion_getInstance_6().w9f_1;
          PolygonScanline$add$lambda(lastPos)(Companion_getInstance_8().nae(l, tmp0, a, tmp0_0));
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              PolygonScanline$add$lambda_0(this, emittedCount, lastPos, prevPos)(Companion_getInstance_8().nae(l, tmp0, a, ratio));
            }
             while (!(n_1 === nEnd));
          l = a;
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.oah_1.u2(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var tmp0_1 = Vector2D.t9g(tmp_3, path.oah_1.u2(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.oah_1.u2(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var tmp2 = Vector2D.t9g(tmp_4, path.oah_1.u2(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.oah_1.u2(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.t9g(tmp_5, path.oah_1.u2(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance().z9s(l, tmp0_1) + Companion_getInstance().z9s(tmp0_1, tmp2) + Companion_getInstance().z9s(tmp2, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.y9j()};
          var prevPos_0 = {_v: Vector2D.y9j()};
          var emittedCount_0 = {_v: 0};
          var tmp0_2 = Companion_getInstance_6().w9f_1;
          PolygonScanline$add$lambda_1(lastPos_0)(Companion_getInstance_8().mae(l, tmp0_1, tmp2, a_1, tmp0_2));
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              PolygonScanline$add$lambda_2(this, emittedCount_0, lastPos_0, prevPos_0)(Companion_getInstance_8().mae(l, tmp0_1, tmp2, a_1, ratio_0));
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          break;
        case 4:
          var p = i;
          this.eaq(p, false);
          if (true) {
            this.f7();
          }

          break;
      }
    }
    if (false) {
      this.f7();
    }
  }
  eaq(p, move) {
    var tmp;
    if (move) {
      this.gah(p);
      tmp = Unit_instance;
    } else {
      this.iah(p);
      tmp = Unit_instance;
    }
    return tmp;
  }
  jaq(x, y, move) {
    var tmp;
    if (move) {
      this.gaq(x, y);
      tmp = Unit_instance;
    } else {
      this.haq(x, y);
      tmp = Unit_instance;
    }
    return tmp;
  }
  f7() {
    this.haq(this.pap_1, this.qap_1);
  }
  kaq(y, winding, out) {
    this.vap_1 = 0;
    this.uap_1.a5();
    out.sh();
    var tmp = this;
    var tmp_0 = this.vap_1;
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY' call
    var edgesChecked = 0;
    // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY' call
    var this_0 = access$_get_buckets__joe3tk(this);
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_1 = this_0.bap_1;
    if (this_1.s2() > 0) {
      var tmp47_safe_receiver = this_1.lao(y);
      if (tmp47_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = tmp47_safe_receiver.fao_1.d9v_1;
        var n = 0;
        while (n < array.length) {
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var edge = array[_unary__edvuaz];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge.maq(y)) {
            if (!edge.uao_1) {
              this.uap_1.baq(edge.laq(y), edge.rao_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_2 = this_0.cap_1;
    if (this_2.s2() > 0) {
      var tmp47_safe_receiver_0 = this_2.lao(y);
      if (tmp47_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp47_safe_receiver_0.fao_1.d9v_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var edge_0 = array_0[_unary__edvuaz_0];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_0.maq(y)) {
            if (!edge_0.uao_1) {
              this.uap_1.baq(edge_0.laq(y), edge_0.rao_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_3 = this_0.dap_1;
    if (this_3.s2() > 0) {
      var tmp47_safe_receiver_1 = this_3.lao(y);
      if (tmp47_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_1 = tmp47_safe_receiver_1.fao_1.d9v_1;
        var n_1 = 0;
        while (n_1 < array_1.length) {
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var edge_1 = array_1[_unary__edvuaz_1];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_1.maq(y)) {
            if (!edge_1.uao_1) {
              this.uap_1.baq(edge_1.laq(y), edge_1.rao_1);
            }
          }
        }
      }
    }
    tmp.vap_1 = tmp_0 + edgesChecked | 0;
    genericSort(this.uap_1, 0, this.uap_1.s2() - 1 | 0, IntArrayListSort_getInstance());
    var tempX = this.uap_1.zap_1;
    var tempW = this.uap_1.aaq_1;
    if (this.uap_1.s2() >= 2) {
      switch (winding.w1_1) {
        case 0:
          var progression = step(until(0, tempX.s2() - 1 | 0), 2);
          var inductionVariable = progression.n3_1;
          var last = progression.o3_1;
          var step_0 = progression.p3_1;
          if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + step_0 | 0;
              var a = tempX.j9u(i);
              var b = tempX.j9u(i + 1 | 0);
              out.dab(a, b);
            }
             while (!(i === last));
          break;
        case 1:
          var count = 0;
          var startX = 0;
          var endX = 0;
          var pending = false;
          var inductionVariable_0 = 0;
          var last_0 = tempX.s2() - 1 | 0;
          if (inductionVariable_0 < last_0)
            do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var a_0 = tempX.j9u(i_0);
              count = count + tempW.j9u(i_0) | 0;
              var b_0 = tempX.j9u(i_0 + 1 | 0);
              if (!(count === 0)) {
                if (pending && !(a_0 === endX)) {
                  out.dab(startX, endX);
                  startX = a_0;
                  endX = b_0;
                } else {
                  if (!pending) {
                    startX = a_0;
                  }
                  endX = b_0;
                }
                pending = true;
              }
            }
             while (inductionVariable_0 < last_0);
          if (pending) {
            out.dab(startX, endX);
          }

          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    return out;
  }
  naq(x, y, winding) {
    return this.oaq(this.xap(x), this.xap(y), winding);
  }
  oaq(x, y, winding) {
    var ss = this.wap_1;
    this.kaq(y, winding, ss.sh());
    return ss.as(x);
  }
}
class Companion_10 {
  constructor() {
    this.raq_1 = 20;
    this.saq_1 = 0;
    this.taq_1 = 80;
    this.uaq_1 = 320;
    this.vaq_1 = 1280;
  }
}
class Companion_11 {
  waq(a, b) {
    // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY' call
    var Ax = a.nao_1;
    var Ay = a.oao_1;
    var Bx = a.pao_1;
    var By = a.qao_1;
    var Cx = b.nao_1;
    var Cy = b.oao_1;
    var Dx = b.pao_1;
    var Dy = b.qao_1;
    var tmp52_safe_receiver = this.xaq(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
    var tmp;
    if (tmp52_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = Vector2I.e9r(numberToInt(floorCeil(tmp52_safe_receiver.r9g_1)), numberToInt(floorCeil(tmp52_safe_receiver.s9g_1)));
    }
    var tmp51_safe_receiver = tmp;
    var tmp_0;
    if (tmp51_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = Vector2D.a9k(tmp51_safe_receiver.b9r_1, tmp51_safe_receiver.c9r_1);
    }
    return tmp_0;
  }
  yaq(a, b) {
    return Angle__minus_impl_xeau7k(b.zaq(), a.zaq());
  }
  xaq(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    return Companion_instance_20.xaq(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
  }
}
class MEdge {
  constructor() {
    this.nao_1 = 0;
    this.oao_1 = 0;
    this.pao_1 = 0;
    this.qao_1 = 0;
    this.rao_1 = 0;
    this.sao_1 = 0;
    this.tao_1 = 0;
    this.uao_1 = false;
    this.vao_1 = false;
    this.wao_1 = 0;
  }
  l9j(n) {
    return n === 0 ? this.nao_1 : this.pao_1;
  }
  m9j(n) {
    return n === 0 ? this.oao_1 : this.qao_1;
  }
  aar(other) {
    return this.yap(other.nao_1, other.oao_1, other.pao_1, other.qao_1, other.rao_1);
  }
  yap(ax, ay, bx, by, wind) {
    // Inline function 'kotlin.apply' call
    this.nao_1 = ax;
    this.oao_1 = ay;
    this.pao_1 = bx;
    this.qao_1 = by;
    this.tao_1 = bx - ax | 0;
    this.sao_1 = by - ay | 0;
    this.uao_1 = ay === by;
    this.vao_1 = ax === bx;
    this.rao_1 = wind;
    this.wao_1 = this.vao_1 ? 0 : ay - (imul(ax, this.sao_1) / this.tao_1 | 0) | 0;
    return this;
  }
  xao() {
    var tmp0 = this.oao_1;
    // Inline function 'kotlin.math.min' call
    var b = this.qao_1;
    return Math.min(tmp0, b);
  }
  yao() {
    var tmp0 = this.oao_1;
    // Inline function 'kotlin.math.max' call
    var b = this.qao_1;
    return Math.max(tmp0, b);
  }
  maq(y) {
    return y >= this.oao_1 && y < this.qao_1;
  }
  laq(y) {
    return this.vao_1 || this.sao_1 === 0 ? this.nao_1 : imul(y - this.wao_1 | 0, this.tao_1) / this.sao_1 | 0;
  }
  zaq() {
    Companion_getInstance_0();
    var tmp2 = this.nao_1;
    var tmp4 = this.oao_1;
    var tmp6 = this.pao_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var y1 = this.qao_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var up = Companion_getInstance().k9h_1;
    return Angle_between(tmp2, tmp4, tmp6, y1, up);
  }
  toString() {
    return 'Edge([' + this.nao_1 + ',' + this.oao_1 + ']-[' + this.pao_1 + ',' + this.qao_1 + '])';
  }
}
class EdgePoint extends Enum {
  constructor(name, ordinal, n) {
    super(name, ordinal);
    this.var_1 = n;
  }
}
class StrokeToFill {
  constructor() {
    this.bar_1 = 1;
    this.dar_1 = LineCap_BUTT_getInstance();
    this.ear_1 = LineCap_BUTT_getInstance();
    this.far_1 = LineJoin_BEVEL_getInstance();
    this.gar_1 = 4.0;
    this.har_1 = new PointIntArrayList(1024);
    this.iar_1 = IntArrayList.za1(1024);
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(2);
    while (tmp_0 < 2) {
      tmp_1[tmp_0] = new PointIntArrayList(1024);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.jar_1 = tmp_1;
    this.kar_1 = this.jar_1[0];
    this.lar_1 = this.jar_1[1];
    this.mar_1 = new MEdge();
    this.nar_1 = new MEdge();
    this.oar_1 = new MEdge();
    this.par_1 = new MEdge();
    this.qar_1 = new MEdge();
    this.rar_1 = new MEdge();
  }
  xar(_this__u8e3s4, edge, width, angle) {
    // Inline function 'kotlin.apply' call
    var ldx = width * _Angle___get_cosine__impl__vprvmu(angle);
    var ldy = width * _Angle___get_sine__impl__15nmyi(angle);
    _this__u8e3s4.yap(numberToInt(edge.nao_1 + ldx), numberToInt(edge.oao_1 + ldy), numberToInt(edge.pao_1 + ldx), numberToInt(edge.qao_1 + ldy), edge.rao_1);
    return _this__u8e3s4;
  }
  yar(_this__u8e3s4, e) {
    return _this__u8e3s4.dab(e.nao_1, e.oao_1);
  }
  zar(_this__u8e3s4, e) {
    return _this__u8e3s4.dab(e.pao_1, e.qao_1);
  }
  aas(_this__u8e3s4, e) {
    _this__u8e3s4.dab(numberToInt(e.r9g_1), numberToInt(e.s9g_1));
  }
  bas(out, mainPrev, mainCurr, prev, curr, join, miterLimit, scale, forcedMiter) {
    var rjoin = forcedMiter ? LineJoin_MITER_getInstance() : join;
    switch (rjoin.w1_1) {
      case 2:
        var intersection2 = Vector2D.a9k(mainPrev.pao_1, mainPrev.qao_1);
        var intersection = Companion_instance_11.waq(prev, curr);
        if (!(intersection == null)) {
          var dist = Companion_getInstance().z9s(intersection, intersection2);
          if (forcedMiter || dist <= miterLimit) {
            out.eab(toInt(intersection));
          } else {
            this.zar(out, prev);
            this.yar(out, curr);
          }
        }

        break;
      case 0:
        this.zar(out, prev);
        this.yar(out, curr);
        break;
      case 1:
        var i = Companion_instance_11.waq(prev, curr);
        if (!(i == null)) {
          var count = clamp_0(numberToInt(Companion_getInstance().y9s(prev.pao_1, prev.qao_1, curr.nao_1, curr.oao_1) * scale), 4, 64);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.aas(out, Companion_getInstance_8().nae(Vector2D.t9g(prev.pao_1, prev.qao_1), Vector2D.t9g(i.r9g_1, i.s9g_1), Vector2D.t9g(curr.nao_1, curr.oao_1), _Ratio___init__impl__9mwvn2(n / count)));
            }
             while (!(n === count));
        } else {
          this.zar(out, prev);
          this.yar(out, curr);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  cas(l, r, left, right, epoint, cap, scale) {
    var angle = epoint.equals(EdgePoint_A_getInstance()) ? Angle__unaryMinus_impl_7901fr(left.zaq()) : Angle__unaryPlus_impl_eyi5pl(left.zaq());
    var lx = left.l9j(epoint.var_1);
    var ly = left.m9j(epoint.var_1);
    var rx = right.l9j(epoint.var_1);
    var ry = right.m9j(epoint.var_1);
    switch (cap.w1_1) {
      case 0:
        l.dab(lx, ly);
        r.dab(rx, ry);
        break;
      case 2:
      case 1:
        var ax = numberToInt(_Angle___get_cosine__impl__vprvmu(angle) * this.bar_1 / 2);
        var ay = numberToInt(_Angle___get_sine__impl__15nmyi(angle) * this.bar_1 / 2);
        var lx2 = lx + ax | 0;
        var ly2 = ly + ay | 0;
        var rx2 = rx + ax | 0;
        var ry2 = ry + ay | 0;
        if (cap.equals(LineCap_SQUARE_getInstance())) {
          l.dab(lx2, ly2);
          r.dab(rx2, ry2);
        } else {
          var count = clamp_0(numberToInt(Companion_getInstance_27().y9s(lx, ly, rx, ry) * scale), 4, 64);
          l.dab(lx, ly);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var m = epoint.equals(EdgePoint_A_getInstance()) ? n : count - n | 0;
              var ratio = _Ratio___init__impl__9mwvn2(m / count);
              this.aas(r, Companion_getInstance_8().mae(Vector2D.t9g(lx, ly), Vector2D.t9g(lx2, ly2), Vector2D.t9g(rx2, ry2), Vector2D.t9g(rx, ry), ratio));
            }
             while (!(n === count));
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  war(scale, closed) {
    if (this.har_1.n1())
      return Unit_instance;
    var weightD2 = this.bar_1 / 2 | 0;
    this.kar_1.a5();
    this.lar_1.a5();
    var sp = this.har_1;
    var nstrokePoints = sp.s2();
    var inductionVariable = 0;
    if (inductionVariable < nstrokePoints)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var isFirst = n === 0;
        var isLast = n === (nstrokePoints - 1 | 0);
        var isMiddle = !isFirst && (!isLast || closed);
        var n1 = isLast ? closed ? 1 : n : n + 1 | 0;
        this.mar_1.aar(this.par_1);
        this.nar_1.aar(this.qar_1);
        this.oar_1.aar(this.rar_1);
        var doJoin = !(this.iar_1.j9u(n) === 0);
        this.par_1.yap(sp.l9j(n), sp.m9j(n), sp.l9j(n1), sp.m9j(n1), 1);
        this.xar(this.qar_1, this.par_1, weightD2, Angle__minus_impl_xeau7k(this.par_1.zaq(), get_degrees(90)));
        this.xar(this.rar_1, this.par_1, weightD2, Angle__plus_impl_26v37k(this.par_1.zaq(), get_degrees(90)));
        if (isFirst) {
          this.cas(this.kar_1, this.lar_1, this.qar_1, this.rar_1, EdgePoint_A_getInstance(), closed ? LineCap_BUTT_getInstance() : this.dar_1, scale);
        } else if (isMiddle) {
          var angle = Companion_instance_11.yaq(this.mar_1, this.par_1);
          var leftAngle = Angle__compareTo_impl_a0hfds(angle, get_degrees(0)) > 0;
          if (doJoin) {
            this.bas(this.kar_1, this.mar_1, this.par_1, this.nar_1, this.qar_1, this.far_1, this.gar_1, scale, leftAngle);
            this.bas(this.lar_1, this.mar_1, this.par_1, this.oar_1, this.rar_1, this.far_1, this.gar_1, scale, !leftAngle);
          } else {
            this.yar(this.kar_1, this.qar_1);
            this.yar(this.lar_1, this.rar_1);
          }
        } else if (isLast) {
          if (closed) {
            this.cas(this.kar_1, this.lar_1, this.qar_1, this.rar_1, EdgePoint_B_getInstance(), LineCap_BUTT_getInstance(), scale);
          } else {
            this.cas(this.kar_1, this.lar_1, this.nar_1, this.oar_1, EdgePoint_B_getInstance(), this.ear_1, scale);
          }
        }
      }
       while (inductionVariable < nstrokePoints);
    var inductionVariable_0 = 0;
    var last = this.kar_1.s2();
    if (inductionVariable_0 < last)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var x = this.kar_1.l9j(n_0);
        var y = this.kar_1.m9j(n_0);
        if (n_0 === 0) {
          _get_outFill__zcv64g(this).gah(Vector2D.t9g(x * scale, y * scale));
        } else {
          _get_outFill__zcv64g(this).iah(Vector2D.t9g(x * scale, y * scale));
        }
      }
       while (inductionVariable_0 < last);
    var inductionVariable_1 = 0;
    var last_0 = this.lar_1.s2();
    if (inductionVariable_1 < last_0)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var m = (this.lar_1.s2() - n_1 | 0) - 1 | 0;
        _get_outFill__zcv64g(this).iah(Vector2D.t9g(this.lar_1.l9j(m) * scale, this.lar_1.m9j(m) * scale));
      }
       while (inductionVariable_1 < last_0);
    _get_outFill__zcv64g(this).f7();
    _get_outFill__zcv64g(this).pah_1 = Winding_NON_ZERO_getInstance();
    this.har_1.a5();
    this.iar_1.a5();
  }
  kas(outFill, weight, startCap, endCap, joins, miterLimit) {
    this.car_1 = outFill;
    this.bar_1 = weight;
    this.dar_1 = startCap;
    this.ear_1 = endCap;
    this.far_1 = joins;
    this.gar_1 = miterLimit * weight;
  }
  sar(stroke, lineWidth, joins, startCap, endCap, miterLimit, outFill) {
    var scale = 20;
    var iscale = 1.0 / 20;
    this.kas(outFill, numberToInt(lineWidth * scale), startCap, endCap, joins, miterLimit);
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.y9j();
    var l = Vector2D.y9j();
    if (false) {
      this.war(iscale, true);
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = stroke.nah_1;
    var n_0 = 0;
    while (n_0 < this_0.s2()) {
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.j9u(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = stroke.oah_1.u2(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.t9g(tmp, stroke.oah_1.u2(_unary__edvuaz_1));
          i = it;
          if (true) {
            this.war(iscale, false);
          }

          this.har_1.dab(numberToInt(it.r9g_1 * scale), numberToInt(it.s9g_1 * scale));
          this.iar_1.ga2(0);
          l = it;
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = stroke.oah_1.u2(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.t9g(tmp_0, stroke.oah_1.u2(_unary__edvuaz_3));
          if (false) {
            this.war(iscale, false);
          }

          this.har_1.dab(numberToInt(it_0.r9g_1 * scale), numberToInt(it_0.s9g_1 * scale));
          this.iar_1.ga2(0);
          l = it_0;
          this.iar_1.s7x(this.iar_1.s2() - 1 | 0, 1);
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = stroke.oah_1.u2(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var tmp0 = Vector2D.t9g(tmp_1, stroke.oah_1.u2(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = stroke.oah_1.u2(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.t9g(tmp_2, stroke.oah_1.u2(_unary__edvuaz_7));
          var sum = Companion_getInstance().z9s(l, tmp0) + Companion_getInstance().z9s(tmp0, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.y9j()};
          var prevPos = {_v: Vector2D.y9j()};
          var emittedCount = {_v: 0};
          var tmp0_0 = Companion_getInstance_6().w9f_1;
          StrokeToFill$strokeFill$lambda(lastPos)(Companion_getInstance_8().nae(l, tmp0, a, tmp0_0));
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              StrokeToFill$strokeFill$lambda_0(this, iscale, scale, emittedCount, lastPos, prevPos)(Companion_getInstance_8().nae(l, tmp0, a, ratio));
            }
             while (!(n_1 === nEnd));
          l = a;
          this.iar_1.s7x(this.iar_1.s2() - 1 | 0, 1);
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = stroke.oah_1.u2(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var tmp0_1 = Vector2D.t9g(tmp_3, stroke.oah_1.u2(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = stroke.oah_1.u2(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var tmp2 = Vector2D.t9g(tmp_4, stroke.oah_1.u2(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = stroke.oah_1.u2(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.t9g(tmp_5, stroke.oah_1.u2(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance().z9s(l, tmp0_1) + Companion_getInstance().z9s(tmp0_1, tmp2) + Companion_getInstance().z9s(tmp2, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.y9j()};
          var prevPos_0 = {_v: Vector2D.y9j()};
          var emittedCount_0 = {_v: 0};
          var tmp0_2 = Companion_getInstance_6().w9f_1;
          StrokeToFill$strokeFill$lambda_1(lastPos_0)(Companion_getInstance_8().mae(l, tmp0_1, tmp2, a_1, tmp0_2));
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              StrokeToFill$strokeFill$lambda_2(this, iscale, scale, emittedCount_0, lastPos_0, prevPos_0)(Companion_getInstance_8().mae(l, tmp0_1, tmp2, a_1, ratio_0));
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          this.iar_1.s7x(this.iar_1.s2() - 1 | 0, 1);
          break;
        case 4:
          var p = i;
          if (false) {
            this.war(iscale, false);
          }

          this.har_1.dab(numberToInt(p.r9g_1 * scale), numberToInt(p.s9g_1 * scale));
          this.iar_1.ga2(0);
          this.iar_1.s7x(this.iar_1.s2() - 1 | 0, 1);
          if (true) {
            this.war(iscale, true);
          }

          break;
      }
    }
    if (false) {
      this.war(iscale, true);
    }
    this.war(iscale, false);
  }
}
class VectorBuilder {}
function quadTo(c, a) {
  var tmp0 = Companion_getInstance_8();
  var tmp2 = this.hah().r9g_1;
  var tmp4 = this.hah().s9g_1;
  var tmp6 = c.r9g_1;
  var tmp8 = c.s9g_1;
  var tmp10 = a.r9g_1;
  // Inline function 'korlibs.math.geom.bezier.Companion.quadToCubic' call
  var y1 = a.s9g_1;
  var tmp4_0 = tmp0.oae(tmp2, tmp6);
  var tmp6_0 = tmp0.oae(tmp4, tmp8);
  var tmp8_0 = tmp0.pae(tmp6, tmp10);
  var cy2 = tmp0.pae(tmp8, y1);
  this.lah(Vector2D.t9g(tmp4_0, tmp6_0), Vector2D.t9g(tmp8_0, cy2), Vector2D.t9g(tmp10, y1));
}
function line(p0, p1) {
  this.gah(p0);
  this.iah(p1);
}
function arcTo(a, c, r) {
  return Arc_instance.fah(this, a, c, r);
}
function isEmpty() {
  return this.pas() === 0;
}
function isNotEmpty() {
  return !(this.pas() === 0);
}
function rect(rect) {
  return this.uas(rect.o9h_1, rect.p9h_1, rect.q9h_1, rect.r9h_1);
}
function rect_0(pos, size) {
  this.uas(pos.r9g_1, pos.s9g_1, size.j9i_1, size.k9i_1);
}
function rect_1(x, y, width, height) {
  this.gah(Vector2D.t9g(x, y));
  this.iah(Vector2D.t9g(x + width, y));
  this.iah(Vector2D.t9g(x + width, y + height));
  this.iah(Vector2D.t9g(x, y + height));
  this.f7();
}
function roundRect(x, y, w, h, rtl, rtr, rbr, rbl) {
  if (rtl === 0.0 && rtr === 0.0 && rbr === 0.0 && rbl === 0.0) {
    this.uas(x, y, w, h);
  } else {
    this.gah(Vector2D.t9g(x + rtl, y));
    this.ras(Vector2D.t9g(x + w, y), Vector2D.t9g(x + w, y + h), rtr);
    this.ras(Vector2D.t9g(x + w, y + h), Vector2D.t9g(x, y + h), rbr);
    this.ras(Vector2D.t9g(x, y + h), Vector2D.t9g(x, y), rbl);
    this.ras(Vector2D.t9g(x, y), Vector2D.t9g(x + w, y), rtl);
    this.f7();
  }
}
function roundRect_0(rect) {
  var r = rect.j9r_1;
  var c = rect.k9r_1;
  this.vas(r.o9h_1, r.p9h_1, r.q9h_1, r.r9h_1, c.n9p_1, c.o9p_1, c.q9p_1, c.p9p_1);
}
function arc(center, r, start, end, counterclockwise) {
  return Arc_instance.kah(this, center, numberToDouble(r), start, end, counterclockwise);
}
function arc$default(center, r, start, end, counterclockwise, $super) {
  counterclockwise = counterclockwise === VOID ? false : counterclockwise;
  var tmp;
  if ($super === VOID) {
    this.was(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  } else {
    arc(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  }
  return tmp;
}
function circle(center, radius) {
  return this.xas(center, radius, Companion_getInstance_0().x9g_1, Companion_getInstance_0().b9h_1);
}
function rMoveTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.hah();
  var tmp$ret$0 = Vector2D.t9g(this_0.r9g_1 + delta.r9g_1, this_0.s9g_1 + delta.s9g_1);
  return this.gah(tmp$ret$0);
}
function rLineTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.hah();
  var tmp$ret$0 = Vector2D.t9g(this_0.r9g_1 + delta.r9g_1, this_0.s9g_1 + delta.s9g_1);
  return this.iah(tmp$ret$0);
}
function transformed(m) {
  var im = m.h9m();
  var parent = this;
  return new VectorBuilder$transformed$1(parent, im, m);
}
function transformed_0(m, block) {
  return block(this.v9q(m));
}
class VectorBuilder$transformed$1 {
  constructor($parent, $im, $m) {
    this.mas_1 = $parent;
    this.nas_1 = $im;
    this.oas_1 = $m;
    this.las_1 = $parent.pas();
  }
  hah() {
    var tmp0 = this.nas_1;
    var tmp2 = this.mas_1.hah();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      if (tmp0.t9h()) {
        tmp$ret$0 = tmp2;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.t9g(tmp0.m9l(tmp2.r9g_1, tmp2.s9g_1), tmp0.p9l(tmp2.r9g_1, tmp2.s9g_1));
    }
    return tmp$ret$0;
  }
  pas() {
    return this.las_1;
  }
  f7() {
    return this.mas_1.f7();
  }
  iah(p) {
    return this.mas_1.iah(t(this, p));
  }
  gah(p) {
    return this.mas_1.iah(t(this, p));
  }
  jah(c, a) {
    return this.mas_1.jah(t(this, c), t(this, a));
  }
  lah(c1, c2, a) {
    return this.mas_1.lah(t(this, c1), t(this, c2), t(this, a));
  }
}
class Companion_12 {}
class Visitor {}
function close() {
  return Unit_instance;
}
function moveTo(p) {
  return Unit_instance;
}
function lineTo(p) {
  return Unit_instance;
}
function quadTo_0(c, a) {
  return Unit_instance;
}
function cubicTo(c1, c2, a) {
  return Unit_instance;
}
class VectorPath extends AbstractShape2D {
  constructor(commands, data, winding, optimize) {
    commands = commands === VOID ? IntArrayList.za1() : commands;
    data = data === VOID ? DoubleArrayList.ga3() : data;
    winding = winding === VOID ? Companion_instance_14.cat() : winding;
    optimize = optimize === VOID ? true : optimize;
    super();
    this.mah_1 = new Mixin();
    this.nah_1 = commands;
    this.oah_1 = data;
    this.pah_1 = winding;
    this.qah_1 = optimize;
    this.rah_1 = false;
    this.sah_1 = 0;
    this.tah_1 = Vector2D.y9j();
    this.uah_1 = Vector2D.y9j();
    this.vah_1 = null;
    this.wah_1 = null;
  }
  o9u(_set____db54di) {
    this.mah_1.o9u(_set____db54di);
  }
  p9u() {
    return this.mah_1.p9u();
  }
  g9m() {
    return new VectorPath(IntArrayList.ca2(this.nah_1), DoubleArrayList.ha3(this.oah_1), this.pah_1);
  }
  equals(other) {
    if (this === other)
      return true;
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof VectorPath) {
      tmp_1 = this.nah_1.equals(other.nah_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.oah_1.equals(other.oah_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.pah_1.equals(other.pah_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return (this.nah_1.hashCode() + imul(this.oah_1.hashCode(), 13) | 0) + imul(this.pah_1.w1_1, 111) | 0;
  }
  dat(visitor) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.nah_1;
    var n_0 = 0;
    while (n_0 < this_0.s2()) {
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.j9u(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.oah_1.u2(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var p0 = Vector2D.t9g(tmp, this.oah_1.u2(_unary__edvuaz_1));
          visitor.gah(p0);
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.oah_1.u2(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var p0_0 = Vector2D.t9g(tmp_0, this.oah_1.u2(_unary__edvuaz_3));
          visitor.iah(p0_0);
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.oah_1.u2(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var tmp2 = Vector2D.t9g(tmp_1, this.oah_1.u2(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.oah_1.u2(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p1 = Vector2D.t9g(tmp_2, this.oah_1.u2(_unary__edvuaz_7));
          visitor.jah(tmp2, p1);
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.oah_1.u2(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var tmp2_0 = Vector2D.t9g(tmp_3, this.oah_1.u2(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.oah_1.u2(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var tmp4 = Vector2D.t9g(tmp_4, this.oah_1.u2(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.oah_1.u2(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p2 = Vector2D.t9g(tmp_5, this.oah_1.u2(_unary__edvuaz_13));
          visitor.lah(tmp2_0, tmp4, p2);
          break;
        case 4:
          visitor.f7();
          break;
      }
    }
  }
  a5() {
    this.nah_1.a5();
    this.oah_1.a5();
    this.tah_1 = Vector2D.y9j();
    this.sah_1 = 0;
    this.eat().fap_1 = this.sah_1 - 1 | 0;
  }
  hah() {
    return this.tah_1;
  }
  gah(p) {
    if (this.nah_1.o9j() && this.nah_1.oa2() === 0) {
      if (this.tah_1.equals(p))
        return Unit_instance;
    }
    this.nah_1.ga2(0);
    this.oah_1.ma3(p.r9g_1, p.s9g_1);
    this.tah_1 = p;
    this.uah_1 = p;
    this.sah_1 = this.sah_1 + 1 | 0;
  }
  iah(p) {
    if (ensureMoveTo(this, p) && this.qah_1)
      return Unit_instance;
    if (p.equals(this.tah_1) && this.qah_1)
      return Unit_instance;
    this.nah_1.ga2(1);
    this.oah_1.ma3(p.r9g_1, p.s9g_1);
    this.tah_1 = p;
    this.sah_1 = this.sah_1 + 1 | 0;
  }
  jah(c, a) {
    ensureMoveTo(this, c);
    this.nah_1.ga2(2);
    this.oah_1.na3(c.r9g_1, c.s9g_1, a.r9g_1, a.s9g_1);
    this.tah_1 = a;
    this.sah_1 = this.sah_1 + 1 | 0;
  }
  lah(c1, c2, a) {
    ensureMoveTo(this, c1);
    this.nah_1.ga2(3);
    this.oah_1.oa3(c1.r9g_1, c1.s9g_1, c2.r9g_1, c2.s9g_1, a.r9g_1, a.s9g_1);
    this.tah_1 = a;
    this.sah_1 = this.sah_1 + 1 | 0;
  }
  f7() {
    this.nah_1.ga2(4);
    this.tah_1 = this.uah_1;
    this.sah_1 = this.sah_1 + 1 | 0;
  }
  pas() {
    return this.oah_1.s2() / 2 | 0;
  }
  faf() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(plus_0(Companion_getInstance_4().e9i(), this));
  }
  fat(x, y) {
    return this.gat().naq(x, y, this.pah_1);
  }
  oat(p) {
    return this.naq(p.r9g_1, p.s9g_1, this.pah_1);
  }
  gat() {
    if (this.vah_1 == null || !(ensureNotNull(this.vah_1).hat_1 === this.sah_1)) {
      this.vah_1 = new VectorPathTrapezoids(this.sah_1, this);
    }
    return ensureNotNull(this.vah_1);
  }
  eat() {
    if (this.wah_1 == null)
      this.wah_1 = new PolygonScanline();
    var scanline = ensureNotNull(this.wah_1);
    if (!(scanline.fap_1 === this.sah_1)) {
      scanline.ra8();
      scanline.iaq(this);
      scanline.fap_1 = this.sah_1;
    }
    return ensureNotNull(this.wah_1);
  }
  naq(x, y, winding) {
    return this.eat().naq(x, y, winding);
  }
  pat(path, transform) {
    this.nah_1.ka2(path.nah_1);
    if (transform.k9l()) {
      this.oah_1.qa3(path.oah_1);
      this.tah_1 = path.tah_1;
    } else {
      var progression = step(until(0, path.oah_1.s2()), 2);
      var inductionVariable = progression.n3_1;
      var last = progression.o3_1;
      var step_0 = progression.p3_1;
      if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var tmp2 = Vector2D.t9g(path.oah_1.u2(n + 0 | 0), path.oah_1.u2(n + 1 | 0));
          var tmp$ret$0;
          $l$block: {
            // Inline function 'korlibs.math.geom.Matrix.transform' call
            if (transform.t9h()) {
              tmp$ret$0 = tmp2;
              break $l$block;
            }
            tmp$ret$0 = Vector2D.t9g(transform.m9l(tmp2.r9g_1, tmp2.s9g_1), transform.p9l(tmp2.r9g_1, tmp2.s9g_1));
          }
          var p = tmp$ret$0;
          this.oah_1.ma3(p.r9g_1, p.s9g_1);
        }
         while (!(n === last));
      var tmp = this;
      var tmp2_0 = path.tah_1;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        if (transform.t9h()) {
          tmp$ret$1 = tmp2_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.t9g(transform.m9l(tmp2_0.r9g_1, tmp2_0.s9g_1), transform.p9l(tmp2_0.r9g_1, tmp2_0.s9g_1));
      }
      tmp.tah_1 = tmp$ret$1;
    }
    this.sah_1 = this.sah_1 + 1 | 0;
  }
  qat(path, transform, $super) {
    transform = transform === VOID ? Companion_getInstance_1().v9k_1 : transform;
    var tmp;
    if ($super === VOID) {
      this.pat(path, transform);
      tmp = Unit_instance;
    } else {
      tmp = $super.pat.call(this, path, transform);
    }
    return tmp;
  }
  rat() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.nah_1;
    var n_0 = 0;
    while (n_0 < this_1.s2()) {
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.j9u(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.oah_1.u2(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.t9g(tmp, this.oah_1.u2(_unary__edvuaz_1));
          var x = destruct.jm();
          var y = destruct.km();
          this_0.m1('M' + get_niceStr(x) + ',' + get_niceStr(y) + ' ');
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.oah_1.u2(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.t9g(tmp_0, this.oah_1.u2(_unary__edvuaz_3));
          var x_0 = destruct_0.jm();
          var y_0 = destruct_0.km();
          this_0.m1('L' + get_niceStr(x_0) + ',' + get_niceStr(y_0) + ' ');
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.oah_1.u2(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var tmp0 = Vector2D.t9g(tmp_1, this.oah_1.u2(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.oah_1.u2(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_1 = Vector2D.t9g(tmp_2, this.oah_1.u2(_unary__edvuaz_7));
          var x1 = tmp0.jm();
          var y1 = tmp0.km();
          var x2 = destruct_1.jm();
          var y2 = destruct_1.km();
          this_0.m1('Q' + get_niceStr(x1) + ',' + get_niceStr(y1) + ',' + get_niceStr(x2) + ',' + get_niceStr(y2) + ' ');
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.oah_1.u2(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var tmp0_0 = Vector2D.t9g(tmp_3, this.oah_1.u2(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.oah_1.u2(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var tmp2 = Vector2D.t9g(tmp_4, this.oah_1.u2(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.oah_1.u2(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_2 = Vector2D.t9g(tmp_5, this.oah_1.u2(_unary__edvuaz_13));
          var x1_0 = tmp0_0.jm();
          var y1_0 = tmp0_0.km();
          var x2_0 = tmp2.jm();
          var y2_0 = tmp2.km();
          var x3 = destruct_2.jm();
          var y3 = destruct_2.km();
          this_0.m1('C' + get_niceStr(x1_0) + ',' + get_niceStr(y1_0) + ',' + get_niceStr(x2_0) + ',' + get_niceStr(y2_0) + ',' + get_niceStr(x3) + ',' + get_niceStr(y3) + ' ');
          break;
        case 4:
          this_0.m1('Z ');
          break;
      }
    }
    // Inline function 'kotlin.text.trimEnd' call
    var this_2 = this_0.toString();
    return toString(trimEnd(isCharSequence(this_2) ? this_2 : THROW_CCE()));
  }
  toString() {
    return 'VectorPath(' + this.rat() + ')';
  }
  sat(sx, sy) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, this.oah_1.s2()), 2);
    var inductionVariable = progression.n3_1;
    var last = progression.o3_1;
    var step_0 = progression.p3_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var it = Vector2D.t9g(this.oah_1.u2(n + 0 | 0), this.oah_1.u2(n + 1 | 0));
        var p = Vector2D.t9g(it.r9g_1 * sx, it.s9g_1 * sy);
        this.oah_1.ta3(n + 0 | 0, p.r9g_1);
        this.oah_1.ta3(n + 1 | 0, p.s9g_1);
      }
       while (!(n === last));
    this.sah_1 = this.sah_1 + 1 | 0;
    return this;
  }
}
class VectorPathTrapezoids {
  constructor(version, path, scale) {
    scale = scale === VOID ? 100 : scale;
    this.hat_1 = version;
    this.iat_1 = path;
    this.jat_1 = scale;
    this.kat_1 = imul(this.jat_1, this.jat_1);
    this.lat_1 = toSegments(this.iat_1, this.jat_1);
    var tmp = this;
    tmp.mat_1 = lazy(VectorPathTrapezoids$trapezoidsEvenOdd$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.nat_1 = lazy(VectorPathTrapezoids$trapezoidsNonZero$delegate$lambda(this));
  }
  tat() {
    var tmp0 = this.mat_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('trapezoidsEvenOdd', 1, tmp, VectorPathTrapezoids$_get_trapezoidsEvenOdd_$ref_7uws1x(), null);
    return tmp0.k3();
  }
  uat() {
    var tmp0 = this.nat_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('trapezoidsNonZero', 1, tmp, VectorPathTrapezoids$_get_trapezoidsNonZero_$ref_es11np(), null);
    return tmp0.k3();
  }
  vat(winding) {
    var tmp;
    switch (winding.w1_1) {
      case 0:
        tmp = this.tat();
        break;
      case 1:
        tmp = this.uat();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  naq(x, y, winding) {
    return this.vat(winding).ram(toIntRound(x * this.jat_1), toIntRound(y * this.jat_1));
  }
}
class with$1 {
  constructor($bb) {
    this.wat_1 = $bb;
  }
  gah(p) {
    this.wat_1._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x(this.wat_1._v.r9i_1, p));
  }
}
class Companion_13 {}
class StrokeInfo {
  constructor(thickness, pixelHinting, scaleMode, startCap, endCap, join, miterLimit, dash, dashOffset) {
    thickness = thickness === VOID ? 1.0 : thickness;
    pixelHinting = pixelHinting === VOID ? false : pixelHinting;
    scaleMode = scaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : scaleMode;
    startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
    endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
    join = join === VOID ? LineJoin_MITER_getInstance() : join;
    miterLimit = miterLimit === VOID ? 20.0 : miterLimit;
    dash = dash === VOID ? null : dash;
    dashOffset = dashOffset === VOID ? 0.0 : dashOffset;
    this.pab_1 = thickness;
    this.qab_1 = pixelHinting;
    this.rab_1 = scaleMode;
    this.sab_1 = startCap;
    this.tab_1 = endCap;
    this.uab_1 = join;
    this.vab_1 = miterLimit;
    this.wab_1 = dash;
    this.xab_1 = dashOffset;
  }
  toString() {
    return 'StrokeInfo(thickness=' + this.pab_1 + ', pixelHinting=' + this.qab_1 + ', scaleMode=' + this.rab_1.toString() + ', startCap=' + this.sab_1.toString() + ', endCap=' + this.tab_1.toString() + ', join=' + this.uab_1.toString() + ', miterLimit=' + this.vab_1 + ', dash=' + toString_0(this.wab_1) + ', dashOffset=' + this.xab_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.pab_1);
    result = imul(result, 31) + getBooleanHashCode(this.qab_1) | 0;
    result = imul(result, 31) + this.rab_1.hashCode() | 0;
    result = imul(result, 31) + this.sab_1.hashCode() | 0;
    result = imul(result, 31) + this.tab_1.hashCode() | 0;
    result = imul(result, 31) + this.uab_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.vab_1) | 0;
    result = imul(result, 31) + (this.wab_1 == null ? 0 : hashCode(this.wab_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.xab_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StrokeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof StrokeInfo ? other : THROW_CCE();
    if (!equals(this.pab_1, tmp0_other_with_cast.pab_1))
      return false;
    if (!(this.qab_1 === tmp0_other_with_cast.qab_1))
      return false;
    if (!this.rab_1.equals(tmp0_other_with_cast.rab_1))
      return false;
    if (!this.sab_1.equals(tmp0_other_with_cast.sab_1))
      return false;
    if (!this.tab_1.equals(tmp0_other_with_cast.tab_1))
      return false;
    if (!this.uab_1.equals(tmp0_other_with_cast.uab_1))
      return false;
    if (!equals(this.vab_1, tmp0_other_with_cast.vab_1))
      return false;
    if (!equals(this.wab_1, tmp0_other_with_cast.wab_1))
      return false;
    if (!equals(this.xab_1, tmp0_other_with_cast.xab_1))
      return false;
    return true;
  }
}
class Companion_14 {
  cat() {
    return Winding_NON_ZERO_getInstance();
  }
}
class Winding extends Enum {
  constructor(name, ordinal, str) {
    super(name, ordinal);
    this.zat_1 = str;
  }
}
class LineScaleMode extends Enum {
  constructor(name, ordinal, hScale, vScale) {
    super(name, ordinal);
    this.cau_1 = hScale;
    this.dau_1 = vScale;
    this.eau_1 = this.cau_1 || this.dau_1;
    this.fau_1 = (this.cau_1 && this.dau_1);
  }
}
class Companion_15 {}
class LineCap extends Enum {}
class Companion_16 {}
class LineJoin extends Enum {}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    var tmp = this;
    var tmp_0 = MMatrix$Companion$POOL$lambda;
    tmp.nau_1 = ConcurrentPool.za8(tmp_0, VOID, MMatrix$Companion$POOL$lambda_0);
  }
}
class MMatrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_26();
    a = a === VOID ? 1.0 : a;
    b = b === VOID ? 0.0 : b;
    c = c === VOID ? 0.0 : c;
    d = d === VOID ? 1.0 : d;
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.gau_1 = a;
    this.hau_1 = b;
    this.iau_1 = c;
    this.jau_1 = d;
    this.kau_1 = tx;
    this.lau_1 = ty;
  }
  x9p() {
    return new Matrix(this.gau_1, this.hau_1, this.iau_1, this.jau_1, this.kau_1, this.lau_1);
  }
  oau(a, b, c, d, tx, ty) {
    this.gau_1 = a;
    this.hau_1 = b;
    this.iau_1 = c;
    this.jau_1 = d;
    this.kau_1 = tx;
    this.lau_1 = ty;
    return this;
  }
  pau(that) {
    return this.oau(that.a9l_1, that.b9l_1, that.c9l_1, that.d9l_1, that.e9l_1, that.f9l_1);
  }
  qau(sx, sy) {
    return this.oau(this.gau_1 * sx, this.hau_1 * sx, this.iau_1 * sy, this.jau_1 * sy, this.kau_1, this.lau_1);
  }
  rau(sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    return $super === VOID ? this.qau(sx, sy) : $super.qau.call(this, sx, sy);
  }
  sau(dx, dy) {
    // Inline function 'kotlin.apply' call
    this.kau_1 = this.kau_1 + dx;
    this.lau_1 = this.lau_1 + dy;
    return this;
  }
  tau(dx, dy) {
    // Inline function 'kotlin.apply' call
    this.kau_1 = this.kau_1 + (this.gau_1 * dx + this.iau_1 * dy);
    this.lau_1 = this.lau_1 + (this.hau_1 * dx + this.jau_1 * dy);
    return this;
  }
  mau() {
    return this.oau(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
  }
  uau(ratio, l, r) {
    return this.oau(interpolate_1(ratio, l.gau_1, r.gau_1), interpolate_1(ratio, l.hau_1, r.hau_1), interpolate_1(ratio, l.iau_1, r.iau_1), interpolate_1(ratio, l.jau_1, r.jau_1), interpolate_1(ratio, l.kau_1, r.kau_1), interpolate_1(ratio, l.lau_1, r.lau_1));
  }
  vau(ratio, other) {
    return (new MMatrix()).uau(ratio, this, other);
  }
  u9f(ratio, other) {
    return this.vau(ratio, other instanceof MMatrix ? other : THROW_CCE());
  }
  toString() {
    return 'Matrix(a=' + this.gau_1 + ', b=' + this.hau_1 + ', c=' + this.iau_1 + ', d=' + this.jau_1 + ', tx=' + this.kau_1 + ', ty=' + this.lau_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.gau_1);
    result = imul(result, 31) + getNumberHashCode(this.hau_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.iau_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.jau_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.kau_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.lau_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MMatrix))
      return false;
    var tmp0_other_with_cast = other instanceof MMatrix ? other : THROW_CCE();
    if (!equals(this.gau_1, tmp0_other_with_cast.gau_1))
      return false;
    if (!equals(this.hau_1, tmp0_other_with_cast.hau_1))
      return false;
    if (!equals(this.iau_1, tmp0_other_with_cast.iau_1))
      return false;
    if (!equals(this.jau_1, tmp0_other_with_cast.jau_1))
      return false;
    if (!equals(this.kau_1, tmp0_other_with_cast.kau_1))
      return false;
    if (!equals(this.lau_1, tmp0_other_with_cast.lau_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    var tmp = this;
    var tmp_0 = MPoint$Companion$POOL$lambda;
    tmp.das_1 = ConcurrentPool.za8(tmp_0, VOID, MPoint$Companion$POOL$lambda_0);
    this.eas_1 = new MPoint(0.0, 0.0);
    this.fas_1 = new MPoint(1.0, 1.0);
    this.gas_1 = new MPoint(0.0, -1.0);
    this.has_1 = new MPoint(0.0, +1.0);
    this.ias_1 = new MPoint(-1.0, 0.0);
    this.jas_1 = new MPoint(+1.0, 0.0);
  }
  y9k() {
    return new MPoint(0.0, 0.0);
  }
  zau(lx, ly, rx, ry) {
    var ret = compareTo(ly, ry);
    return ret === 0 ? compareTo(lx, rx) : ret;
  }
  y9q(x1, y1, x2, y2) {
    var tmp0 = x1 - x2;
    // Inline function 'kotlin.math.hypot' call
    var y = y1 - y2;
    return hypot(tmp0, y);
  }
  y9s(x1, y1, x2, y2) {
    return this.y9q(x1, y1, x2, y2);
  }
  aav(aX, aY, bX, bY) {
    return aX * bX + aY * bY;
  }
}
class MPoint {
  constructor(x, y) {
    Companion_getInstance_27();
    this.wau_1 = x;
    this.xau_1 = y;
  }
  bav(other, epsilon) {
    return isAlmostEquals_0(this.wau_1, other.wau_1, epsilon) && isAlmostEquals_0(this.xau_1, other.xau_1, epsilon);
  }
  l9f(other, epsilon) {
    return this.bav(other instanceof MPoint ? other : THROW_CCE(), epsilon);
  }
  yau(x, y) {
    this.wau_1 = x;
    this.xau_1 = y;
    return this;
  }
  cav(ratio, other) {
    return Companion_getInstance_27().y9k().dav(ratio, this, other);
  }
  u9f(ratio, other) {
    return this.cav(ratio, other instanceof MPoint ? other : THROW_CCE());
  }
  dav(ratio, l, r) {
    return this.eav(ratio, l.wau_1, l.xau_1, r.wau_1, r.xau_1);
  }
  eav(ratio, lx, ly, rx, ry) {
    return this.yau(interpolate_1(ratio, lx, rx), interpolate_1(ratio, ly, ry));
  }
  fav(other) {
    return Companion_getInstance_27().zau(this.wau_1, this.xau_1, other.wau_1, other.xau_1);
  }
  d(other) {
    return this.fav(other instanceof MPoint ? other : THROW_CCE());
  }
  toString() {
    return '(' + get_niceStr(this.wau_1) + ', ' + get_niceStr(this.xau_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.wau_1);
    result = imul(result, 31) + getNumberHashCode(this.xau_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MPoint))
      return false;
    var tmp0_other_with_cast = other instanceof MPoint ? other : THROW_CCE();
    if (!equals(this.wau_1, tmp0_other_with_cast.wau_1))
      return false;
    if (!equals(this.xau_1, tmp0_other_with_cast.xau_1))
      return false;
    return true;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    var tmp_0 = MRectangle$Companion$POOL$lambda;
    tmp.kav_1 = ConcurrentPool.za8(tmp_0, VOID, MRectangle$Companion$POOL$lambda_0);
  }
  y9k() {
    return new MRectangle(0.0, 0.0, 0.0, 0.0);
  }
}
class MRectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_28();
    this.gav_1 = x;
    this.hav_1 = y;
    this.iav_1 = width;
    this.jav_1 = height;
  }
  lav(other, epsilon) {
    return isAlmostEquals_0(this.gav_1, other.gav_1, epsilon) && isAlmostEquals_0(this.hav_1, other.hav_1, epsilon) && isAlmostEquals_0(this.iav_1, other.iav_1, epsilon) && isAlmostEquals_0(this.jav_1, other.jav_1, epsilon);
  }
  l9f(other, epsilon) {
    return this.lav(other instanceof MRectangle ? other : THROW_CCE(), epsilon);
  }
  v9h() {
    return this.gav_1;
  }
  x9h() {
    return this.hav_1;
  }
  w9h() {
    return this.gav_1 + this.iav_1;
  }
  y9h() {
    return this.hav_1 + this.jav_1;
  }
  mav(x, y, width, height) {
    this.gav_1 = x;
    this.hav_1 = y;
    this.iav_1 = width;
    this.jav_1 = height;
    return this;
  }
  nav(left, top, right, bottom) {
    return this.mav(left, top, right - left, bottom - top);
  }
  oav(left, top, right, bottom) {
    return this.nav(this.v9h() - left, this.x9h() - top, this.w9h() + right, this.y9h() + bottom);
  }
  pav(left, top, right, bottom, $super) {
    top = top === VOID ? left : top;
    right = right === VOID ? left : right;
    bottom = bottom === VOID ? top : bottom;
    return $super === VOID ? this.oav(left, top, right, bottom) : $super.oav.call(this, left, top, right, bottom);
  }
  sh() {
    return this.mav(0.0, 0.0, 0.0, 0.0);
  }
  toString() {
    return 'Rectangle(x=' + get_niceStr(this.gav_1) + ', y=' + get_niceStr(this.hav_1) + ', width=' + get_niceStr(this.iav_1) + ', height=' + get_niceStr(this.jav_1) + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof MRectangle) {
      tmp_2 = isAlmostEquals_0(this.gav_1, other.gav_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = isAlmostEquals_0(this.hav_1, other.hav_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = isAlmostEquals_0(this.iav_1, other.iav_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = isAlmostEquals_0(this.jav_1, other.jav_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  qav(ratio, other) {
    return Companion_getInstance_28().y9k().rav(ratio, this, other);
  }
  u9f(ratio, other) {
    return this.qav(ratio, other instanceof MRectangle ? other : THROW_CCE());
  }
  rav(ratio, l, r) {
    return this.mav(interpolate_1(ratio, l.gav_1, r.gav_1), interpolate_1(ratio, l.hav_1, r.hav_1), interpolate_1(ratio, l.iav_1, r.iav_1), interpolate_1(ratio, l.jav_1, r.jav_1));
  }
  x9p() {
    return new Rectangle(this.gav_1, this.hav_1, this.iav_1, this.jav_1);
  }
  hashCode() {
    var result = getNumberHashCode(this.gav_1);
    result = imul(result, 31) + getNumberHashCode(this.hav_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.iav_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.jav_1) | 0;
    return result;
  }
}
class Companion_20 {
  sav(point, direction, scale, out) {
    return out.mav(point.r9g_1, point.s9g_1, point.r9g_1 + direction.r9g_1 * scale, point.s9g_1 + direction.s9g_1 * scale);
  }
  qac(point, direction, scale, out, $super) {
    scale = scale === VOID ? 1.0 : scale;
    out = out === VOID ? MLine.tav() : out;
    return $super === VOID ? this.sav(point, direction, scale, out) : $super.sav.call(this, point, direction, scale, out);
  }
  xaq(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    var a1 = By - Ay;
    var b1 = Ax - Bx;
    var c1 = a1 * Ax + b1 * Ay;
    var a2 = Dy - Cy;
    var b2 = Cx - Dx;
    var c2 = a2 * Cx + b2 * Cy;
    var determinant = a1 * b2 - a2 * b1;
    if (isAlmostZero(determinant))
      return null;
    var x = (b2 * c1 - b1 * c2) / determinant;
    var y = (a1 * c2 - a2 * c1) / determinant;
    return Vector2D.t9g(x, y);
  }
}
class MLine {
  constructor(a, b) {
    return new.target.uav(a, b);
  }
  static uav(a, b) {
    var $this = createThis(this);
    $this.rac_1 = a;
    $this.sac_1 = b;
    return $this;
  }
  g9m() {
    return MLine.uav(this.rac_1, this.sac_1);
  }
  mav(x0, y0, x1, y1) {
    this.rac_1 = Vector2D.t9g(x0, y0);
    this.sac_1 = Vector2D.t9g(x1, y1);
    return this;
  }
  tac(scale) {
    var tmp = this;
    var tmp0 = this.rac_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_0 = this.vav();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var that = Vector2D.t9g(this_0.r9g_1 * scale, this_0.s9g_1 * scale);
    tmp.rac_1 = Vector2D.t9g(tmp0.r9g_1 - that.r9g_1, tmp0.s9g_1 - that.s9g_1);
    var tmp_0 = this;
    var tmp0_0 = this.sac_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = this.vav();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var that_0 = Vector2D.t9g(this_1.r9g_1 * scale, this_1.s9g_1 * scale);
    tmp_0.sac_1 = Vector2D.t9g(tmp0_0.r9g_1 - that_0.r9g_1, tmp0_0.s9g_1 - that_0.s9g_1);
    return this;
  }
  static tav() {
    return this.uav(Vector2D.y9j(), Vector2D.y9j());
  }
  b9k() {
    return this.rac_1.r9g_1;
  }
  c9k() {
    return this.rac_1.s9g_1;
  }
  d9k() {
    return this.sac_1.r9g_1;
  }
  e9k() {
    return this.sac_1.s9g_1;
  }
  vav() {
    var tmp0 = this.sac_1;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var that = this.rac_1;
    return Vector2D.t9g(tmp0.r9g_1 - that.r9g_1, tmp0.s9g_1 - that.s9g_1);
  }
  toString() {
    return 'Line(' + this.rac_1.toString() + ', ' + this.sac_1.toString() + ')';
  }
  wav(line) {
    return Companion_instance_20.xaq(this.b9k(), this.c9k(), this.d9k(), this.e9k(), line.b9k(), line.c9k(), line.d9k(), line.e9k());
  }
  hashCode() {
    var result = this.rac_1.hashCode();
    result = imul(result, 31) + this.sac_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MLine))
      return false;
    var tmp0_other_with_cast = other instanceof MLine ? other : THROW_CCE();
    if (!this.rac_1.equals(tmp0_other_with_cast.rac_1))
      return false;
    if (!this.sac_1.equals(tmp0_other_with_cast.sac_1))
      return false;
    return true;
  }
}
class Easings extends Enum {
  toString() {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return replace(super.toString(), _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45)).toLowerCase();
  }
}
class Easings$SMOOTH extends Easings {
  constructor() {
    super('SMOOTH', 0);
    Easings_SMOOTH_instance = this;
  }
  o9f(it) {
    return it * it * (3 - 2 * it);
  }
}
class Easings$EASE_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_ELASTIC', 1);
    Easings_EASE_IN_ELASTIC_instance = this;
  }
  o9f(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        var inv = it - 1;
        var tmp_0 = -1.0;
        // Inline function 'kotlin.math.pow' call

        var x = 10.0 * inv;
        var tmp_1 = tmp_0 * Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (inv - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_1 * Math.sin(x_0);
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_ELASTIC', 2);
    Easings_EASE_OUT_ELASTIC_instance = this;
  }
  o9f(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        // Inline function 'kotlin.math.pow' call

        var x = -10.0 * it;
        var tmp_0 = Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (it - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_0 * Math.sin(x_0) + 1;
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_BOUNCE', 3);
    Easings_EASE_OUT_BOUNCE_instance = this;
  }
  o9f(it) {
    var s = 7.5625;
    var p = 2.75;
    var tmp;
    if (it < 1.0 / p) {
      // Inline function 'kotlin.math.pow' call
      tmp = s * Math.pow(it, 2.0);
    } else if (it < 2.0 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = it - 1.5 / p;
      tmp = s * Math.pow(this_0, 2.0) + 0.75;
    } else if (it < 2.5 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_1 = it - 2.25 / p;
      tmp = s * Math.pow(this_1, 2.0) + 0.9375;
    } else {
      // Inline function 'kotlin.math.pow' call
      var this_2 = it - 2.625 / p;
      tmp = s * Math.pow(this_2, 2.0) + 0.984375;
    }
    return tmp;
  }
}
class Easings$LINEAR extends Easings {
  constructor() {
    super('LINEAR', 4);
    Easings_LINEAR_instance = this;
  }
  o9f(it) {
    return it;
  }
}
class Easings$EASE extends Easings {
  constructor() {
    super('EASE', 5);
    Easings_EASE_instance = this;
    this.jaw_1 = new EasingCubic(0.25, 0.1, 0.25, 1.0, 'ease');
  }
  o9f(it) {
    return this.jaw_1.o9f(it);
  }
}
class Easings$EASE_IN extends Easings {
  constructor() {
    super('EASE_IN', 6);
    Easings_EASE_IN_instance = this;
    this.saw_1 = new EasingCubic(0.42, 0.0, 1.0, 1.0, 'ease-in');
  }
  o9f(it) {
    return this.saw_1.o9f(it);
  }
}
class Easings$EASE_OUT extends Easings {
  constructor() {
    super('EASE_OUT', 7);
    Easings_EASE_OUT_instance = this;
    this.vaw_1 = new EasingCubic(0.0, 0.0, 0.58, 1.0, 'ease-out');
  }
  o9f(it) {
    return this.vaw_1.o9f(it);
  }
}
class Easings$EASE_IN_OUT extends Easings {
  constructor() {
    super('EASE_IN_OUT', 8);
    Easings_EASE_IN_OUT_instance = this;
    this.yaw_1 = new EasingCubic(0.42, 0.0, 0.58, 1.0, 'ease-in-out');
  }
  o9f(it) {
    return this.yaw_1.o9f(it);
  }
}
class Easings$EASE_IN_OLD extends Easings {
  constructor() {
    super('EASE_IN_OLD', 9);
    Easings_EASE_IN_OLD_instance = this;
  }
  o9f(it) {
    return it * it * it;
  }
}
class Easings$EASE_OUT_OLD extends Easings {
  constructor() {
    super('EASE_OUT_OLD', 10);
    Easings_EASE_OUT_OLD_instance = this;
  }
  o9f(it) {
    // Inline function 'kotlin.let' call
    var inv = it - 1.0;
    return inv * inv * inv + 1;
  }
}
class Easings$EASE_IN_OUT_OLD extends Easings {
  constructor() {
    super('EASE_IN_OUT_OLD', 11);
    Easings_EASE_IN_OUT_OLD_instance = this;
  }
  o9f(it) {
    Companion_getInstance_7();
    var tmp4 = Easings_EASE_IN_OLD_getInstance();
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    var end = Easings_EASE_OUT_OLD_getInstance();
    return it < 0.5 ? 0.5 * tmp4.o9f(it * 2.0) : 0.5 * end.o9f((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_OLD extends Easings {
  constructor() {
    super('EASE_OUT_IN_OLD', 12);
    Easings_EASE_OUT_IN_OLD_instance = this;
  }
  o9f(it) {
    Companion_getInstance_7();
    var tmp4 = Easings_EASE_OUT_OLD_getInstance();
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    var end = Easings_EASE_IN_OLD_getInstance();
    return it < 0.5 ? 0.5 * tmp4.o9f(it * 2.0) : 0.5 * end.o9f((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BACK extends Easings {
  constructor() {
    super('EASE_IN_BACK', 13);
    Easings_EASE_IN_BACK_instance = this;
  }
  o9f(it) {
    // Inline function 'kotlin.math.pow' call
    return Math.pow(it, 2.0) * ((1.70158 + 1.0) * it - 1.70158);
  }
}
class Easings$EASE_OUT_BACK extends Easings {
  constructor() {
    super('EASE_OUT_BACK', 14);
    Easings_EASE_OUT_BACK_instance = this;
  }
  o9f(it) {
    // Inline function 'kotlin.let' call
    var inv = it - 1.0;
    // Inline function 'kotlin.math.pow' call
    return Math.pow(inv, 2.0) * ((1.70158 + 1.0) * inv + 1.70158) + 1.0;
  }
}
class Easings$EASE_IN_OUT_BACK extends Easings {
  constructor() {
    super('EASE_IN_OUT_BACK', 15);
    Easings_EASE_IN_OUT_BACK_instance = this;
  }
  o9f(it) {
    Companion_getInstance_7();
    var tmp4 = Easings_EASE_IN_BACK_getInstance();
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    var end = Easings_EASE_OUT_BACK_getInstance();
    return it < 0.5 ? 0.5 * tmp4.o9f(it * 2.0) : 0.5 * end.o9f((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BACK extends Easings {
  constructor() {
    super('EASE_OUT_IN_BACK', 16);
    Easings_EASE_OUT_IN_BACK_instance = this;
  }
  o9f(it) {
    Companion_getInstance_7();
    var tmp4 = Easings_EASE_OUT_BACK_getInstance();
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    var end = Easings_EASE_IN_BACK_getInstance();
    return it < 0.5 ? 0.5 * tmp4.o9f(it * 2.0) : 0.5 * end.o9f((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_OUT_ELASTIC', 17);
    Easings_EASE_IN_OUT_ELASTIC_instance = this;
  }
  o9f(it) {
    Companion_getInstance_7();
    var tmp4 = Easings_EASE_IN_ELASTIC_getInstance();
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    var end = Easings_EASE_OUT_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * tmp4.o9f(it * 2.0) : 0.5 * end.o9f((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_IN_ELASTIC', 18);
    Easings_EASE_OUT_IN_ELASTIC_instance = this;
  }
  o9f(it) {
    Companion_getInstance_7();
    var tmp4 = Easings_EASE_OUT_ELASTIC_getInstance();
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    var end = Easings_EASE_IN_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * tmp4.o9f(it * 2.0) : 0.5 * end.o9f((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_BOUNCE', 19);
    Easings_EASE_IN_BOUNCE_instance = this;
  }
  o9f(it) {
    return 1.0 - Easings_EASE_OUT_BOUNCE_getInstance().o9f(1.0 - it);
  }
}
class Easings$EASE_IN_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_OUT_BOUNCE', 20);
    Easings_EASE_IN_OUT_BOUNCE_instance = this;
  }
  o9f(it) {
    Companion_getInstance_7();
    var tmp4 = Easings_EASE_IN_BOUNCE_getInstance();
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    var end = Easings_EASE_OUT_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * tmp4.o9f(it * 2.0) : 0.5 * end.o9f((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_IN_BOUNCE', 21);
    Easings_EASE_OUT_IN_BOUNCE_instance = this;
  }
  o9f(it) {
    Companion_getInstance_7();
    var tmp4 = Easings_EASE_OUT_BOUNCE_getInstance();
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    var end = Easings_EASE_IN_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * tmp4.o9f(it * 2.0) : 0.5 * end.o9f((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_QUAD extends Easings {
  constructor() {
    super('EASE_IN_QUAD', 22);
    Easings_EASE_IN_QUAD_instance = this;
  }
  o9f(it) {
    return 1.0 * it * it;
  }
}
class Easings$EASE_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_OUT_QUAD', 23);
    Easings_EASE_OUT_QUAD_instance = this;
  }
  o9f(it) {
    return -1.0 * it * (it - 2);
  }
}
class Easings$EASE_IN_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_IN_OUT_QUAD', 24);
    Easings_EASE_IN_OUT_QUAD_instance = this;
  }
  o9f(it) {
    // Inline function 'kotlin.let' call
    var t = it * 2.0;
    var tmp;
    if (t < 1) {
      tmp = +1.0 / 2 * t * t;
    } else {
      tmp = -1.0 / 2 * ((t - 1) * (t - 1 - 2) - 1);
    }
    return tmp;
  }
}
class Easings$EASE_SINE extends Easings {
  constructor() {
    super('EASE_SINE', 25);
    Easings_EASE_SINE_instance = this;
  }
  o9f(it) {
    // Inline function 'kotlin.math.sin' call
    var x = it * 1.5707964;
    return Math.sin(x);
  }
}
class Easings$EASE_CLAMP_START extends Easings {
  constructor() {
    super('EASE_CLAMP_START', 26);
    Easings_EASE_CLAMP_START_instance = this;
  }
  o9f(it) {
    return it <= 0.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_END extends Easings {
  constructor() {
    super('EASE_CLAMP_END', 27);
    Easings_EASE_CLAMP_END_instance = this;
  }
  o9f(it) {
    return it < 1.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_MIDDLE extends Easings {
  constructor() {
    super('EASE_CLAMP_MIDDLE', 28);
    Easings_EASE_CLAMP_MIDDLE_instance = this;
  }
  o9f(it) {
    return it < 0.5 ? 0.0 : 1.0;
  }
}
class P {
  constructor(x, y) {
    return new.target.pay(x, y);
  }
  static pay(x, y) {
    var $this = createThis(this);
    $this.nay_1 = x;
    $this.oay_1 = y;
    return $this;
  }
  static qay(x, y) {
    return this.pay(x, y);
  }
  b9q(that) {
    return P.pay(this.nay_1 * that, this.oay_1 * that);
  }
  ray(that) {
    return P.pay(this.nay_1 + that.nay_1, this.oay_1 + that.oay_1);
  }
  toString() {
    return 'P(x=' + this.nay_1 + ', y=' + this.oay_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.nay_1);
    result = imul(result, 31) + getNumberHashCode(this.oay_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof P))
      return false;
    var tmp0_other_with_cast = other instanceof P ? other : THROW_CCE();
    if (!equals(this.nay_1, tmp0_other_with_cast.nay_1))
      return false;
    if (!equals(this.oay_1, tmp0_other_with_cast.oay_1))
      return false;
    return true;
  }
}
class EasingCubic {
  constructor(x1, y1, x2, y2, name) {
    name = name === VOID ? null : name;
    this.kaw_1 = x1;
    this.law_1 = y1;
    this.maw_1 = x2;
    this.naw_1 = y2;
    this.oaw_1 = name;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.paw_1 = [P.qay(0.0, 0.0), P.qay(clamp_1(this.kaw_1, 0.0, 1.0), this.law_1), P.qay(clamp_1(this.maw_1, 0.0, 1.0), this.naw_1), P.qay(1.0, 1.0)];
  }
  toString() {
    var tmp0_elvis_lhs = this.oaw_1;
    return tmp0_elvis_lhs == null ? 'cubic-bezier(' + this.kaw_1 + ', ' + this.law_1 + ', ' + this.maw_1 + ', ' + this.naw_1 + ')' : tmp0_elvis_lhs;
  }
  o9f(it) {
    var pivotLeft = it < 0.0 ? it * 10.0 : 0.0;
    var pivotRight = it > 1.0 ? it * 10.0 : 1.0;
    var pivot = it;
    var lastX = 0.0;
    var lastY = 0.0;
    var steps = 0;
    var inductionVariable = 0;
    if (inductionVariable < 50)
      $l$loop_0: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        steps = steps + 1 | 0;
        var res = calc(this, pivot);
        lastX = res.nay_1;
        lastY = res.oay_1;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = lastX - it;
        if (Math.abs(this_0) < 0.001)
          break $l$loop_0;
        if (it < lastX) {
          pivotRight = pivot;
          pivot = (pivotLeft + pivot) * 0.5;
        } else if (it > lastX) {
          pivotLeft = pivot;
          pivot = (pivotRight + pivot) * 0.5;
        } else {
          break $l$loop_0;
        }
      }
       while (inductionVariable < 50);
    return lastY;
  }
}
//endregion
function insertAt($this, n, min, max) {
  $this.fab_1.pa2(n, min);
  $this.gab_1.pa2(n, max);
}
function removeAt($this, n, count) {
  $this.fab_1.ra2(n, count);
  $this.gab_1.ra2(n, count);
}
function toVectorPath(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
  // Inline function 'kotlin.apply' call
  var this_0 = new VectorPath();
  this_0.oab(_this__u8e3s4.s9i_1, _this__u8e3s4.t9i_1);
  return this_0;
}
function toStrokePointsList(_this__u8e3s4, info, mode, generateDebug, forceClosed) {
  mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
  generateDebug = generateDebug === VOID ? false : generateDebug;
  forceClosed = forceClosed === VOID ? null : forceClosed;
  return toStrokePointsList_0(_this__u8e3s4, info.pab_1, info.uab_1, info.sab_1, info.tab_1, info.vab_1, mode, info.wab_1, info.xab_1, generateDebug, forceClosed);
}
var StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance;
var StrokePointsMode_NON_SCALABLE_POS_instance;
var StrokePointsMode_entriesInitialized;
function StrokePointsMode_initEntries() {
  if (StrokePointsMode_entriesInitialized)
    return Unit_instance;
  StrokePointsMode_entriesInitialized = true;
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance = new StrokePointsMode('SCALABLE_POS_NORMAL_WIDTH', 0);
  StrokePointsMode_NON_SCALABLE_POS_instance = new StrokePointsMode('NON_SCALABLE_POS', 1);
}
function toStrokePointsList_0(_this__u8e3s4, width, join, startCap, endCap, miterLimit, mode, lineDash, lineDashOffset, generateDebug, forceClosed) {
  join = join === VOID ? LineJoin_MITER_getInstance() : join;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
  miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
  mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  generateDebug = generateDebug === VOID ? false : generateDebug;
  forceClosed = forceClosed === VOID ? null : forceClosed;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = _this__u8e3s4.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var list = toDashes(element, lineDash.k9u(), lineDashOffset);
      addAll(destination, list);
    }
    tmp = destination;
  } else {
    tmp = _this__u8e3s4;
  }
  var curvesList = tmp;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(collectionSizeOrDefault(curvesList, 10));
  var _iterator__ex2g4s_0 = curvesList.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item = _iterator__ex2g4s_0.r1();
    // Inline function 'kotlin.also' call
    var this_0 = new StrokePointsBuilder(width / 2.0, mode, generateDebug);
    this_0.fac(item, join, startCap, endCap, miterLimit, forceClosed);
    destination_0.d2(this_0);
  }
  return destination_0;
}
function StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance() {
  StrokePointsMode_initEntries();
  return StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance;
}
function StrokePointsMode_NON_SCALABLE_POS_getInstance() {
  StrokePointsMode_initEntries();
  return StrokePointsMode_NON_SCALABLE_POS_instance;
}
function get_isConvex(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var tmp0 = isConvex$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('isConvex', 1, tmp, _get_isConvex_$ref_rh3961(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var isConvex$delegate;
function Bezier$Extrema$allt$delegate$lambda(this$0) {
  return () => combineSmallDistinctSorted(Companion_getInstance_8(), this$0.sad_1, this$0.tad_1);
}
function Bezier$Extrema$xt01$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.sad_1, new Float64Array([1.0])]);
  };
}
function Bezier$Extrema$_get_xt01_$ref_uaychq() {
  return constructCallableReference((p0) => p0.xad(), 1, 0, 54);
}
function Bezier$Extrema$yt01$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.tad_1, new Float64Array([1.0])]);
  };
}
function Bezier$Extrema$_get_yt01_$ref_eubpb() {
  return constructCallableReference((p0) => p0.yad(), 1, 0, 55);
}
function map($this, v, ds, de, ts, te) {
  return convertRange(v, ds, de, ts, te);
}
function angle($this, o, v1, v2) {
  var dx1 = v1.r9g_1 - o.r9g_1;
  var dy1 = v1.s9g_1 - o.s9g_1;
  var dx2 = v2.r9g_1 - o.r9g_1;
  var dy2 = v2.s9g_1 - o.s9g_1;
  var cross = dx1 * dy2 - dy1 * dx2;
  var dot = dx1 * dx2 + dy1 * dy2;
  // Inline function 'kotlin.math.atan2' call
  return Math.atan2(cross, dot);
}
function compute($this, t, points) {
  var p = points;
  var order = p.s2() - 1 | 0;
  if (equals(t, Companion_getInstance_6().w9f_1))
    return p.u2(0);
  if (equals(t, Companion_getInstance_6().z9f_1))
    return p.u2(order);
  if (order === 0)
    return p.u2(0);
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance_6().z9f_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var tmp;
  switch (order) {
    case 1:
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_0 = p.u2(0);
      var tmp0 = Vector2D.t9g(this_0.r9g_1 * mt, this_0.s9g_1 * mt);
      var tmp0_0 = p.u2(1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var scale = Ratio__toDouble_impl_o7epze(t);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      var that = Vector2D.t9g(tmp0_0.r9g_1 * scale, tmp0_0.s9g_1 * scale);
      tmp = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
      break;
    case 2:
      var a = mt2;
      // Inline function 'korlibs.math.interpolation.times' call

      var b = mt * _Ratio___get_value__impl__57cli6(t) * 2;
      var c = t2;
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_1 = p.u2(0);
      var tmp0_1 = Vector2D.t9g(this_1.r9g_1 * a, this_1.s9g_1 * a);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_2 = p.u2(1);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      var that_0 = Vector2D.t9g(this_2.r9g_1 * b, this_2.s9g_1 * b);
      var tmp0_2 = Vector2D.t9g(tmp0_1.r9g_1 + that_0.r9g_1, tmp0_1.s9g_1 + that_0.s9g_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_3 = p.u2(2);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      var that_1 = Vector2D.t9g(this_3.r9g_1 * c, this_3.s9g_1 * c);
      tmp = Vector2D.t9g(tmp0_2.r9g_1 + that_1.r9g_1, tmp0_2.s9g_1 + that_1.s9g_1);
      break;
    case 3:
      var a_0 = mt2 * mt;
      // Inline function 'korlibs.math.interpolation.times' call

      var b_0 = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
      var c_0 = mt * t2 * 3;
      var d = Ratio__times_impl_ucdh7y(t, t2);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_4 = p.u2(0);
      var tmp0_3 = Vector2D.t9g(this_4.r9g_1 * a_0, this_4.s9g_1 * a_0);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_5 = p.u2(1);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      var that_2 = Vector2D.t9g(this_5.r9g_1 * b_0, this_5.s9g_1 * b_0);
      var tmp0_4 = Vector2D.t9g(tmp0_3.r9g_1 + that_2.r9g_1, tmp0_3.s9g_1 + that_2.s9g_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_6 = p.u2(2);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      var that_3 = Vector2D.t9g(this_6.r9g_1 * c_0, this_6.s9g_1 * c_0);
      var tmp0_5 = Vector2D.t9g(tmp0_4.r9g_1 + that_3.r9g_1, tmp0_4.s9g_1 + that_3.s9g_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_7 = p.u2(3);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      var that_4 = Vector2D.t9g(this_7.r9g_1 * d, this_7.s9g_1 * d);
      tmp = Vector2D.t9g(tmp0_5.r9g_1 + that_4.r9g_1, tmp0_5.s9g_1 + that_4.s9g_1);
      break;
    default:
      // Inline function 'kotlin.TODO' call

      var reason = 'higher order curves';
      throw NotImplementedError.le('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function derive($this, points) {
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.p2();
  var current = points;
  while (current.s2() >= 2) {
    var new_0 = new PointArrayList(current.s2() - 1 | 0);
    var c = current.s2() - 1 | 0;
    var inductionVariable = 0;
    var last = current.s2() - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0 = current.u2(n + 1 | 0);
        // Inline function 'korlibs.math.geom.Vector2D.minus' call
        var that = current.u2(n);
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        var this_0 = Vector2D.t9g(tmp0.r9g_1 - that.r9g_1, tmp0.s9g_1 - that.s9g_1);
        var tmp$ret$2 = Vector2D.t9g(this_0.r9g_1 * c, this_0.s9g_1 * c);
        new_0.uaa(tmp$ret$2);
      }
       while (inductionVariable < last);
    out.d2(new_0);
    current = new_0;
  }
  return out;
}
function align($this, points, line, out) {
  out = out === VOID ? new PointArrayList() : out;
  var p1 = line.u9j_1;
  var p2 = line.v9j_1;
  var tx = p1.r9g_1;
  var ty = p1.s9g_1;
  var tmp0 = p2.s9g_1 - ty;
  // Inline function 'kotlin.math.atan2' call
  var x = p2.r9g_1 - tx;
  var a = -Math.atan2(tmp0, x);
  // Inline function 'korlibs.math.geom.fastForEach' call
  var inductionVariable = 0;
  var last = points.s2();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var destruct = points.u2(n);
      var x_0 = destruct.jm();
      var y = destruct.km();
      var tmp = x_0 - tx;
      // Inline function 'kotlin.math.cos' call
      var tmp_0 = tmp * Math.cos(a);
      var tmp_1 = y - ty;
      // Inline function 'kotlin.math.sin' call
      var tmp_2 = tmp_0 - tmp_1 * Math.sin(a);
      var tmp_3 = x_0 - tx;
      // Inline function 'kotlin.math.sin' call
      var tmp_4 = tmp_3 * Math.sin(a);
      var tmp_5 = y - ty;
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$6 = Math.cos(a);
      out.taa(tmp_2, tmp_4 + tmp_5 * tmp$ret$6);
    }
     while (inductionVariable < last);
  return out;
}
function droots($this, p) {
  switch (p.length) {
    case 3:
      var a = p[0];
      var b = p[1];
      var c = p[2];
      var d = a - 2 * b + c;
      if (!(d === 0.0)) {
        // Inline function 'kotlin.math.sqrt' call
        var x = b * b - a * c;
        var m1 = -Math.sqrt(x);
        var m2 = -a + b;
        var v1 = -(m1 + m2) / d;
        var v2 = -(-m1 + m2) / d;
        return doubleArrayOfValid01($this, v1, v2);
      } else if (!(b === c) && d === 0.0) {
        return doubleArrayOfValid01($this, (2.0 * b - c) / (2.0 * (b - c)));
      }

      break;
    case 2:
      var a_0 = p[0];
      var b_0 = p[1];
      if (!(a_0 === b_0))
        return doubleArrayOfValid01($this, a_0 / (a_0 - b_0));
      break;
    default:
      break;
  }
  return doubleArrayOfValid01($this);
}
function doubleArrayOfValid01($this, v1, v2, v3) {
  v1 = v1 === VOID ? NaN : v1;
  v2 = v2 === VOID ? NaN : v2;
  v3 = v3 === VOID ? NaN : v3;
  var v1Valid = 0.0 <= v1 ? v1 <= 1.0 : false;
  var v2Valid = 0.0 <= v2 ? v2 <= 1.0 : false;
  var v3Valid = 0.0 <= v3 ? v3 <= 1.0 : false;
  var validCount = 0;
  if (v1Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v2Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v3Valid) {
    validCount = validCount + 1 | 0;
  }
  if (validCount === 0)
    return $this.dae_1;
  var index = 0;
  var out = new Float64Array(validCount);
  if (v1Valid) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    out[_unary__edvuaz] = normalizeZero(v1);
  }
  if (v2Valid) {
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    out[_unary__edvuaz_0] = normalizeZero(v2);
  }
  if (v3Valid) {
    var _unary__edvuaz_1 = index;
    index = _unary__edvuaz_1 + 1 | 0;
    out[_unary__edvuaz_1] = normalizeZero(v3);
  }
  return out;
}
function combineSmallDistinctSorted($this, a, b) {
  var out = DoubleArrayList.ga3(a.length + b.length | 0);
  out.ka3(a);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < b.length) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = b[_unary__edvuaz];
    if (!out.l9u(it)) {
      out.la3(it);
    }
  }
  sort(out);
  return out.k9u();
}
function _get_aligned__7fjidv($this) {
  var tmp0 = $this.had_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('aligned', 1, tmp, Bezier$_get_aligned_$ref_k3jq5z(), null);
  return tmp0.k3();
}
function _getBoundingBox($this, m) {
  m = m === VOID ? Companion_getInstance_1().w9k_1 : m;
  var xmin = 0.0;
  var ymin = 0.0;
  var xmax = 0.0;
  var ymax = 0.0;
  var inductionVariable = 0;
  if (inductionVariable <= 1)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ext = $this.eae().fae(n);
      var min = Infinity;
      var max = -Infinity;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < ext.length) {
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        var t = ext[_unary__edvuaz];
        var p = $this.gae(_Ratio___init__impl__9mwvn2(t));
        var value = n === 0 ? transformX(p, m) : transformY(p, m);
        // Inline function 'kotlin.math.min' call
        var a = min;
        min = Math.min(a, value);
        // Inline function 'kotlin.math.max' call
        var a_0 = max;
        max = Math.max(a_0, value);
      }
      if (n === 0) {
        xmin = min;
        xmax = max;
      } else {
        ymin = min;
        ymax = max;
      }
    }
     while (inductionVariable <= 1);
  return Companion_getInstance_2().u9p(xmin, ymin, xmax, ymax);
}
function findNearestLine($this, pX, pY, aX, aY, bX, bY, out) {
  out = out === VOID ? new ProjectedPoint() : out;
  out.kae_1 = $this;
  var atobX = bX - aX;
  var atobY = bY - aY;
  var atopX = pX - aX;
  var atopY = pY - aY;
  var len = atobX * atobX + atobY * atobY;
  var dot = atopX * atobX + atopY * atobY;
  // Inline function 'kotlin.math.max' call
  var b = dot / len;
  // Inline function 'kotlin.math.min' call
  var b_0 = Math.max(0.0, b);
  var tmp$ret$1 = Math.min(1.0, b_0);
  var t = toRatio_0(tmp$ret$1);
  var tmp = out;
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp_0 = aX + atobX * _Ratio___get_value__impl__57cli6(t);
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp$ret$3 = atobY * _Ratio___get_value__impl__57cli6(t);
  tmp.hae_1 = Vector2D.t9g(tmp_0, aY + tmp$ret$3);
  out.iae_1 = t;
  out.jae_1 = Companion_getInstance().a9t(out.hae_1.r9g_1, out.hae_1.s9g_1, pX, pY);
  return out;
}
var Companion_instance;
function Companion_getInstance_8() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function Bezier$aligned$delegate$lambda(this$0) {
  return () => align(Companion_getInstance_8(), this$0.gad_1, Line2D.w9j(this$0.gad_1.ma4(), this$0.gad_1.na4()));
}
function Bezier$_get_aligned_$ref_k3jq5z() {
  return constructCallableReference((p0) => _get_aligned__7fjidv(p0), 1, 0, 56);
}
function Bezier$dpoints$delegate$lambda(this$0) {
  return () => derive(Companion_getInstance_8(), this$0.gad_1);
}
function Bezier$_get_dpoints_$ref_ff14gc() {
  return constructCallableReference((p0) => p0.qae(), 1, 0, 57);
}
function Bezier$direction$delegate$lambda(this$0) {
  return () => {
    Companion_getInstance_0();
    var tmp2 = this$0.gad_1.u2(0);
    var tmp4 = this$0.gad_1.u2(this$0.rad());
    // Inline function 'korlibs.math.geom.Companion.between' call
    var up = this$0.gad_1.u2(1);
    var tmp2_0 = tmp2.r9g_1;
    var tmp4_0 = tmp2.s9g_1;
    var tmp6 = tmp4.r9g_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var y1 = tmp4.s9g_1;
    var tmp$ret$0 = Angle_between(tmp2_0, tmp4_0, tmp6, y1, up);
    return new Angle(tmp$ret$0);
  };
}
function Bezier$extrema$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.rae());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.n3_1;
    var last = this_0.o3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dim = item;
        var tmp = Companion_getInstance_8();
        // Inline function 'korlibs.datastructure.mapDouble' call
        var this_1 = this$0.qae().u2(0).maa(dim);
        // Inline function 'kotlin.also' call
        var this_2 = new Float64Array(this_1.length);
        var inductionVariable_0 = 0;
        var last_0 = this_1.length;
        if (inductionVariable_0 < last_0)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this_2[n] = this_1[n];
          }
           while (inductionVariable_0 < last_0);
        var out = droots(tmp, this_2);
        if (this$0.rad() === 3)
          out = combineSmallDistinctSorted(Companion_getInstance_8(), out, droots(Companion_getInstance_8(), this$0.qae().u2(1).maa(dim)));
        var tmp$ret$2 = out;
        destination.d2(tmp$ret$2);
      }
       while (!(item === last));
    var out_0 = destination;
    return new Extrema(out_0.u2(0), out_0.u2(1));
  };
}
function Bezier$_get_extrema_$ref_gf7khf() {
  return constructCallableReference((p0) => p0.eae(), 1, 0, 58);
}
function Bezier$outerCircle$delegate$lambda(this$0) {
  return () => outerCircle(this$0.sae());
}
function Bezier$_get_outerCircle_$ref_c58qwg() {
  return constructCallableReference((p0) => p0.tae(), 1, 0, 59);
}
function Bezier$boundingBox$delegate$lambda(this$0) {
  return () => _getBoundingBox(this$0, Companion_getInstance_1().w9k_1);
}
function Bezier$_get_boundingBox_$ref_1y88b0() {
  return constructCallableReference((p0) => p0.sae(), 1, 0, 60);
}
function Bezier$length$delegate$lambda(this$0) {
  return () => {
    var z = 0.5;
    var sum = 0.0;
    var inductionVariable = 0;
    var last = Companion_getInstance_8().zad_1.length - 1 | 0;
    var tmp;
    if (inductionVariable <= last) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var t = _Ratio___init__impl__9mwvn2(z * Companion_getInstance_8().zad_1[i] + z);
        var temp = this$0.uae(t);
        sum = sum + Companion_getInstance_8().aae_1[i] * temp.a();
      }
       while (inductionVariable <= last);
      tmp = Unit_instance;
    }
    return z * sum;
  };
}
function Bezier$_get_length_$ref_bphkk9() {
  return constructCallableReference((p0) => p0.a(), 1, 0, 61);
}
function Bezier$lut$delegate$lambda(this$0) {
  return () => this$0.vae();
}
function Bezier$_get_lut_$ref_n1ixow() {
  return constructCallableReference((p0) => p0.wae(), 1, 0, 62);
}
function Bezier$isLinear$delegate$lambda(this$0) {
  return () => {
    var tmp0 = this$0.gad_1.u2(this$0.rad());
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var that = this$0.gad_1.u2(0);
    var baseLength = Vector2D.t9g(tmp0.r9g_1 - that.r9g_1, tmp0.s9g_1 - that.s9g_1).a();
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var progression = until(0, _get_aligned__7fjidv(this$0).s2());
    var inductionVariable = progression.n3_1;
    var last = progression.o3_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = sum;
        var it = element;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = _get_aligned__7fjidv(this$0).m9j(it);
        sum = tmp + Math.abs(this_0);
      }
       while (!(element === last));
    return sum < baseLength / 50.0;
  };
}
function Bezier$isSimple$delegate$lambda(this$0) {
  return () => {
    var tmp;
    if (this$0.rad() === 3) {
      var a1 = angle(Companion_getInstance_8(), this$0.gad_1.u2(0), this$0.gad_1.u2(3), this$0.gad_1.u2(1));
      var a2 = angle(Companion_getInstance_8(), this$0.gad_1.u2(0), this$0.gad_1.u2(3), this$0.gad_1.u2(2));
      var tmp_0;
      if (a1 > 0.0 && a2 < 0.0 || (a1 < 0.0 && a2 > 0.0)) {
        return false;
      }
      tmp = tmp_0;
    }
    var n1 = this$0.pac(Companion_getInstance_6().w9f_1);
    var n2 = this$0.pac(Companion_getInstance_6().z9f_1);
    var s = n1.r9g_1 * n2.r9g_1 + n1.s9g_1 * n2.s9g_1;
    // Inline function 'kotlin.math.acos' call
    // Inline function 'kotlin.math.abs' call
    var x = Math.acos(s);
    return Math.abs(x) < 3.141592653589793 / 3.0;
  };
}
function Curves$contiguous$delegate$lambda(this$0) {
  return () => {
    var inductionVariable = 1;
    var last = this$0.aad_1.s2();
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = this$0.aad_1.u2(n - 1 | 0);
        var next = this$0.aad_1.u2(n);
        if (!curr.gad_1.na4().m9f(next.gad_1.ma4()))
          return false;
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    return true;
  };
}
function Curves$infos$delegate$lambda(this$0) {
  return () => {
    var pos = 0.0;
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.aad_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var start = pos;
      pos = pos + item.a();
      var tmp$ret$2 = new CurveInfo(index_0, item, start, pos, item.faf());
      destination.d2(tmp$ret$2);
    }
    return destination;
  };
}
function Curves$_get_infos_$ref_92y8xn() {
  return constructCallableReference((p0) => p0.sag(), 1, 0, 63);
}
function Curves$length$delegate$lambda(this$0) {
  return () => {
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var _iterator__ex2g4s = this$0.sag().p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp = sum;
      sum = tmp + element.a();
    }
    return sum;
  };
}
function Curves$_get_length_$ref_2flho() {
  return constructCallableReference((p0) => p0.a(), 1, 0, 64);
}
function Curves$findInfo$lambda($pos) {
  return (it) => it.l9u($pos) ? 0 : it.qag_1 < $pos ? -1 : 1;
}
function Curves$ratioFromLength$lambda($length) {
  return (it) => it.qag_1 < $length ? -1 : it.pag_1 > $length ? 1 : 0;
}
function toBezier(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return Bezier.zae(Vector2D.t9g(_this__u8e3s4.b9k(), _this__u8e3s4.c9k()), Vector2D.t9g(_this__u8e3s4.d9k(), _this__u8e3s4.e9k()));
}
function toDashes(_this__u8e3s4, pattern, offset) {
  offset = offset === VOID ? 0.0 : offset;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  if (pattern == null)
    return listOf(_this__u8e3s4);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.all' call
    var inductionVariable = 0;
    var last = pattern.length;
    while (inductionVariable < last) {
      var element = pattern[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (!(element <= 0.0)) {
        tmp$ret$0 = false;
        break $l$block;
      }
    }
    tmp$ret$0 = true;
  }
  // Inline function 'kotlin.check' call
  if (!!tmp$ret$0) {
    throw IllegalStateException.o('Check failed.');
  }
  var length = _this__u8e3s4.a();
  var current = offset;
  var dashNow = true;
  var index = 0;
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.p2();
  while (current < length) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var len = getCyclic_0(pattern, _unary__edvuaz);
    if (dashNow) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = _this__u8e3s4.wag(current, current + len);
      out.d2(element_0);
    }
    current = current + len;
    dashNow = !dashNow;
  }
  return out;
}
function BezierCurveFromIndices($this, indices, points) {
  var p = new PointArrayList(indices.length);
  var inductionVariable = 0;
  var last = indices.length;
  while (inductionVariable < last) {
    var index = indices[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    p.xaa(points, index);
  }
  return Bezier.caf(p);
}
var Companion_instance_0;
function Companion_getInstance_9() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function _split($this, t, hull, left) {
  var rt = convertRange(t, Companion_getInstance_6().w9f_1, Companion_getInstance_6().z9f_1, $this.fag_1, $this.gag_1);
  var rt1 = left ? $this.fag_1 : rt;
  var rt2 = left ? rt : $this.gag_1;
  var tmp;
  if ($this.eag_1.rad() < 2) {
    var p1 = $this.nac(rt1);
    var p2 = $this.nac(rt2);
    tmp = Bezier.zae(p1, p2);
  } else {
    var indices = left ? Companion_getInstance_9().xag_1 : Companion_getInstance_9().yag_1;
    tmp = BezierCurveFromIndices(Companion_getInstance_9(), ensureNotNull(indices.u2($this.eag_1.rad())), ensureNotNull(hull));
  }
  var curve = tmp;
  return SubBezier.kag(curve, rt1, rt2, $this.hag_1);
}
function _splitLeft($this, t, hull) {
  hull = hull === VOID ? $this.eag_1.cag(t) : hull;
  return _split($this, t, hull, true);
}
function _splitRight($this, t, hull) {
  hull = hull === VOID ? $this.eag_1.cag(t) : hull;
  return _split($this, t, hull, false);
}
function estimateAt($this, values, value, out) {
  out = out === VOID ? new Estimation() : out;
  var result = binarySearch_0(values, value);
  if (_BSearchResult___get_found__impl__om04iz(result))
    return $this.zag(out, _BSearchResult___get_index__impl__b5kraz(result), 0.0);
  var index = _BSearchResult___get_nearIndex__impl__s8nq43(result);
  if (value <= 0.0)
    return $this.zag(out, 0, 0.0);
  if (index >= (values.s2() - 1 | 0))
    return $this.zag(out, $this.maf_1.s2() - 1 | 0, 0.0);
  var ratio0 = values.u2(index);
  var ratio1 = values.u2(index + 1 | 0);
  var ratio = convertRange_0(value, ratio0, ratio1, 0.0, 1.0);
  return $this.zag(out, index, ratio);
}
function CurveLUT$toString$lambda(this$0) {
  return (it) => '' + this$0.naf_1.u2(it) + ',len=' + this$0.aah().u2(it) + ': ' + this$0.maf_1.u2(it).toString();
}
function toCurves(_this__u8e3s4, closed) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return new Curves(_this__u8e3s4, closed);
}
function toNonCurveSimplePointList(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var curves = _this__u8e3s4;
  var beziers = curves.aad_1;
  var epsilon = 1.0E-5;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < beziers.s2()) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var bezier = beziers.u2(_unary__edvuaz);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(bezier.yaf().length === 0))
      return null;
    var points = bezier.gad_1;
    // Inline function 'korlibs.math.geom.fastForEach' call
    var inductionVariable = 0;
    var last = points.s2();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var p = points.u2(n_0);
        if (out.n1() || !out.na4().m9t(p, epsilon)) {
          out.uaa(p);
        }
      }
       while (inductionVariable < last);
  }
  if (out.na4().m9t(out.ma4(), epsilon)) {
    out.yaa(out.s2() - 1 | 0);
  }
  return out;
}
function toVectorPath_0(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return toVectorPath_1(listOf(_this__u8e3s4), out);
}
var Arc_instance;
function Arc_getInstance() {
  return Arc_instance;
}
function toVectorPath_1(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var first = {_v: true};
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.s2()) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var curves = _this__u8e3s4.u2(_unary__edvuaz);
    if (curves instanceof Curves) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = curves.aad_1;
      var n_0 = 0;
      while (n_0 < this_0.s2()) {
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_0.u2(_unary__edvuaz_0);
        toVectorPath$bezier(first, out, it);
      }
      if (curves.bad_1) {
        out.f7();
      }
    } else {
      if (curves instanceof Bezier) {
        toVectorPath$bezier(first, out, curves);
      } else {
        // Inline function 'kotlin.TODO' call
        throw NotImplementedError.le();
      }
    }
  }
  return out;
}
function isConvex$delegate$lambda($this$extraPropertyThis) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return $this$extraPropertyThis.cad_1 || Convex_instance.xah($this$extraPropertyThis);
}
function isConvex$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return it;
}
function _get_isConvex_$ref_rh3961() {
  return constructCallableReference((p0) => get_isConvex(p0), 1, 0, 65);
}
function toVectorPath$bezier(first, $out, bezier) {
  var points = bezier.gad_1;
  if (first._v) {
    $out.gah(points.ma4());
    first._v = false;
  }
  switch (bezier.rad()) {
    case 1:
      $out.iah(points.u2(1));
      break;
    case 2:
      $out.jah(points.u2(1), points.u2(2));
      break;
    case 3:
      $out.lah(points.u2(1), points.u2(2), points.u2(3));
      break;
    default:
      // Inline function 'kotlin.TODO' call

      throw NotImplementedError.le();
  }
}
var properties_initialized__MathGeom_bezier_kt_sxrpnw;
function _init_properties__MathGeom_bezier_kt__br5r2i() {
  if (!properties_initialized__MathGeom_bezier_kt_sxrpnw) {
    properties_initialized__MathGeom_bezier_kt_sxrpnw = true;
    var tmp2 = isConvex$delegate$lambda;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = isConvex$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, tmp2);
    this_0.u9u_1 = transform;
    isConvex$delegate = this_0;
  }
}
var Companion_instance_1;
function Companion_getInstance_10() {
  return Companion_instance_1;
}
function quickFindPositionForNewNodeBestAreaFit($this, width, height) {
  var score = 1.7976931348623157E308;
  var areaFit;
  var bestNode = Companion_getInstance_2().y9k();
  var _iterator__ex2g4s = $this.bai_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var r = _iterator__ex2g4s.r1();
    if (r.q9h_1 >= width && r.r9h_1 >= height) {
      areaFit = r.q9h_1 * r.r9h_1 - width * height;
      if (areaFit < score) {
        bestNode = new Rectangle(r.o9h_1, r.p9h_1, width, height);
        score = areaFit;
      }
    }
  }
  return bestNode;
}
function splitFreeNode($this, freeNode, usedNode) {
  var newNode;
  if (usedNode.v9h() >= freeNode.w9h() || usedNode.w9h() <= freeNode.o9h_1 || usedNode.x9h() >= freeNode.y9h() || usedNode.y9h() <= freeNode.x9h()) {
    return false;
  }
  if (usedNode.o9h_1 < freeNode.w9h() && usedNode.w9h() > freeNode.o9h_1) {
    if (usedNode.p9h_1 > freeNode.p9h_1 && usedNode.p9h_1 < freeNode.y9h()) {
      newNode = freeNode.u9q(VOID, VOID, VOID, usedNode.p9h_1 - freeNode.p9h_1);
      $this.bai_1.d2(newNode);
    }
    if (usedNode.y9h() < freeNode.y9h()) {
      newNode = freeNode.u9q(VOID, usedNode.y9h(), VOID, freeNode.y9h() - usedNode.y9h());
      $this.bai_1.d2(newNode);
    }
  }
  if (usedNode.p9h_1 < freeNode.y9h() && usedNode.y9h() > freeNode.p9h_1) {
    if (usedNode.o9h_1 > freeNode.o9h_1 && usedNode.o9h_1 < freeNode.w9h()) {
      newNode = freeNode.u9q(VOID, VOID, usedNode.o9h_1 - freeNode.o9h_1);
      $this.bai_1.d2(newNode);
    }
    if (usedNode.w9h() < freeNode.w9h()) {
      newNode = freeNode.u9q(usedNode.w9h(), VOID, freeNode.w9h() - usedNode.w9h());
      $this.bai_1.d2(newNode);
    }
  }
  return true;
}
function pruneFreeList($this) {
  var len = $this.bai_1.s2();
  var i = 0;
  while (i < len) {
    var j = i + 1 | 0;
    var tmpRect = $this.bai_1.u2(i);
    $l$loop: while (j < len) {
      var tmpRect2 = $this.bai_1.u2(j);
      if (Companion_getInstance_2().w9p(tmpRect, tmpRect2)) {
        $this.bai_1.g5(i);
        i = i - 1 | 0;
        len = len - 1 | 0;
        break $l$loop;
      }
      if (Companion_getInstance_2().w9p(tmpRect2, tmpRect)) {
        $this.bai_1.g5(j);
        len = len - 1 | 0;
        j = j - 1 | 0;
      }
      j = j + 1 | 0;
    }
    i = i + 1 | 0;
  }
}
var HitTestDirection_ANY_instance;
var HitTestDirection_UP_instance;
var HitTestDirection_RIGHT_instance;
var HitTestDirection_DOWN_instance;
var HitTestDirection_LEFT_instance;
var Companion_instance_2;
function Companion_getInstance_11() {
  return Companion_instance_2;
}
var HitTestDirection_entriesInitialized;
function HitTestDirection_initEntries() {
  if (HitTestDirection_entriesInitialized)
    return Unit_instance;
  HitTestDirection_entriesInitialized = true;
  HitTestDirection_ANY_instance = new HitTestDirection('ANY', 0);
  HitTestDirection_UP_instance = new HitTestDirection('UP', 1);
  HitTestDirection_RIGHT_instance = new HitTestDirection('RIGHT', 2);
  HitTestDirection_DOWN_instance = new HitTestDirection('DOWN', 3);
  HitTestDirection_LEFT_instance = new HitTestDirection('LEFT', 4);
}
function HitTestDirection_ANY_getInstance() {
  HitTestDirection_initEntries();
  return HitTestDirection_ANY_instance;
}
var Convex_instance;
function Convex_getInstance() {
  return Convex_instance;
}
function get_cachedPoints(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  var tmp0 = cachedPoints$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('cachedPoints', 1, tmp, _get_cachedPoints_$ref_ohcq17(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cachedPoints$delegate;
function getPoints2List(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.p2();
  var current = {_v: new PointArrayList()};
  // Inline function 'korlibs.math.geom.shape.emitPoints2' call
  var i = Vector2D.y9j();
  var l = Vector2D.y9j();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.nah_1;
  var n_0 = 0;
  while (n_0 < this_0.s2()) {
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.j9u(_unary__edvuaz)) {
      case 0:
        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.oah_1.u2(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.t9g(tmp, _this__u8e3s4.oah_1.u2(_unary__edvuaz_1));
        i = it;
        if (true) {
          getPoints2List$flush(current, out);
        }

        current._v.uaa(it);
        l = it;
        break;
      case 1:
        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.t9g(tmp_0, _this__u8e3s4.oah_1.u2(_unary__edvuaz_3));
        if (false) {
          getPoints2List$flush(current, out);
        }

        current._v.uaa(it_0);
        l = it_0;
        break;
      case 2:
        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var tmp0 = Vector2D.t9g(tmp_1, _this__u8e3s4.oah_1.u2(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.t9g(tmp_2, _this__u8e3s4.oah_1.u2(_unary__edvuaz_7));
        var sum = Companion_getInstance().z9s(l, tmp0) + Companion_getInstance().z9s(tmp0, a);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_0 = numberToInt(sum);
        var rcurveSteps = Math.max(a_0, 20);
        var dt = 1.0 / rcurveSteps;
        var lastPos = {_v: Vector2D.y9j()};
        var prevPos = {_v: Vector2D.y9j()};
        var emittedCount = {_v: 0};
        var tmp0_0 = Companion_getInstance_6().w9f_1;
        getPoints2List$lambda(lastPos)(Companion_getInstance_8().nae(l, tmp0, a, tmp0_0));
        var nStart = false ? 0 : 1;
        var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
        var inductionVariable = nStart;
        if (inductionVariable <= nEnd)
          do {
            var n_1 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ratio = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
            getPoints2List$lambda_0(current, emittedCount, lastPos, prevPos, out)(Companion_getInstance_8().nae(l, tmp0, a, ratio));
          }
           while (!(n_1 === nEnd));
        l = a;
        break;
      case 3:
        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var tmp0_1 = Vector2D.t9g(tmp_3, _this__u8e3s4.oah_1.u2(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var tmp2 = Vector2D.t9g(tmp_4, _this__u8e3s4.oah_1.u2(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_1 = Vector2D.t9g(tmp_5, _this__u8e3s4.oah_1.u2(_unary__edvuaz_13));
        var sum_0 = Companion_getInstance().z9s(l, tmp0_1) + Companion_getInstance().z9s(tmp0_1, tmp2) + Companion_getInstance().z9s(tmp2, a_1);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_2 = numberToInt(sum_0);
        var rcurveSteps_0 = Math.max(a_2, 20);
        var dt_0 = 1.0 / rcurveSteps_0;
        var lastPos_0 = {_v: Vector2D.y9j()};
        var prevPos_0 = {_v: Vector2D.y9j()};
        var emittedCount_0 = {_v: 0};
        var tmp0_2 = Companion_getInstance_6().w9f_1;
        getPoints2List$lambda_1(lastPos_0)(Companion_getInstance_8().mae(l, tmp0_1, tmp2, a_1, tmp0_2));
        var nStart_0 = false ? 0 : 1;
        var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
        var inductionVariable_0 = nStart_0;
        if (inductionVariable_0 <= nEnd_0)
          do {
            var n_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
            getPoints2List$lambda_2(current, emittedCount_0, lastPos_0, prevPos_0, out)(Companion_getInstance_8().mae(l, tmp0_1, tmp2, a_1, ratio_0));
          }
           while (!(n_2 === nEnd_0));
        l = a_1;
        break;
      case 4:
        var p = i;
        if (false) {
          getPoints2List$flush(current, out);
        }

        current._v.uaa(p);
        break;
    }
  }
  getPoints2List$flush(current, out);
  return out;
}
function getPoints2(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_shape_kt__uqeev8();
  // Inline function 'korlibs.math.geom.shape.emitPoints2' call
  var i = Vector2D.y9j();
  var l = Vector2D.y9j();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.nah_1;
  var n_0 = 0;
  while (n_0 < this_0.s2()) {
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.j9u(_unary__edvuaz)) {
      case 0:
        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.oah_1.u2(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.t9g(tmp, _this__u8e3s4.oah_1.u2(_unary__edvuaz_1));
        i = it;
        out.uaa(it);
        l = it;
        break;
      case 1:
        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.t9g(tmp_0, _this__u8e3s4.oah_1.u2(_unary__edvuaz_3));
        out.uaa(it_0);
        l = it_0;
        break;
      case 2:
        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var tmp0 = Vector2D.t9g(tmp_1, _this__u8e3s4.oah_1.u2(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.t9g(tmp_2, _this__u8e3s4.oah_1.u2(_unary__edvuaz_7));
        var sum = Companion_getInstance().z9s(l, tmp0) + Companion_getInstance().z9s(tmp0, a);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_0 = numberToInt(sum);
        var rcurveSteps = Math.max(a_0, 20);
        var dt = 1.0 / rcurveSteps;
        var lastPos = {_v: Vector2D.y9j()};
        var prevPos = {_v: Vector2D.y9j()};
        var emittedCount = {_v: 0};
        var tmp0_0 = Companion_getInstance_6().w9f_1;
        getPoints2$lambda(lastPos)(Companion_getInstance_8().nae(l, tmp0, a, tmp0_0));
        var nStart = false ? 0 : 1;
        var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
        var inductionVariable = nStart;
        if (inductionVariable <= nEnd)
          do {
            var n_1 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ratio = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
            getPoints2$lambda_0(out, emittedCount, lastPos, prevPos)(Companion_getInstance_8().nae(l, tmp0, a, ratio));
          }
           while (!(n_1 === nEnd));
        l = a;
        break;
      case 3:
        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var tmp0_1 = Vector2D.t9g(tmp_3, _this__u8e3s4.oah_1.u2(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var tmp2 = Vector2D.t9g(tmp_4, _this__u8e3s4.oah_1.u2(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_1 = Vector2D.t9g(tmp_5, _this__u8e3s4.oah_1.u2(_unary__edvuaz_13));
        var sum_0 = Companion_getInstance().z9s(l, tmp0_1) + Companion_getInstance().z9s(tmp0_1, tmp2) + Companion_getInstance().z9s(tmp2, a_1);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_2 = numberToInt(sum_0);
        var rcurveSteps_0 = Math.max(a_2, 20);
        var dt_0 = 1.0 / rcurveSteps_0;
        var lastPos_0 = {_v: Vector2D.y9j()};
        var prevPos_0 = {_v: Vector2D.y9j()};
        var emittedCount_0 = {_v: 0};
        var tmp0_2 = Companion_getInstance_6().w9f_1;
        getPoints2$lambda_1(lastPos_0)(Companion_getInstance_8().mae(l, tmp0_1, tmp2, a_1, tmp0_2));
        var nStart_0 = false ? 0 : 1;
        var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
        var inductionVariable_0 = nStart_0;
        if (inductionVariable_0 <= nEnd_0)
          do {
            var n_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
            getPoints2$lambda_2(out, emittedCount_0, lastPos_0, prevPos_0)(Companion_getInstance_8().mae(l, tmp0_1, tmp2, a_1, ratio_0));
          }
           while (!(n_2 === nEnd_0));
        l = a_1;
        break;
      case 4:
        var p = i;
        out.uaa(p);
        break;
    }
  }
  return out;
}
function CircleShape2D$_init_$lambda_c1uoso(it) {
  return toVectorPath(it);
}
function BaseShape2D$cachedPath$delegate$lambda(this$0) {
  return () => this$0.uai_1(this$0.tai_1);
}
function toShape2D(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  return new CircleShape2D(_this__u8e3s4);
}
function cachedPoints$delegate$lambda($this$PropertyThis) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  return getPoints2($this$PropertyThis);
}
function _get_cachedPoints_$ref_ohcq17() {
  return constructCallableReference((p0) => get_cachedPoints(p0), 1, 0, 66);
}
function getPoints2List$flush(current, out) {
  if (!current._v.o9j())
    return Unit_instance;
  out.d2(current._v);
  current._v = new PointArrayList();
}
function getPoints2List$lambda($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function getPoints2List$lambda_0($current, $emittedCount, $lastPos, $prevPos, $out) {
  return (it) => {
    if (false) {
      getPoints2List$flush($current, $out);
    }
    $current._v.uaa(it);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function getPoints2List$lambda_1($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function getPoints2List$lambda_2($current, $emittedCount, $lastPos, $prevPos, $out) {
  return (it) => {
    if (false) {
      getPoints2List$flush($current, $out);
    }
    $current._v.uaa(it);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function getPoints2$lambda($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function getPoints2$lambda_0($out, $emittedCount, $lastPos, $prevPos) {
  return (it) => {
    $out.uaa(it);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function getPoints2$lambda_1($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function getPoints2$lambda_2($out, $emittedCount, $lastPos, $prevPos) {
  return (it) => {
    $out.uaa(it);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
var properties_initialized__MathGeom_shape_kt_lonmli;
function _init_properties__MathGeom_shape_kt__uqeev8() {
  if (!properties_initialized__MathGeom_shape_kt_lonmli) {
    properties_initialized__MathGeom_shape_kt_lonmli = true;
    cachedPoints$delegate = new PropertyThis(VOID, cachedPoints$delegate$lambda);
  }
}
var Companion_instance_3;
function Companion_getInstance_12() {
  return Companion_instance_3;
}
var SliceRotation_R0_instance;
var SliceRotation_R90_instance;
var SliceRotation_R180_instance;
var SliceRotation_R270_instance;
var Companion_instance_4;
function Companion_getInstance_13() {
  SliceRotation_initEntries();
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function values() {
  return [SliceRotation_R0_getInstance(), SliceRotation_R90_getInstance(), SliceRotation_R180_getInstance(), SliceRotation_R270_getInstance()];
}
var SliceRotation_entriesInitialized;
function SliceRotation_initEntries() {
  if (SliceRotation_entriesInitialized)
    return Unit_instance;
  SliceRotation_entriesInitialized = true;
  SliceRotation_R0_instance = new SliceRotation('R0', 0);
  SliceRotation_R90_instance = new SliceRotation('R90', 1);
  SliceRotation_R180_instance = new SliceRotation('R180', 2);
  SliceRotation_R270_instance = new SliceRotation('R270', 3);
  Companion_getInstance_13();
}
function _SliceOrientation___init__impl__ewylib(raw) {
  return raw;
}
function _SliceOrientation___get_raw__impl__tj3u8w($this) {
  return $this;
}
function _SliceOrientation___get_rotation__impl__m65r0o($this) {
  return Companion_getInstance_13().u2(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 2));
}
function _SliceOrientation___get_flipX__impl__lgb7bx($this) {
  return !(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 2, 1) === 0);
}
function _SliceOrientation___init__impl__ewylib_0(rotation, flipX) {
  rotation = rotation === VOID ? SliceRotation_R0_getInstance() : rotation;
  flipX = flipX === VOID ? false : flipX;
  return _SliceOrientation___init__impl__ewylib(insert_0(insert(0, rotation.w1_1, 0, 2), flipX, 2));
}
function _SliceOrientation___get_indices__impl__km5on3($this) {
  return Companion_getInstance_14().wai_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
function _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq($this) {
  return _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R90_getInstance()) || _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R270_getInstance());
}
function SliceOrientation__toString_impl_tdph6r($this) {
  return Companion_getInstance_14().xai_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
var Companion_instance_5;
function Companion_getInstance_14() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
function SliceOrientation__hashCode_impl_7mjkdw($this) {
  return $this;
}
function SliceOrientation__equals_impl_h4gywg($this, other) {
  if (!(other instanceof SliceOrientation))
    return false;
  if (!($this === (other instanceof SliceOrientation ? other.eam_1 : THROW_CCE())))
    return false;
  return true;
}
function transformed_1(_this__u8e3s4, orientation) {
  var i = _SliceOrientation___get_indices__impl__km5on3(orientation);
  return new RectCoords(_this__u8e3s4.lal(i[0]), _this__u8e3s4.mal(i[0]), _this__u8e3s4.lal(i[1]), _this__u8e3s4.mal(i[1]), _this__u8e3s4.lal(i[2]), _this__u8e3s4.mal(i[2]), _this__u8e3s4.lal(i[3]), _this__u8e3s4.mal(i[3]));
}
function SliceRotation_R0_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R0_instance;
}
function SliceRotation_R90_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R90_instance;
}
function SliceRotation_R180_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R180_instance;
}
function SliceRotation_R270_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R270_instance;
}
function _Item___init__impl__hhk1le(index) {
  return index;
}
function _Item___get_index__impl__lpanhd($this) {
  return $this;
}
function Item__toString_impl_d711m6($this) {
  return 'Item(index=' + $this + ')';
}
function Item__hashCode_impl_8k4v6p($this) {
  return $this;
}
function Item__equals_impl_qczid($this, other) {
  if (!(other instanceof Item))
    return false;
  if (!($this === (other instanceof Item ? other.fam_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_6;
function Companion_getInstance_15() {
  return Companion_instance_6;
}
function _Item___init__impl__hhk1le_0(index) {
  return index;
}
function _Item___get_index__impl__lpanhd_0($this) {
  return $this;
}
function Item__toString_impl_d711m6_0($this) {
  return 'Item(index=' + $this + ')';
}
function Item__hashCode_impl_8k4v6p_0($this) {
  return $this;
}
function Item__equals_impl_qczid_0($this, other) {
  if (!(other instanceof Item_0))
    return false;
  if (!($this === (other instanceof Item_0 ? other.yam_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_7;
function Companion_getInstance_16() {
  return Companion_instance_7;
}
function toSegments(_this__u8e3s4, scale) {
  scale = scale === VOID ? 1 : scale;
  var segments = new FSegmentsInt();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges' call
  var m = Vector2D.y9j();
  var l = Vector2D.y9j();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.nah_1;
  var n_0 = 0;
  while (n_0 < this_0.s2()) {
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.j9u(_unary__edvuaz)) {
      case 0:
        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.oah_1.u2(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.t9g(tmp, _this__u8e3s4.oah_1.u2(_unary__edvuaz_1));
        m = it;
        l = it;
        break;
      case 1:
        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.t9g(tmp_0, _this__u8e3s4.oah_1.u2(_unary__edvuaz_3));
        var p0 = l;
        toSegments$emit(segments, scale, p0, it_0);
        l = it_0;
        break;
      case 2:
        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var tmp0 = Vector2D.t9g(tmp_1, _this__u8e3s4.oah_1.u2(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var p2 = Vector2D.t9g(tmp_2, _this__u8e3s4.oah_1.u2(_unary__edvuaz_7));
        var p0_0 = l;
        toSegments$emit_0(segments, scale, Bezier.aaf(p0_0, tmp0, p2));
        l = p2;
        break;
      case 3:
        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var tmp0_0 = Vector2D.t9g(tmp_3, _this__u8e3s4.oah_1.u2(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var tmp2 = Vector2D.t9g(tmp_4, _this__u8e3s4.oah_1.u2(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var p3 = Vector2D.t9g(tmp_5, _this__u8e3s4.oah_1.u2(_unary__edvuaz_13));
        var p0_1 = l;
        toSegments$emit_0(segments, scale, Bezier.baf(p0_1, tmp0_0, tmp2, p3));
        l = p3;
        break;
      case 4:
        var equal = false ? l.m9f(m) : l.equals(m);
        if (!equal) {
          var tmp0_1 = l;
          var p1 = m;
          toSegments$emit(segments, scale, tmp0_1, p1);
        }

        break;
    }
  }
  return segments;
}
function segmentLookups($this, segments) {
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.filter' call
  var this_0 = segments.kan(SegmentIntToTrapezoidIntList$segmentLookups$lambda);
  // Inline function 'kotlin.also' call
  var this_1 = new FSegmentsInt();
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
  var inductionVariable = 0;
  var last = this_0.s2();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = this_0.ean(n);
      if (!(this_0.tan(it) === 0)) {
        this_1.cao(it, this_0);
      }
    }
     while (inductionVariable < last);
  var list = this_1;
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map' call
  // Inline function 'kotlin.also' call
  var this_2 = fastArrayListOf([]);
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
  var inductionVariable_0 = 0;
  var last_0 = list.s2();
  if (inductionVariable_0 < last_0)
    do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var it_0 = list.ean(n_0);
      var tmp$ret$11 = list.wan(it_0);
      this_2.d2(tmp$ret$11);
    }
     while (inductionVariable_0 < last_0);
  var tmp = this_2;
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map' call
  // Inline function 'kotlin.also' call
  var this_3 = fastArrayListOf([]);
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
  var inductionVariable_1 = 0;
  var last_1 = list.s2();
  if (inductionVariable_1 < last_1)
    do {
      var n_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var it_1 = list.ean(n_1);
      var tmp$ret$17 = list.xan(it_1);
      this_3.d2(tmp$ret$17);
    }
     while (inductionVariable_1 < last_1);
  var allY = sortedArray(toIntArray(distinct(plus(tmp, this_3))));
  var tmp_0 = 0;
  var tmp_1 = allY.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = Array(tmp_1);
  while (tmp_0 < tmp_1) {
    tmp_2[tmp_0] = new FSegmentsInt();
    tmp_0 = tmp_0 + 1 | 0;
  }
  var initialSegmentsInY = toList(tmp_2);
  var tmp_3 = 0;
  var tmp_4 = allY.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_5 = Array(tmp_4);
  while (tmp_3 < tmp_4) {
    tmp_5[tmp_3] = new FSegmentsInt();
    tmp_3 = tmp_3 + 1 | 0;
  }
  var allSegmentsInY = toList(tmp_5);
  var listPivot = 0;
  var yPivot = 0;
  while (yPivot < allY.length && listPivot < list.s2()) {
    var currentY = allY[yPivot];
    var currentItem = list.ean(listPivot);
    // Inline function 'korlibs.math.geom.trapezoid.Item.use' call
    if (list.wan(currentItem) === currentY) {
      initialSegmentsInY.u2(yPivot).cao(currentItem, list);
      listPivot = listPivot + 1 | 0;
    } else {
      yPivot = yPivot + 1 | 0;
    }
  }
  var inductionVariable_2 = 0;
  var last_2 = allY.length - 1 | 0;
  if (inductionVariable_2 <= last_2)
    do {
      var n_2 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
      var this_4 = initialSegmentsInY.u2(n_2);
      var inductionVariable_3 = 0;
      var last_3 = this_4.s2();
      if (inductionVariable_3 < last_3)
        do {
          var n_3 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var segment = this_4.ean(n_3);
          var inductionVariable_4 = n_2;
          var last_4 = allY.length;
          if (inductionVariable_4 < last_4)
            $l$loop: do {
              var m = inductionVariable_4;
              inductionVariable_4 = inductionVariable_4 + 1 | 0;
              var y = allY[m];
              if (!this_4.zan(segment, y) || this_4.xan(segment) === y)
                break $l$loop;
              allSegmentsInY.u2(m).cao(segment, this_4);
            }
             while (inductionVariable_4 < last_4);
        }
         while (inductionVariable_3 < last_3);
    }
     while (inductionVariable_2 <= last_2);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n_4 = 0;
  while (n_4 < allSegmentsInY.s2()) {
    var _unary__edvuaz = n_4;
    n_4 = _unary__edvuaz + 1 | 0;
    allSegmentsInY.u2(_unary__edvuaz).lan(SegmentIntToTrapezoidIntList$segmentLookups$lambda_0);
  }
  var inductionVariable_5 = 0;
  var last_5 = allY.length - 1 | 0;
  if (inductionVariable_5 <= last_5)
    do {
      var n_5 = inductionVariable_5;
      inductionVariable_5 = inductionVariable_5 + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
      var this_5 = allSegmentsInY.u2(n_5);
      var inductionVariable_6 = 0;
      var last_6 = this_5.s2();
      if (inductionVariable_6 < last_6)
        do {
          var n_6 = inductionVariable_6;
          inductionVariable_6 = inductionVariable_6 + 1 | 0;
          var segment_0 = this_5.ean(n_6);
          // Inline function 'kotlin.check' call
          if (!this_5.zan(segment_0, allY[n_5])) {
            throw IllegalStateException.o('Check failed.');
          }
        }
         while (inductionVariable_6 < last_6);
    }
     while (inductionVariable_5 <= last_5);
  return new Pair(allY, allSegmentsInY);
}
function SegmentIntToTrapezoidIntList$segmentLookups$lambda($this$sortedBy, it) {
  return $this$sortedBy.wan(it.yam_1);
}
function SegmentIntToTrapezoidIntList$segmentLookups$lambda_0($this$sortBy, it) {
  return $this$sortBy.van(it.yam_1);
}
var SegmentIntToTrapezoidIntList_instance;
function SegmentIntToTrapezoidIntList_getInstance() {
  return SegmentIntToTrapezoidIntList_instance;
}
function det($this, x0, y0, x1, y1) {
  return imul(x0, y1) - imul(x1, y0) | 0;
}
var Companion_instance_8;
function Companion_getInstance_17() {
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_18() {
  return Companion_instance_9;
}
function toSegments$emit(segments, $scale, p0, p1) {
  segments.jan(toIntRound(p0.r9g_1 * $scale), toIntRound(p0.s9g_1 * $scale), toIntRound(p1.r9g_1 * $scale), toIntRound(p1.s9g_1 * $scale));
}
function toSegments$emit_0(segments, $scale, bezier) {
  var len = coerceIn(toIntRound(bezier.a()), 2, 20);
  var oldPos = Vector2D.y9j();
  // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
  Companion_getInstance_6();
  var NS = len - 1 | 0;
  var NSd = NS;
  var start = true ? 0 : 1;
  var end = true ? NS : NS - 1 | 0;
  var inductionVariable = start;
  if (inductionVariable <= end)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ratio = n / NSd;
      var ratio_0 = toRatio_0(ratio);
      var p = bezier.nac(ratio_0);
      if (Ratio__compareTo_impl_z2ienc(ratio_0, Companion_getInstance_6().w9f_1) > 0) {
        toSegments$emit(segments, $scale, oldPos, p);
      }
      oldPos = p;
    }
     while (!(n === end));
}
function PolygonScanline$AllBuckets$pool$lambda(it) {
  it.sh();
  return Unit_instance;
}
function PolygonScanline$AllBuckets$pool$lambda_0(it) {
  return new Bucket();
}
function addPoint($this, x, y) {
  $this.oap_1.taa(x, y);
}
function addEdge($this, ax, ay, bx, by) {
  if (ax === bx && ay === by)
    return Unit_instance;
  var isHorizontal = ay === by;
  var iax = $this.xap(ax);
  var ibx = $this.xap(bx);
  var iay = $this.xap(ay);
  var iby = $this.xap(by);
  var edge = ay < by ? $this.iap_1.ja8().yap(iax, iay, ibx, iby, 1) : $this.iap_1.ja8().yap(ibx, iby, iax, iay, -1);
  $this.lap_1.d2(edge);
  if (isHorizontal) {
    $this.kap_1.d2(edge);
  } else {
    $this.jap_1.d2(edge);
    $this.map_1.eap(edge);
  }
  $this.hap_1 = BoundsBuilder__plus_impl_cz7f7x($this.hap_1, Vector2D.t9g(ax, ay));
  $this.hap_1 = BoundsBuilder__plus_impl_cz7f7x($this.hap_1, Vector2D.t9g(bx, by));
}
var IntArrayListSort_instance;
function IntArrayListSort_getInstance() {
  if (IntArrayListSort_instance === VOID)
    new IntArrayListSort();
  return IntArrayListSort_instance;
}
function access$_get_buckets__joe3tk($this) {
  return $this.map_1;
}
function PolygonScanline$edgesPool$lambda(it) {
  return new MEdge();
}
function PolygonScanline$add$lambda($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function PolygonScanline$add$lambda_0(this$0, $emittedCount, $lastPos, $prevPos) {
  return (it) => {
    this$0.eaq(it, false);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function PolygonScanline$add$lambda_1($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function PolygonScanline$add$lambda_2(this$0, $emittedCount, $lastPos, $prevPos) {
  return (it) => {
    this$0.eaq(it, false);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
var Companion_instance_10;
function Companion_getInstance_19() {
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_20() {
  return Companion_instance_11;
}
function strokeToFill(_this__u8e3s4, lineWidth, joins, startCap, endCap, miterLimit, lineDash, lineDashOffset, temp, outFill) {
  joins = joins === VOID ? LineJoin_MITER_getInstance() : joins;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? startCap : endCap;
  miterLimit = miterLimit === VOID ? 4.0 : miterLimit;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = toCurvesList(_this__u8e3s4);
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var list = toDashes(element, lineDash.k9u(), lineDashOffset);
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$5 = toVectorPath_0(item);
      destination_0.d2(tmp$ret$5);
    }
    tmp = destination_0;
  } else {
    tmp = listOf(_this__u8e3s4);
  }
  var strokePaths = tmp;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < strokePaths.s2()) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var strokePath = strokePaths.u2(_unary__edvuaz);
    temp.sar(strokePath, lineWidth, joins, startCap, endCap, miterLimit, outFill);
  }
  return outFill;
}
var EdgePoint_A_instance;
var EdgePoint_B_instance;
var EdgePoint_entriesInitialized;
function EdgePoint_initEntries() {
  if (EdgePoint_entriesInitialized)
    return Unit_instance;
  EdgePoint_entriesInitialized = true;
  EdgePoint_A_instance = new EdgePoint('A', 0, 0);
  EdgePoint_B_instance = new EdgePoint('B', 1, 1);
}
function _get_outFill__zcv64g($this) {
  var tmp = $this.car_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('outFill');
  }
}
function StrokeToFill$strokeFill$lambda($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function StrokeToFill$strokeFill$lambda_0(this$0, $iscale, $scale, $emittedCount, $lastPos, $prevPos) {
  return (it) => {
    if (false) {
      this$0.war($iscale, false);
    }
    this$0.har_1.dab(numberToInt(it.r9g_1 * $scale), numberToInt(it.s9g_1 * $scale));
    this$0.iar_1.ga2(0);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function StrokeToFill$strokeFill$lambda_1($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function StrokeToFill$strokeFill$lambda_2(this$0, $iscale, $scale, $emittedCount, $lastPos, $prevPos) {
  return (it) => {
    if (false) {
      this$0.war($iscale, false);
    }
    this$0.har_1.dab(numberToInt(it.r9g_1 * $scale), numberToInt(it.s9g_1 * $scale));
    this$0.iar_1.ga2(0);
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function EdgePoint_A_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_A_instance;
}
function EdgePoint_B_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_B_instance;
}
function strokeToFill_0(_this__u8e3s4, info, temp, outFill) {
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  return strokeToFill(_this__u8e3s4, info.pab_1, info.uab_1, info.sab_1, info.tab_1, info.vab_1, info.wab_1, info.xab_1, temp, outFill);
}
function t($this, p) {
  var tmp0 = $this.oas_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (tmp0.t9h()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.t9g(tmp0.m9l(p.r9g_1, p.s9g_1), tmp0.p9l(p.r9g_1, p.s9g_1));
  }
  return tmp$ret$0;
}
var _bvhCurvesCacheVersion$delegate;
var _bvhCurvesCache$delegate;
function set__curvesCacheVersion(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp0 = _curvesCacheVersion$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get__curvesCacheVersion_$ref_25pta1();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('_curvesCacheVersion', 1, tmp, tmp_0, _set__curvesCacheVersion_$ref_ibfkzf());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCacheVersion(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp0 = _curvesCacheVersion$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get__curvesCacheVersion_$ref_25pta1();
  var tmp4 = getPropertyCallableRef('_curvesCacheVersion', 1, tmp, tmp_0, _set__curvesCacheVersion_$ref_ibfkzf());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCacheVersion$delegate;
function set__curvesCache(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp0 = _curvesCache$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get__curvesCache_$ref_9grkpx();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('_curvesCache', 1, tmp, tmp_0, _set__curvesCache_$ref_wh886f());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCache(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp0 = _curvesCache$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get__curvesCache_$ref_9grkpx();
  var tmp4 = getPropertyCallableRef('_curvesCache', 1, tmp, tmp_0, _set__curvesCache_$ref_wh886f());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCache$delegate;
var Companion_instance_12;
function Companion_getInstance_21() {
  return Companion_instance_12;
}
function ensureMoveTo($this, p) {
  if ($this.o9j())
    return false;
  $this.gah(p);
  return true;
}
function toCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return getCurvesList(_this__u8e3s4);
}
function applyTransform(_this__u8e3s4, m) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp;
  if (m.u9h()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, _this__u8e3s4.oah_1.s2()), 2);
    var inductionVariable = progression.n3_1;
    var last = progression.o3_1;
    var step_0 = progression.p3_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var tmp2 = Vector2D.t9g(_this__u8e3s4.oah_1.u2(n + 0 | 0), _this__u8e3s4.oah_1.u2(n + 1 | 0));
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          if (m.t9h()) {
            tmp$ret$2 = tmp2;
            break $l$block;
          }
          tmp$ret$2 = Vector2D.t9g(m.m9l(tmp2.r9g_1, tmp2.s9g_1), m.p9l(tmp2.r9g_1, tmp2.s9g_1));
        }
        var p = tmp$ret$2;
        _this__u8e3s4.oah_1.ta3(n + 0 | 0, p.r9g_1);
        _this__u8e3s4.oah_1.ta3(n + 1 | 0, p.s9g_1);
      }
       while (!(n === last));
    _this__u8e3s4.sah_1 = _this__u8e3s4.sah_1 + 1 | 0;
    tmp = _this__u8e3s4;
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function getCurves(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var curvesList = getCurvesList(_this__u8e3s4);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = curvesList.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var list = element.aad_1;
    addAll(destination, list);
  }
  var tmp = destination;
  var tmp59_safe_receiver = lastOrNull(curvesList);
  var tmp0_elvis_lhs = tmp59_safe_receiver == null ? null : tmp59_safe_receiver.bad_1;
  return toCurves(tmp, tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
}
function plus_0(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return with_0(_this__u8e3s4, path);
}
function write(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.nah_1;
  var n_0 = 0;
  while (n_0 < this_0.s2()) {
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.j9u(_unary__edvuaz)) {
      case 0:
        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.oah_1.u2(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.t9g(tmp, path.oah_1.u2(_unary__edvuaz_1));
        _this__u8e3s4.gah(it);
        break;
      case 1:
        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.oah_1.u2(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.t9g(tmp_0, path.oah_1.u2(_unary__edvuaz_3));
        _this__u8e3s4.iah(it_0);
        break;
      case 2:
        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.oah_1.u2(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var tmp0 = Vector2D.t9g(tmp_1, path.oah_1.u2(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.oah_1.u2(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var p2 = Vector2D.t9g(tmp_2, path.oah_1.u2(_unary__edvuaz_7));
        _this__u8e3s4.jah(tmp0, p2);
        break;
      case 3:
        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.oah_1.u2(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var tmp0_0 = Vector2D.t9g(tmp_3, path.oah_1.u2(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.oah_1.u2(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var tmp2 = Vector2D.t9g(tmp_4, path.oah_1.u2(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.oah_1.u2(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var p3 = Vector2D.t9g(tmp_5, path.oah_1.u2(_unary__edvuaz_13));
        _this__u8e3s4.lah(tmp0_0, tmp2, p3);
        break;
      case 4:
        _this__u8e3s4.f7();
        break;
    }
  }
}
function getCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  if (!(get__curvesCacheVersion(_this__u8e3s4) === _this__u8e3s4.sah_1)) {
    set__curvesCacheVersion(_this__u8e3s4, _this__u8e3s4.sah_1);
    // Inline function 'kotlin.collections.arrayListOf' call
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList.p2();
    var currentClosed = {_v: false};
    // Inline function 'kotlin.collections.arrayListOf' call
    var current = {_v: ArrayList.p2()};
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges' call
    var m = Vector2D.y9j();
    var l = Vector2D.y9j();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = _this__u8e3s4.nah_1;
    var n_0 = 0;
    while (n_0 < this_1.s2()) {
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.j9u(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = _this__u8e3s4.oah_1.u2(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.t9g(tmp, _this__u8e3s4.oah_1.u2(_unary__edvuaz_1));
          m = it;
          l = it;
          getCurvesList$flush(_this__u8e3s4, current, this_0, currentClosed);
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.t9g(tmp_0, _this__u8e3s4.oah_1.u2(_unary__edvuaz_3));
          var p1 = l;
          var tmp0 = current._v;
          // Inline function 'kotlin.collections.plusAssign' call

          var element = Bezier.zae(p1, it_0);
          tmp0.d2(element);
          l = it_0;
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var tmp0_0 = Vector2D.t9g(tmp_1, _this__u8e3s4.oah_1.u2(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p2 = Vector2D.t9g(tmp_2, _this__u8e3s4.oah_1.u2(_unary__edvuaz_7));
          var p1_0 = l;
          var tmp0_1 = current._v;
          // Inline function 'kotlin.collections.plusAssign' call

          var element_0 = Bezier.aaf(p1_0, tmp0_0, p2);
          tmp0_1.d2(element_0);
          l = p2;
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var tmp0_2 = Vector2D.t9g(tmp_3, _this__u8e3s4.oah_1.u2(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var tmp2 = Vector2D.t9g(tmp_4, _this__u8e3s4.oah_1.u2(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = _this__u8e3s4.oah_1.u2(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p3 = Vector2D.t9g(tmp_5, _this__u8e3s4.oah_1.u2(_unary__edvuaz_13));
          var p1_1 = l;
          var tmp0_3 = current._v;
          // Inline function 'kotlin.collections.plusAssign' call

          var element_1 = Bezier.baf(p1_1, tmp0_2, tmp2, p3);
          tmp0_3.d2(element_1);
          l = p3;
          break;
        case 4:
          var equal = true ? l.m9f(m) : l.equals(m);
          if (!equal) {
            var tmp0_4 = l;
            var p2_0 = m;
            var tmp0_5 = current._v;
            // Inline function 'kotlin.collections.plusAssign' call
            var element_2 = Bezier.zae(tmp0_4, p2_0);
            tmp0_5.d2(element_2);
          }

          currentClosed._v = true;
          getCurvesList$flush(_this__u8e3s4, current, this_0, currentClosed);
          break;
      }
    }
    getCurvesList$flush(_this__u8e3s4, current, this_0, currentClosed);
    set__curvesCache(_this__u8e3s4, this_0);
  }
  return ensureNotNull(get__curvesCache(_this__u8e3s4));
}
function VectorPathTrapezoids$trapezoidsEvenOdd$delegate$lambda(this$0) {
  return () => SegmentIntToTrapezoidIntList_instance.eao(this$0.lat_1, Winding_EVEN_ODD_getInstance());
}
function VectorPathTrapezoids$_get_trapezoidsEvenOdd_$ref_7uws1x() {
  return constructCallableReference((p0) => p0.tat(), 1, 0, 67);
}
function VectorPathTrapezoids$trapezoidsNonZero$delegate$lambda(this$0) {
  return () => SegmentIntToTrapezoidIntList_instance.eao(this$0.lat_1, Winding_NON_ZERO_getInstance());
}
function VectorPathTrapezoids$_get_trapezoidsNonZero_$ref_es11np() {
  return constructCallableReference((p0) => p0.uat(), 1, 0, 68);
}
function with_0(_this__u8e3s4, path, transform) {
  transform = transform === VOID ? Companion_getInstance_1().w9k_1 : transform;
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var bb = {_v: new BoundsBuilder(_this__u8e3s4)};
  var curvesList = getCurvesList(path);
  if (curvesList.n1() && path.o9j()) {
    path.dat(new with$1(bb));
  }
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < curvesList.s2()) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = curvesList.u2(_unary__edvuaz).aad_1;
    var n_0 = 0;
    while (n_0 < this_0.s2()) {
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var bezier = this_0.u2(_unary__edvuaz_0);
      bb._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x_0(bb._v.r9i_1, bezier.gaf(transform)));
    }
  }
  return bb._v.r9i_1;
}
function _bvhCurvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _bvhCurvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _get__curvesCacheVersion_$ref_25pta1() {
  return constructCallableReference((p0) => get__curvesCacheVersion(p0), 1, 0, 69);
}
function _set__curvesCacheVersion_$ref_ibfkzf() {
  return constructCallableReference((p0, p1) => {
    set__curvesCacheVersion(p0, p1);
    return Unit_instance;
  }, 2, 0, 70);
}
function _curvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _get__curvesCache_$ref_9grkpx() {
  return constructCallableReference((p0) => get__curvesCache(p0), 1, 0, 71);
}
function _set__curvesCache_$ref_wh886f() {
  return constructCallableReference((p0, p1) => {
    set__curvesCache(p0, p1);
    return Unit_instance;
  }, 2, 0, 72);
}
function getCurvesList$flush($this_getCurvesList, current, $out, currentClosed) {
  if (current._v.n1())
    return Unit_instance;
  // Inline function 'kotlin.also' call
  var this_0 = new Curves(current._v, currentClosed._v);
  this_0.cad_1 = $this_getCurvesList.rah_1;
  $out.d2(this_0);
  currentClosed._v = false;
  // Inline function 'kotlin.collections.arrayListOf' call
  current._v = ArrayList.p2();
}
var properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk;
function _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe() {
  if (!properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk) {
    properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _bvhCurvesCacheVersion$delegate$lambda;
    _bvhCurvesCacheVersion$delegate = new Property(null, default_0);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_1 = _bvhCurvesCache$delegate$lambda;
    _bvhCurvesCache$delegate = new Property(null, default_1);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_2 = _curvesCacheVersion$delegate$lambda;
    _curvesCacheVersion$delegate = new Property(null, default_2);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_3 = _curvesCache$delegate$lambda;
    _curvesCache$delegate = new Property(null, default_3);
  }
}
var Companion_instance_13;
function Companion_getInstance_22() {
  return Companion_instance_13;
}
var Winding_EVEN_ODD_instance;
var Winding_NON_ZERO_instance;
var Companion_instance_14;
function Companion_getInstance_23() {
  return Companion_instance_14;
}
var Winding_entriesInitialized;
function Winding_initEntries() {
  if (Winding_entriesInitialized)
    return Unit_instance;
  Winding_entriesInitialized = true;
  Winding_EVEN_ODD_instance = new Winding('EVEN_ODD', 0, 'evenOdd');
  Winding_NON_ZERO_instance = new Winding('NON_ZERO', 1, 'nonZero');
}
var LineScaleMode_NONE_instance;
var LineScaleMode_HORIZONTAL_instance;
var LineScaleMode_VERTICAL_instance;
var LineScaleMode_NORMAL_instance;
var LineScaleMode_entriesInitialized;
function LineScaleMode_initEntries() {
  if (LineScaleMode_entriesInitialized)
    return Unit_instance;
  LineScaleMode_entriesInitialized = true;
  LineScaleMode_NONE_instance = new LineScaleMode('NONE', 0, false, false);
  LineScaleMode_HORIZONTAL_instance = new LineScaleMode('HORIZONTAL', 1, true, false);
  LineScaleMode_VERTICAL_instance = new LineScaleMode('VERTICAL', 2, false, true);
  LineScaleMode_NORMAL_instance = new LineScaleMode('NORMAL', 3, true, true);
}
var LineCap_BUTT_instance;
var LineCap_SQUARE_instance;
var LineCap_ROUND_instance;
var Companion_instance_15;
function Companion_getInstance_24() {
  return Companion_instance_15;
}
var LineCap_entriesInitialized;
function LineCap_initEntries() {
  if (LineCap_entriesInitialized)
    return Unit_instance;
  LineCap_entriesInitialized = true;
  LineCap_BUTT_instance = new LineCap('BUTT', 0);
  LineCap_SQUARE_instance = new LineCap('SQUARE', 1);
  LineCap_ROUND_instance = new LineCap('ROUND', 2);
}
var LineJoin_BEVEL_instance;
var LineJoin_ROUND_instance;
var LineJoin_MITER_instance;
var Companion_instance_16;
function Companion_getInstance_25() {
  return Companion_instance_16;
}
var LineJoin_entriesInitialized;
function LineJoin_initEntries() {
  if (LineJoin_entriesInitialized)
    return Unit_instance;
  LineJoin_entriesInitialized = true;
  LineJoin_BEVEL_instance = new LineJoin('BEVEL', 0);
  LineJoin_ROUND_instance = new LineJoin('ROUND', 1);
  LineJoin_MITER_instance = new LineJoin('MITER', 2);
}
function Winding_EVEN_ODD_getInstance() {
  Winding_initEntries();
  return Winding_EVEN_ODD_instance;
}
function Winding_NON_ZERO_getInstance() {
  Winding_initEntries();
  return Winding_NON_ZERO_instance;
}
function LineScaleMode_NONE_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NONE_instance;
}
function LineScaleMode_NORMAL_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NORMAL_instance;
}
function LineCap_BUTT_getInstance() {
  LineCap_initEntries();
  return LineCap_BUTT_instance;
}
function LineCap_SQUARE_getInstance() {
  LineCap_initEntries();
  return LineCap_SQUARE_instance;
}
function LineJoin_BEVEL_getInstance() {
  LineJoin_initEntries();
  return LineJoin_BEVEL_instance;
}
function LineJoin_MITER_getInstance() {
  LineJoin_initEntries();
  return LineJoin_MITER_instance;
}
function get_immutable(_this__u8e3s4) {
  return _this__u8e3s4;
}
function MMatrix$Companion$POOL$lambda(it) {
  it.mau();
  return Unit_instance;
}
function MMatrix$Companion$POOL$lambda_0(it) {
  return new MMatrix();
}
var Companion_instance_17;
function Companion_getInstance_26() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
function toMatrix4(_this__u8e3s4) {
  if (_this__u8e3s4.t9h())
    return Companion_getInstance_5().b9o_1;
  return Companion_getInstance_5().e9o(_this__u8e3s4.a9l_1, _this__u8e3s4.c9l_1, 0.0, _this__u8e3s4.e9l_1, _this__u8e3s4.b9l_1, _this__u8e3s4.d9l_1, 0.0, _this__u8e3s4.f9l_1, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
}
function MPoint$Companion$POOL$lambda(it) {
  it.yau(0.0, 0.0);
  return Unit_instance;
}
function MPoint$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_27().y9k();
}
var Companion_instance_18;
function Companion_getInstance_27() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
function MRectangle$Companion$POOL$lambda(it) {
  it.sh();
  return Unit_instance;
}
function MRectangle$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_28().y9k();
}
var Companion_instance_19;
function Companion_getInstance_28() {
  if (Companion_instance_19 === VOID)
    new Companion_19();
  return Companion_instance_19;
}
function get_mutable(_this__u8e3s4) {
  return new MRectangle(_this__u8e3s4.o9h_1, _this__u8e3s4.p9h_1, _this__u8e3s4.q9h_1, _this__u8e3s4.r9h_1);
}
function get_mutable_0(_this__u8e3s4) {
  return new MMatrix(_this__u8e3s4.a9l_1, _this__u8e3s4.b9l_1, _this__u8e3s4.c9l_1, _this__u8e3s4.d9l_1, _this__u8e3s4.e9l_1, _this__u8e3s4.f9l_1);
}
var Companion_instance_20;
function Companion_getInstance_29() {
  return Companion_instance_20;
}
function lineIntersectionPoint(_this__u8e3s4, l1, l2) {
  return l1.wav(l2);
}
function projectedPoint(_this__u8e3s4, point) {
  return projectedPoint_0(Companion_instance_20, _this__u8e3s4.rac_1, _this__u8e3s4.sac_1, point);
}
function projectedPoint_0(_this__u8e3s4, v1, v2, point) {
  return projectedPoint_1(_this__u8e3s4, v1.r9g_1, v1.s9g_1, v2.r9g_1, v2.s9g_1, point.r9g_1, point.s9g_1);
}
function projectedPoint_1(_this__u8e3s4, v1x, v1y, v2x, v2y, px, py) {
  var e1x = v2x - v1x;
  var e1y = v2y - v1y;
  var e2x = px - v1x;
  var e2y = py - v1y;
  var valDp = Companion_getInstance_27().aav(e1x, e1y, e2x, e2y);
  // Inline function 'kotlin.math.hypot' call
  var lenLineE1 = hypot(e1x, e1y);
  // Inline function 'kotlin.math.hypot' call
  var lenLineE2 = hypot(e2x, e2y);
  if (lenLineE1 === 0.0 || lenLineE2 === 0.0) {
    return Vector2D.t9g(px, py);
  }
  var cos = valDp / (lenLineE1 * lenLineE2);
  var projLenOfLine = cos * lenLineE2;
  return Vector2D.t9g(v1x + projLenOfLine * e1x / lenLineE1, v1y + projLenOfLine * e1y / lenLineE1);
}
function floorCeil(v) {
  var tmp;
  if (v < 0.0) {
    // Inline function 'kotlin.math.ceil' call
    tmp = Math.ceil(v);
  } else {
    // Inline function 'kotlin.math.floor' call
    tmp = Math.floor(v);
  }
  return tmp;
}
function get__ALL_LIST() {
  _init_properties_Easings_kt__swvzhy();
  var tmp0 = _ALL_LIST$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_ALL_LIST', 0, tmp, _get__ALL_LIST_$ref_7nhd1(), null);
  return tmp0.k3();
}
var _ALL_LIST$delegate;
var _ALL$delegate;
function get_EASE_IN_OUT(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_OUT_getInstance();
}
function get_EASE_IN_OUT_QUAD(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_OUT_QUAD_getInstance();
}
function get_EASE_IN(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_getInstance();
}
var Easings_SMOOTH_instance;
var Easings_EASE_IN_ELASTIC_instance;
var Easings_EASE_OUT_ELASTIC_instance;
var Easings_EASE_OUT_BOUNCE_instance;
var Easings_LINEAR_instance;
var Easings_EASE_instance;
var Easings_EASE_IN_instance;
var Easings_EASE_OUT_instance;
var Easings_EASE_IN_OUT_instance;
var Easings_EASE_IN_OLD_instance;
var Easings_EASE_OUT_OLD_instance;
var Easings_EASE_IN_OUT_OLD_instance;
var Easings_EASE_OUT_IN_OLD_instance;
var Easings_EASE_IN_BACK_instance;
var Easings_EASE_OUT_BACK_instance;
var Easings_EASE_IN_OUT_BACK_instance;
var Easings_EASE_OUT_IN_BACK_instance;
var Easings_EASE_IN_OUT_ELASTIC_instance;
var Easings_EASE_OUT_IN_ELASTIC_instance;
var Easings_EASE_IN_BOUNCE_instance;
var Easings_EASE_IN_OUT_BOUNCE_instance;
var Easings_EASE_OUT_IN_BOUNCE_instance;
var Easings_EASE_IN_QUAD_instance;
var Easings_EASE_OUT_QUAD_instance;
var Easings_EASE_IN_OUT_QUAD_instance;
var Easings_EASE_SINE_instance;
var Easings_EASE_CLAMP_START_instance;
var Easings_EASE_CLAMP_END_instance;
var Easings_EASE_CLAMP_MIDDLE_instance;
function values_0() {
  return [Easings_SMOOTH_getInstance(), Easings_EASE_IN_ELASTIC_getInstance(), Easings_EASE_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_BOUNCE_getInstance(), Easings_LINEAR_getInstance(), Easings_EASE_getInstance(), Easings_EASE_IN_getInstance(), Easings_EASE_OUT_getInstance(), Easings_EASE_IN_OUT_getInstance(), Easings_EASE_IN_OLD_getInstance(), Easings_EASE_OUT_OLD_getInstance(), Easings_EASE_IN_OUT_OLD_getInstance(), Easings_EASE_OUT_IN_OLD_getInstance(), Easings_EASE_IN_BACK_getInstance(), Easings_EASE_OUT_BACK_getInstance(), Easings_EASE_IN_OUT_BACK_getInstance(), Easings_EASE_OUT_IN_BACK_getInstance(), Easings_EASE_IN_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_IN_ELASTIC_getInstance(), Easings_EASE_IN_BOUNCE_getInstance(), Easings_EASE_IN_OUT_BOUNCE_getInstance(), Easings_EASE_OUT_IN_BOUNCE_getInstance(), Easings_EASE_IN_QUAD_getInstance(), Easings_EASE_OUT_QUAD_getInstance(), Easings_EASE_IN_OUT_QUAD_getInstance(), Easings_EASE_SINE_getInstance(), Easings_EASE_CLAMP_START_getInstance(), Easings_EASE_CLAMP_END_getInstance(), Easings_EASE_CLAMP_MIDDLE_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values_0());
  return $ENTRIES;
}
var Easings_entriesInitialized;
function Easings_initEntries() {
  if (Easings_entriesInitialized)
    return Unit_instance;
  Easings_entriesInitialized = true;
  Easings_SMOOTH_instance = new Easings$SMOOTH();
  Easings_EASE_IN_ELASTIC_instance = new Easings$EASE_IN_ELASTIC();
  Easings_EASE_OUT_ELASTIC_instance = new Easings$EASE_OUT_ELASTIC();
  Easings_EASE_OUT_BOUNCE_instance = new Easings$EASE_OUT_BOUNCE();
  Easings_LINEAR_instance = new Easings$LINEAR();
  Easings_EASE_instance = new Easings$EASE();
  Easings_EASE_IN_instance = new Easings$EASE_IN();
  Easings_EASE_OUT_instance = new Easings$EASE_OUT();
  Easings_EASE_IN_OUT_instance = new Easings$EASE_IN_OUT();
  Easings_EASE_IN_OLD_instance = new Easings$EASE_IN_OLD();
  Easings_EASE_OUT_OLD_instance = new Easings$EASE_OUT_OLD();
  Easings_EASE_IN_OUT_OLD_instance = new Easings$EASE_IN_OUT_OLD();
  Easings_EASE_OUT_IN_OLD_instance = new Easings$EASE_OUT_IN_OLD();
  Easings_EASE_IN_BACK_instance = new Easings$EASE_IN_BACK();
  Easings_EASE_OUT_BACK_instance = new Easings$EASE_OUT_BACK();
  Easings_EASE_IN_OUT_BACK_instance = new Easings$EASE_IN_OUT_BACK();
  Easings_EASE_OUT_IN_BACK_instance = new Easings$EASE_OUT_IN_BACK();
  Easings_EASE_IN_OUT_ELASTIC_instance = new Easings$EASE_IN_OUT_ELASTIC();
  Easings_EASE_OUT_IN_ELASTIC_instance = new Easings$EASE_OUT_IN_ELASTIC();
  Easings_EASE_IN_BOUNCE_instance = new Easings$EASE_IN_BOUNCE();
  Easings_EASE_IN_OUT_BOUNCE_instance = new Easings$EASE_IN_OUT_BOUNCE();
  Easings_EASE_OUT_IN_BOUNCE_instance = new Easings$EASE_OUT_IN_BOUNCE();
  Easings_EASE_IN_QUAD_instance = new Easings$EASE_IN_QUAD();
  Easings_EASE_OUT_QUAD_instance = new Easings$EASE_OUT_QUAD();
  Easings_EASE_IN_OUT_QUAD_instance = new Easings$EASE_IN_OUT_QUAD();
  Easings_EASE_SINE_instance = new Easings$EASE_SINE();
  Easings_EASE_CLAMP_START_instance = new Easings$EASE_CLAMP_START();
  Easings_EASE_CLAMP_END_instance = new Easings$EASE_CLAMP_END();
  Easings_EASE_CLAMP_MIDDLE_instance = new Easings$EASE_CLAMP_MIDDLE();
}
var $ENTRIES;
function calc($this, it) {
  var t = toRatio_1(it);
  var p = $this.paw_1;
  var order = p.length - 1 | 0;
  if (equals(t, Companion_getInstance_6().w9f_1))
    return p[0];
  if (equals(t, Companion_getInstance_6().z9f_1))
    return p[order];
  if (order === 0)
    return p[0];
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance_6().z9f_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var a = mt2 * mt;
  // Inline function 'korlibs.math.interpolation.times' call
  var b = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
  var c = mt * t2 * 3;
  var d = Ratio__times_impl_ucdh7y(t, t2);
  return p[0].b9q(a).ray(p[1].b9q(b)).ray(p[2].b9q(c)).ray(p[3].b9q(d));
}
function get_EASE_OUT_QUAD(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_OUT_QUAD_getInstance();
}
function _ALL_LIST$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  return get_entries();
}
function _get__ALL_LIST_$ref_7nhd1() {
  return constructCallableReference(() => get__ALL_LIST(), 0, 0, 73);
}
function _ALL$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = get__ALL_LIST();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.cd(capacity);
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$2 = element.v1_1;
    destination.b5(tmp$ret$2, element);
  }
  return destination;
}
function Easings_SMOOTH_getInstance() {
  Easings_initEntries();
  return Easings_SMOOTH_instance;
}
function Easings_EASE_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_ELASTIC_instance;
}
function Easings_EASE_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BOUNCE_instance;
}
function Easings_LINEAR_getInstance() {
  Easings_initEntries();
  return Easings_LINEAR_instance;
}
function Easings_EASE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_instance;
}
function Easings_EASE_IN_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_instance;
}
function Easings_EASE_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_instance;
}
function Easings_EASE_IN_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_instance;
}
function Easings_EASE_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OLD_instance;
}
function Easings_EASE_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_OLD_instance;
}
function Easings_EASE_IN_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_OLD_instance;
}
function Easings_EASE_OUT_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_OLD_instance;
}
function Easings_EASE_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BACK_instance;
}
function Easings_EASE_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BACK_instance;
}
function Easings_EASE_IN_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BACK_instance;
}
function Easings_EASE_OUT_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BACK_instance;
}
function Easings_EASE_IN_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_ELASTIC_instance;
}
function Easings_EASE_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BOUNCE_instance;
}
function Easings_EASE_IN_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BOUNCE_instance;
}
function Easings_EASE_OUT_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BOUNCE_instance;
}
function Easings_EASE_IN_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_QUAD_instance;
}
function Easings_EASE_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_QUAD_instance;
}
function Easings_EASE_IN_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_QUAD_instance;
}
function Easings_EASE_SINE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_SINE_instance;
}
function Easings_EASE_CLAMP_START_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_START_instance;
}
function Easings_EASE_CLAMP_END_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_END_instance;
}
function Easings_EASE_CLAMP_MIDDLE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_MIDDLE_instance;
}
var properties_initialized_Easings_kt_w5y1uw;
function _init_properties_Easings_kt__swvzhy() {
  if (!properties_initialized_Easings_kt_w5y1uw) {
    properties_initialized_Easings_kt_w5y1uw = true;
    var tmp = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL_LIST$delegate = lazy_0(tmp, _ALL_LIST$delegate$lambda);
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL$delegate = lazy_0(tmp_0, _ALL$delegate$lambda);
  }
}
function interpolate_2(_this__u8e3s4, l, r) {
  return Size2D.y9p(interpolate_1(_this__u8e3s4, l.j9i_1, r.j9i_1), interpolate_1(_this__u8e3s4, l.k9i_1, r.k9i_1));
}
function get_niceStr_0(_this__u8e3s4) {
  return get_niceStr(Ratio__toDouble_impl_o7epze(_this__u8e3s4));
}
//region block: post-declaration
initMetadataForClass(IntSegmentSet, 'IntSegmentSet', IntSegmentSet);
initMetadataForClass(StrokePointsMode, 'StrokePointsMode');
initMetadataForClass(StrokePointsBuilder, 'StrokePointsBuilder');
protoOf(ProjectedPoint).m9f = isAlmostEquals$default;
initMetadataForClass(ProjectedPoint, 'ProjectedPoint', ProjectedPoint, VOID, [IsAlmostEquals]);
initMetadataForClass(Extrema, 'Extrema');
initMetadataForCompanion(Companion);
protoOf(Bezier).m9f = isAlmostEquals$default;
initMetadataForClass(Bezier, 'Bezier', Bezier.yae, VOID, [IsAlmostEquals]);
initMetadataForClass(CurveInfo, 'CurveInfo');
initMetadataForClass(Curves, 'Curves');
initMetadataForCompanion(Companion_0);
initMetadataForClass(SubBezier, 'SubBezier');
initMetadataForClass(ClosestResult, 'ClosestResult');
initMetadataForClass(Estimation, 'Estimation', Estimation);
initMetadataForClass(CurveLUT, 'CurveLUT');
initMetadataForObject(Arc, 'Arc');
initMetadataForCompanion(Companion_1);
initMetadataForClass(ImageDoNotFitException, 'ImageDoNotFitException');
initMetadataForClass(BinPacker, 'BinPacker');
initMetadataForClass(MaxRects, 'MaxRects');
initMetadataForCompanion(Companion_2);
initMetadataForClass(HitTestDirection, 'HitTestDirection');
initMetadataForObject(Convex, 'Convex');
initMetadataForClass(BaseShape2D, 'BaseShape2D');
initMetadataForClass(CircleShape2D, 'CircleShape2D');
initMetadataForClass(AbstractShape2D, 'AbstractShape2D');
initMetadataForInterface(SliceCoords, 'SliceCoords');
initMetadataForInterface(SliceCoordsWithBase, 'SliceCoordsWithBase', VOID, VOID, [SliceCoords]);
initMetadataForInterface(SliceCoordsWithBaseAndRect, 'SliceCoordsWithBaseAndRect', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectSlice).v9h = get_left;
protoOf(RectSlice).x9h = get_top;
protoOf(RectSlice).w9h = get_right;
protoOf(RectSlice).y9h = get_bottom;
protoOf(RectSlice).g9r = get_area;
protoOf(RectSlice).jal = get_frameOffsetX;
protoOf(RectSlice).kal = get_frameOffsetY;
protoOf(RectSlice).lal = x;
protoOf(RectSlice).mal = y;
initMetadataForClass(RectSlice, 'RectSlice', VOID, VOID, [SliceCoordsWithBaseAndRect]);
initMetadataForCompanion(Companion_3);
protoOf(SliceCoordsImpl).jal = get_frameOffsetX;
protoOf(SliceCoordsImpl).kal = get_frameOffsetY;
protoOf(SliceCoordsImpl).lal = x;
protoOf(SliceCoordsImpl).mal = y;
initMetadataForClass(SliceCoordsImpl, 'SliceCoordsImpl', VOID, VOID, [SliceCoordsWithBase]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(SliceRotation, 'SliceRotation');
initMetadataForCompanion(Companion_5);
initMetadataForClass(SliceOrientation, 'SliceOrientation');
protoOf(RectCoords).lal = x;
protoOf(RectCoords).mal = y;
initMetadataForClass(RectCoords, 'RectCoords', VOID, VOID, [SliceCoords]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(Item, 'Item');
initMetadataForClass(FTrapezoidsInt, 'FTrapezoidsInt', FTrapezoidsInt);
initMetadataForCompanion(Companion_7);
initMetadataForClass(SortOps_0, 'SortOps');
initMetadataForClass(Item_0, 'Item');
initMetadataForClass(FSegmentsInt, 'FSegmentsInt', FSegmentsInt);
initMetadataForObject(SegmentIntToTrapezoidIntList, 'SegmentIntToTrapezoidIntList');
initMetadataForCompanion(Companion_8);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Bucket, 'Bucket', Bucket);
initMetadataForClass(Buckets, 'Buckets');
initMetadataForClass(AllBuckets, 'AllBuckets', AllBuckets);
initMetadataForClass(XWithWind, 'XWithWind', XWithWind);
initMetadataForObject(IntArrayListSort, 'IntArrayListSort');
initMetadataForClass(RastScale, 'RastScale', RastScale);
initMetadataForClass(PolygonScanline, 'PolygonScanline', PolygonScanline);
initMetadataForCompanion(Companion_10);
initMetadataForCompanion(Companion_11);
initMetadataForClass(MEdge, 'MEdge', MEdge);
initMetadataForClass(EdgePoint, 'EdgePoint');
initMetadataForClass(StrokeToFill, 'StrokeToFill', StrokeToFill);
initMetadataForInterface(VectorBuilder, 'VectorBuilder');
protoOf(VectorBuilder$transformed$1).qas = line;
protoOf(VectorBuilder$transformed$1).ras = arcTo;
protoOf(VectorBuilder$transformed$1).n1 = isEmpty;
protoOf(VectorBuilder$transformed$1).sas = rect;
protoOf(VectorBuilder$transformed$1).tas = rect_0;
protoOf(VectorBuilder$transformed$1).uas = rect_1;
protoOf(VectorBuilder$transformed$1).vas = roundRect;
protoOf(VectorBuilder$transformed$1).was = arc;
protoOf(VectorBuilder$transformed$1).xas = arc$default;
protoOf(VectorBuilder$transformed$1).oab = circle;
protoOf(VectorBuilder$transformed$1).yas = rMoveTo;
protoOf(VectorBuilder$transformed$1).zas = rLineTo;
protoOf(VectorBuilder$transformed$1).v9q = transformed;
initMetadataForClass(VectorBuilder$transformed$1, VOID, VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_12);
initMetadataForInterface(Visitor, 'Visitor');
protoOf(VectorPath).qas = line;
protoOf(VectorPath).ras = arcTo;
protoOf(VectorPath).n1 = isEmpty;
protoOf(VectorPath).o9j = isNotEmpty;
protoOf(VectorPath).sas = rect;
protoOf(VectorPath).tas = rect_0;
protoOf(VectorPath).uas = rect_1;
protoOf(VectorPath).vas = roundRect;
protoOf(VectorPath).aat = roundRect_0;
protoOf(VectorPath).was = arc;
protoOf(VectorPath).xas = arc$default;
protoOf(VectorPath).oab = circle;
protoOf(VectorPath).yas = rMoveTo;
protoOf(VectorPath).zas = rLineTo;
protoOf(VectorPath).v9q = transformed;
protoOf(VectorPath).bat = transformed_0;
initMetadataForClass(VectorPath, 'VectorPath', VectorPath, VOID, [VectorBuilder]);
initMetadataForClass(VectorPathTrapezoids, 'VectorPathTrapezoids');
protoOf(with$1).f7 = close;
protoOf(with$1).iah = lineTo;
protoOf(with$1).jah = quadTo_0;
protoOf(with$1).lah = cubicTo;
initMetadataForClass(with$1, VOID, VOID, VOID, [Visitor]);
initMetadataForCompanion(Companion_13);
initMetadataForClass(StrokeInfo, 'StrokeInfo', StrokeInfo);
initMetadataForCompanion(Companion_14);
initMetadataForClass(Winding, 'Winding');
initMetadataForClass(LineScaleMode, 'LineScaleMode');
initMetadataForCompanion(Companion_15);
initMetadataForClass(LineCap, 'LineCap');
initMetadataForCompanion(Companion_16);
initMetadataForClass(LineJoin, 'LineJoin');
initMetadataForCompanion(Companion_17);
initMetadataForClass(MMatrix, 'MMatrix', MMatrix);
initMetadataForCompanion(Companion_18);
protoOf(MPoint).m9f = isAlmostEquals$default;
initMetadataForClass(MPoint, 'MPoint', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_19);
protoOf(MRectangle).m9f = isAlmostEquals$default;
initMetadataForClass(MRectangle, 'MRectangle', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_20);
initMetadataForClass(MLine, 'MLine', MLine.tav);
protoOf(Easings).p9f = invoke;
protoOf(Easings).q9f = invoke_0;
initMetadataForClass(Easings, 'Easings', VOID, VOID, [Easing]);
initMetadataForClass(Easings$SMOOTH, 'SMOOTH');
initMetadataForClass(Easings$EASE_IN_ELASTIC, 'EASE_IN_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_ELASTIC, 'EASE_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_BOUNCE, 'EASE_OUT_BOUNCE');
initMetadataForClass(Easings$LINEAR, 'LINEAR');
initMetadataForClass(Easings$EASE, 'EASE');
initMetadataForClass(Easings$EASE_IN, 'EASE_IN');
initMetadataForClass(Easings$EASE_OUT, 'EASE_OUT');
initMetadataForClass(Easings$EASE_IN_OUT, 'EASE_IN_OUT');
initMetadataForClass(Easings$EASE_IN_OLD, 'EASE_IN_OLD');
initMetadataForClass(Easings$EASE_OUT_OLD, 'EASE_OUT_OLD');
initMetadataForClass(Easings$EASE_IN_OUT_OLD, 'EASE_IN_OUT_OLD');
initMetadataForClass(Easings$EASE_OUT_IN_OLD, 'EASE_OUT_IN_OLD');
initMetadataForClass(Easings$EASE_IN_BACK, 'EASE_IN_BACK');
initMetadataForClass(Easings$EASE_OUT_BACK, 'EASE_OUT_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_BACK, 'EASE_IN_OUT_BACK');
initMetadataForClass(Easings$EASE_OUT_IN_BACK, 'EASE_OUT_IN_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_ELASTIC, 'EASE_IN_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_IN_ELASTIC, 'EASE_OUT_IN_ELASTIC');
initMetadataForClass(Easings$EASE_IN_BOUNCE, 'EASE_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_OUT_BOUNCE, 'EASE_IN_OUT_BOUNCE');
initMetadataForClass(Easings$EASE_OUT_IN_BOUNCE, 'EASE_OUT_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_QUAD, 'EASE_IN_QUAD');
initMetadataForClass(Easings$EASE_OUT_QUAD, 'EASE_OUT_QUAD');
initMetadataForClass(Easings$EASE_IN_OUT_QUAD, 'EASE_IN_OUT_QUAD');
initMetadataForClass(Easings$EASE_SINE, 'EASE_SINE');
initMetadataForClass(Easings$EASE_CLAMP_START, 'EASE_CLAMP_START');
initMetadataForClass(Easings$EASE_CLAMP_END, 'EASE_CLAMP_END');
initMetadataForClass(Easings$EASE_CLAMP_MIDDLE, 'EASE_CLAMP_MIDDLE');
initMetadataForClass(P, 'P');
protoOf(EasingCubic).p9f = invoke;
protoOf(EasingCubic).q9f = invoke_0;
initMetadataForClass(EasingCubic, 'EasingCubic', VOID, VOID, [Easing]);
//endregion
//region block: init
Arc_instance = new Arc();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Convex_instance = new Convex();
Companion_instance_3 = new Companion_3();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
SegmentIntToTrapezoidIntList_instance = new SegmentIntToTrapezoidIntList();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
Companion_instance_12 = new Companion_12();
Companion_instance_13 = new Companion_13();
Companion_instance_14 = new Companion_14();
Companion_instance_15 = new Companion_15();
Companion_instance_16 = new Companion_16();
Companion_instance_20 = new Companion_20();
//endregion
//region block: exports
export {
  _SliceOrientation___get_flipX__impl__lgb7bx as _SliceOrientation___get_flipX__impl__lgb7bxpfrfmahmr1fq,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq34f1oadsx2p0,
  _SliceOrientation___get_rotation__impl__m65r0o as _SliceOrientation___get_rotation__impl__m65r0op3ryfmm1yyj,
  Companion_getInstance_8 as Companion_getInstance1wsp92tul7oln,
  Companion_instance_1 as Companion_instance13goiojaq0ush,
  Companion_instance_3 as Companion_instance18r9kjg2unqei,
  Companion_getInstance_14 as Companion_getInstance3seqq6212ijwe,
  Companion_getInstance_27 as Companion_getInstance3dt5vnr8lhijd,
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstanceao6xlizlaldg,
  HitTestDirection_ANY_getInstance as HitTestDirection_ANY_getInstance3eco03bn1ccpo,
  SliceRotation_R180_getInstance as SliceRotation_R180_getInstance85sagbi84b4q,
  LineCap_BUTT_getInstance as LineCap_BUTT_getInstance1x8jd0g8nody4,
  LineJoin_MITER_getInstance as LineJoin_MITER_getInstancenxlz621uxkch,
  LineScaleMode_NONE_getInstance as LineScaleMode_NONE_getInstance1f32tfs7crl87,
  LineScaleMode_NORMAL_getInstance as LineScaleMode_NORMAL_getInstance9o852ij0ybpr,
  Winding_EVEN_ODD_getInstance as Winding_EVEN_ODD_getInstance1rr1chty3mia4,
  Winding_NON_ZERO_getInstance as Winding_NON_ZERO_getInstance1fdn4b7o3qufp,
  arc$default as arc$default2ya7cpeqzuelq,
  ProjectedPoint as ProjectedPoint37gr1oedqap6n,
  Bezier as Bezier1nrnsph9esuxa,
  get_isConvex as get_isConvex3nm4n5empqw0n,
  toBezier as toBezier1cphbqwqpx0d3,
  toStrokePointsList as toStrokePointsList2dojuc3rfktd4,
  ImageDoNotFitException as ImageDoNotFitException2gm4q4wt4lh58,
  get_cachedPoints as get_cachedPoints16ehjcv6uuio1,
  getPoints2List as getPoints2List1zux0vi6zk0wt,
  toShape2D as toShape2D2vgft60vvvqgq,
  RectSlice as RectSlicec5msorw5q4el,
  SliceOrientation as SliceOrientation5szkqzxt7oev,
  PolygonScanline as PolygonScanline1ccjpk6mqxyxd,
  RastScale as RastScale3rcmuinujik1d,
  StrokeInfo as StrokeInfo1cunqczl43ffk,
  StrokeToFill as StrokeToFill127v8ehrppf9e,
  arcTo as arcTo1g4ivunekrrtg,
  arc as arc1vjl2w7wqv39k,
  circle as circle1t8rrxfrm1ku9,
  isEmpty as isEmpty3b7xkdp0by4c8,
  line as line3u2mk0n2uhnlh,
  rLineTo as rLineTo1671hm1vy9pme,
  rMoveTo as rMoveTo38ittbd8h3wn5,
  rect as rect1tyihxx4629c2,
  rect_0 as rect31bppuugx2wch,
  rect_1 as rect3nqbmqh4a4l2a,
  roundRect as roundRect2sqmspzw5002d,
  transformed as transformed2t6vo3srmaaf9,
  VectorBuilder as VectorBuilder2g8a28qau4ty9,
  VectorPath as VectorPath1chx1oqdw6sb9,
  applyTransform as applyTransform1vhqlmleb4dce,
  getCurves as getCurves2yjahbp68cxj3,
  plus_0 as plus1r33v70e4ipd7,
  strokeToFill_0 as strokeToFill34bvxzbc34djp,
  strokeToFill as strokeToFill2j5wye7yyxd99,
  toCurvesList as toCurvesList2ibv2opnrpohn,
  write as write11msa0gyjblqp,
  MMatrix as MMatrix1y71lv7vv6y8t,
  get_immutable as get_immutablepxpdoj6e54ll,
  get_mutable_0 as get_mutable10c8ws0x48eez,
  get_mutable as get_mutableqzgwrema46rx,
  toMatrix4 as toMatrix42ci5k1es0x1v1,
  get_EASE_IN as get_EASE_IN3dgilxucimnao,
  get_EASE_IN_OUT as get_EASE_IN_OUT1plt1ext4tf71,
  get_EASE_IN_OUT_QUAD as get_EASE_IN_OUT_QUAD21w3u6e1aoexb,
  get_EASE_OUT_QUAD as get_EASE_OUT_QUAD2mpgddt0aepte,
  interpolate_2 as interpolatekgpa594f7x8f,
  IntSegmentSet as IntSegmentSet3br6yjcm9q2bd,
};
//endregion
